(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire70da"];
var parcelRegister = parcelRequire.register;
parcelRegister("eplKH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CoinbaseWalletSDK = void 0;

var $e3afr = parcelRequire("e3afr");
module.exports.default = $e3afr.CoinbaseWalletSDK;

var $e3afr = parcelRequire("e3afr");
Object.defineProperty(module.exports, "CoinbaseWalletSDK", {
    enumerable: true,
    get: function get() {
        return $e3afr.CoinbaseWalletSDK;
    }
});

});
parcelRegister("e3afr", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
"use strict";
// Copyright (c) 2018-2024 Coinbase, Inc. <https://www.coinbase.com/>
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CoinbaseWalletSDK = void 0;

var $fXfWO = parcelRequire("fXfWO");

var $c7gMn = parcelRequire("c7gMn");

var $ao3Zq = parcelRequire("ao3Zq");

var $exvkr = parcelRequire("exvkr");

var $lBX3m = parcelRequire("lBX3m");

var $4IUJI = parcelRequire("4IUJI");
var $a3a94b8f9c912339$var$CoinbaseWalletSDK = /*#__PURE__*/ function() {
    function CoinbaseWalletSDK(metadata) {
        (0, $4GJKx._)(this, CoinbaseWalletSDK);
        this.metadata = {
            appName: metadata.appName || "Dapp",
            appLogoUrl: metadata.appLogoUrl || (0, $lBX3m.getFavicon)(),
            appChainIds: metadata.appChainIds || []
        };
        this.storeLatestVersion();
    }
    (0, $1wc17._)(CoinbaseWalletSDK, [
        {
            key: "makeWeb3Provider",
            value: function makeWeb3Provider() {
                var preference = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                    options: "all"
                };
                var _a;
                var params = {
                    metadata: this.metadata,
                    preference: preference
                };
                return (_a = (0, $4IUJI.getCoinbaseInjectedProvider)(params)) !== null && _a !== void 0 ? _a : new $c7gMn.CoinbaseWalletProvider(params);
            }
        },
        {
            /**
     * Official Coinbase Wallet logo for developers to use on their frontend
     * @param type Type of wallet logo: "standard" | "circle" | "text" | "textWithLogo" | "textLight" | "textWithLogoLight"
     * @param width Width of the logo (Optional)
     * @returns SVG Data URI
     */ key: "getCoinbaseWalletLogo",
            value: function getCoinbaseWalletLogo(type) {
                var width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 240;
                return (0, $fXfWO.walletLogo)(type, width);
            }
        },
        {
            key: "storeLatestVersion",
            value: function storeLatestVersion() {
                var versionStorage = new $ao3Zq.ScopedLocalStorage("CBWSDK");
                versionStorage.setItem("VERSION", $exvkr.LIB_VERSION);
            }
        }
    ]);
    return CoinbaseWalletSDK;
}();
module.exports.CoinbaseWalletSDK = $a3a94b8f9c912339$var$CoinbaseWalletSDK;

});
parcelRegister("fXfWO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.walletLogo = void 0;
var $b9d8bc8b7d9b7ecd$var$walletLogo = function(type, width) {
    var height;
    switch(type){
        case "standard":
            height = width;
            return "data:image/svg+xml,%3Csvg width='".concat(width, "' height='").concat(height, "' viewBox='0 0 1024 1024' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect width='1024' height='1024' fill='%230052FF'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M152 512C152 710.823 313.177 872 512 872C710.823 872 872 710.823 872 512C872 313.177 710.823 152 512 152C313.177 152 152 313.177 152 512ZM420 396C406.745 396 396 406.745 396 420V604C396 617.255 406.745 628 420 628H604C617.255 628 628 617.255 628 604V420C628 406.745 617.255 396 604 396H420Z' fill='white'/%3E %3C/svg%3E ");
        case "circle":
            height = width;
            return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='".concat(width, "' height='").concat(height, "' viewBox='0 0 999.81 999.81'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052fe;%7D.cls-2%7Bfill:%23fefefe;%7D.cls-3%7Bfill:%230152fe;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M655-115.9h56c.83,1.59,2.36.88,3.56,1a478,478,0,0,1,75.06,10.42C891.4-81.76,978.33-32.58,1049.19,44q116.7,126,131.94,297.61c.38,4.14-.34,8.53,1.78,12.45v59c-1.58.84-.91,2.35-1,3.56a482.05,482.05,0,0,1-10.38,74.05c-24,106.72-76.64,196.76-158.83,268.93s-178.18,112.82-287.2,122.6c-4.83.43-9.86-.25-14.51,1.77H654c-1-1.68-2.69-.91-4.06-1a496.89,496.89,0,0,1-105.9-18.59c-93.54-27.42-172.78-77.59-236.91-150.94Q199.34,590.1,184.87,426.58c-.47-5.19.25-10.56-1.77-15.59V355c1.68-1,.91-2.7,1-4.06a498.12,498.12,0,0,1,18.58-105.9c26-88.75,72.64-164.9,140.6-227.57q126-116.27,297.21-131.61C645.32-114.57,650.35-113.88,655-115.9Zm377.92,500c0-192.44-156.31-349.49-347.56-350.15-194.13-.68-350.94,155.13-352.29,347.42-1.37,194.55,155.51,352.1,348.56,352.47C876.15,734.23,1032.93,577.84,1032.93,384.11Z' transform='translate(-183.1 115.9)'/%3E%3Cpath class='cls-2' d='M1032.93,384.11c0,193.73-156.78,350.12-351.29,349.74-193-.37-349.93-157.92-348.56-352.47C334.43,189.09,491.24,33.28,685.37,34,876.62,34.62,1032.94,191.67,1032.93,384.11ZM683,496.81q43.74,0,87.48,0c15.55,0,25.32-9.72,25.33-25.21q0-87.48,0-175c0-15.83-9.68-25.46-25.59-25.46H595.77c-15.88,0-25.57,9.64-25.58,25.46q0,87.23,0,174.45c0,16.18,9.59,25.7,25.84,25.71Z' transform='translate(-183.1 115.9)'/%3E%3Cpath class='cls-3' d='M683,496.81H596c-16.25,0-25.84-9.53-25.84-25.71q0-87.23,0-174.45c0-15.82,9.7-25.46,25.58-25.46H770.22c15.91,0,25.59,9.63,25.59,25.46q0,87.47,0,175c0,15.49-9.78,25.2-25.33,25.21Q726.74,496.84,683,496.81Z' transform='translate(-183.1 115.9)'/%3E%3C/svg%3E");
        case "text":
            height = (0.1 * width).toFixed(2);
            return "data:image/svg+xml,%3Csvg width='".concat(width, "' height='").concat(height, "' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 528.15 53.64'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052ff;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3ECoinbase_Wordmark_SubBrands_ALL%3C/title%3E%3Cpath class='cls-1' d='M164.45,15a15,15,0,0,0-11.74,5.4V0h-8.64V52.92h8.5V48a15,15,0,0,0,11.88,5.62c10.37,0,18.21-8.21,18.21-19.3S174.67,15,164.45,15Zm-1.3,30.67c-6.19,0-10.73-4.83-10.73-11.31S157,23,163.22,23s10.66,4.82,10.66,11.37S169.34,45.65,163.15,45.65Zm83.31-14.91-6.34-.93c-3-.43-5.18-1.44-5.18-3.82,0-2.59,2.8-3.89,6.62-3.89,4.18,0,6.84,1.8,7.42,4.76h8.35c-.94-7.49-6.7-11.88-15.55-11.88-9.15,0-15.2,4.68-15.2,11.3,0,6.34,4,10,12,11.16l6.33.94c3.1.43,4.83,1.65,4.83,4,0,2.95-3,4.17-7.2,4.17-5.12,0-8-2.09-8.43-5.25h-8.49c.79,7.27,6.48,12.38,16.84,12.38,9.44,0,15.7-4.32,15.7-11.74C258.12,35.28,253.58,31.82,246.46,30.74Zm-27.65-2.3c0-8.06-4.9-13.46-15.27-13.46-9.79,0-15.26,5-16.34,12.6h8.57c.43-3,2.73-5.4,7.63-5.4,4.39,0,6.55,1.94,6.55,4.32,0,3.09-4,3.88-8.85,4.39-6.63.72-14.84,3-14.84,11.66,0,6.7,5,11,12.89,11,6.19,0,10.08-2.59,12-6.7.28,3.67,3,6.05,6.84,6.05h5v-7.7h-4.25Zm-8.5,9.36c0,5-4.32,8.64-9.57,8.64-3.24,0-6-1.37-6-4.25,0-3.67,4.39-4.68,8.42-5.11s6-1.22,7.13-2.88ZM281.09,15c-11.09,0-19.23,8.35-19.23,19.36,0,11.6,8.72,19.3,19.37,19.3,9,0,16.06-5.33,17.86-12.89h-9c-1.3,3.31-4.47,5.19-8.71,5.19-5.55,0-9.72-3.46-10.66-9.51H299.3V33.12C299.3,22.46,291.53,15,281.09,15Zm-9.87,15.26c1.37-5.18,5.26-7.7,9.72-7.7,4.9,0,8.64,2.8,9.51,7.7ZM19.3,23a9.84,9.84,0,0,1,9.5,7h9.14c-1.65-8.93-9-15-18.57-15A19,19,0,0,0,0,34.34c0,11.09,8.28,19.3,19.37,19.3,9.36,0,16.85-6,18.5-15H28.8a9.75,9.75,0,0,1-9.43,7.06c-6.27,0-10.66-4.83-10.66-11.31S13,23,19.3,23Zm41.11-8A19,19,0,0,0,41,34.34c0,11.09,8.28,19.3,19.37,19.3A19,19,0,0,0,79.92,34.27C79.92,23.33,71.64,15,60.41,15Zm.07,30.67c-6.19,0-10.73-4.83-10.73-11.31S54.22,23,60.41,23s10.8,4.89,10.8,11.37S66.67,45.65,60.48,45.65ZM123.41,15c-5.62,0-9.29,2.3-11.45,5.54V15.7h-8.57V52.92H112V32.69C112,27,115.63,23,121,23c5,0,8.06,3.53,8.06,8.64V52.92h8.64V31C137.66,21.6,132.84,15,123.41,15ZM92,.36a5.36,5.36,0,0,0-5.55,5.47,5.55,5.55,0,0,0,11.09,0A5.35,5.35,0,0,0,92,.36Zm-9.72,23h5.4V52.92h8.64V15.7h-14Zm298.17-7.7L366.2,52.92H372L375.29,44H392l3.33,8.88h6L386.87,15.7ZM377,39.23l6.45-17.56h.1l6.56,17.56ZM362.66,15.7l-7.88,29h-.11l-8.14-29H341l-8,28.93h-.1l-8-28.87H319L329.82,53h5.45l8.19-29.24h.11L352,53h5.66L368.1,15.7Zm135.25,0v4.86h12.32V52.92h5.6V20.56h12.32V15.7ZM467.82,52.92h25.54V48.06H473.43v-12h18.35V31.35H473.43V20.56h19.93V15.7H467.82ZM443,15.7h-5.6V52.92h24.32V48.06H443Zm-30.45,0h-5.61V52.92h24.32V48.06H412.52Z'/%3E%3C/svg%3E");
        case "textWithLogo":
            height = (0.25 * width).toFixed(2);
            return "data:image/svg+xml,%3Csvg width='".concat(width, "' height='").concat(height, "' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 308.44 77.61'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052ff;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M142.94,20.2l-7.88,29H135l-8.15-29h-5.55l-8,28.93h-.11l-8-28.87H99.27l10.84,37.27h5.44l8.2-29.24h.1l8.41,29.24h5.66L148.39,20.2Zm17.82,0L146.48,57.42h5.82l3.28-8.88h16.65l3.34,8.88h6L167.16,20.2Zm-3.44,23.52,6.45-17.55h.11l6.56,17.55ZM278.2,20.2v4.86h12.32V57.42h5.6V25.06h12.32V20.2ZM248.11,57.42h25.54V52.55H253.71V40.61h18.35V35.85H253.71V25.06h19.94V20.2H248.11ZM223.26,20.2h-5.61V57.42H242V52.55H223.26Zm-30.46,0h-5.6V57.42h24.32V52.55H192.8Zm-154,38A19.41,19.41,0,1,1,57.92,35.57H77.47a38.81,38.81,0,1,0,0,6.47H57.92A19.39,19.39,0,0,1,38.81,58.21Z'/%3E%3C/svg%3E");
        case "textLight":
            height = (0.1 * width).toFixed(2);
            return "data:image/svg+xml,%3Csvg width='".concat(width, "' height='").concat(height, "' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 528.15 53.64'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fefefe;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3ECoinbase_Wordmark_SubBrands_ALL%3C/title%3E%3Cpath class='cls-1' d='M164.45,15a15,15,0,0,0-11.74,5.4V0h-8.64V52.92h8.5V48a15,15,0,0,0,11.88,5.62c10.37,0,18.21-8.21,18.21-19.3S174.67,15,164.45,15Zm-1.3,30.67c-6.19,0-10.73-4.83-10.73-11.31S157,23,163.22,23s10.66,4.82,10.66,11.37S169.34,45.65,163.15,45.65Zm83.31-14.91-6.34-.93c-3-.43-5.18-1.44-5.18-3.82,0-2.59,2.8-3.89,6.62-3.89,4.18,0,6.84,1.8,7.42,4.76h8.35c-.94-7.49-6.7-11.88-15.55-11.88-9.15,0-15.2,4.68-15.2,11.3,0,6.34,4,10,12,11.16l6.33.94c3.1.43,4.83,1.65,4.83,4,0,2.95-3,4.17-7.2,4.17-5.12,0-8-2.09-8.43-5.25h-8.49c.79,7.27,6.48,12.38,16.84,12.38,9.44,0,15.7-4.32,15.7-11.74C258.12,35.28,253.58,31.82,246.46,30.74Zm-27.65-2.3c0-8.06-4.9-13.46-15.27-13.46-9.79,0-15.26,5-16.34,12.6h8.57c.43-3,2.73-5.4,7.63-5.4,4.39,0,6.55,1.94,6.55,4.32,0,3.09-4,3.88-8.85,4.39-6.63.72-14.84,3-14.84,11.66,0,6.7,5,11,12.89,11,6.19,0,10.08-2.59,12-6.7.28,3.67,3,6.05,6.84,6.05h5v-7.7h-4.25Zm-8.5,9.36c0,5-4.32,8.64-9.57,8.64-3.24,0-6-1.37-6-4.25,0-3.67,4.39-4.68,8.42-5.11s6-1.22,7.13-2.88ZM281.09,15c-11.09,0-19.23,8.35-19.23,19.36,0,11.6,8.72,19.3,19.37,19.3,9,0,16.06-5.33,17.86-12.89h-9c-1.3,3.31-4.47,5.19-8.71,5.19-5.55,0-9.72-3.46-10.66-9.51H299.3V33.12C299.3,22.46,291.53,15,281.09,15Zm-9.87,15.26c1.37-5.18,5.26-7.7,9.72-7.7,4.9,0,8.64,2.8,9.51,7.7ZM19.3,23a9.84,9.84,0,0,1,9.5,7h9.14c-1.65-8.93-9-15-18.57-15A19,19,0,0,0,0,34.34c0,11.09,8.28,19.3,19.37,19.3,9.36,0,16.85-6,18.5-15H28.8a9.75,9.75,0,0,1-9.43,7.06c-6.27,0-10.66-4.83-10.66-11.31S13,23,19.3,23Zm41.11-8A19,19,0,0,0,41,34.34c0,11.09,8.28,19.3,19.37,19.3A19,19,0,0,0,79.92,34.27C79.92,23.33,71.64,15,60.41,15Zm.07,30.67c-6.19,0-10.73-4.83-10.73-11.31S54.22,23,60.41,23s10.8,4.89,10.8,11.37S66.67,45.65,60.48,45.65ZM123.41,15c-5.62,0-9.29,2.3-11.45,5.54V15.7h-8.57V52.92H112V32.69C112,27,115.63,23,121,23c5,0,8.06,3.53,8.06,8.64V52.92h8.64V31C137.66,21.6,132.84,15,123.41,15ZM92,.36a5.36,5.36,0,0,0-5.55,5.47,5.55,5.55,0,0,0,11.09,0A5.35,5.35,0,0,0,92,.36Zm-9.72,23h5.4V52.92h8.64V15.7h-14Zm298.17-7.7L366.2,52.92H372L375.29,44H392l3.33,8.88h6L386.87,15.7ZM377,39.23l6.45-17.56h.1l6.56,17.56ZM362.66,15.7l-7.88,29h-.11l-8.14-29H341l-8,28.93h-.1l-8-28.87H319L329.82,53h5.45l8.19-29.24h.11L352,53h5.66L368.1,15.7Zm135.25,0v4.86h12.32V52.92h5.6V20.56h12.32V15.7ZM467.82,52.92h25.54V48.06H473.43v-12h18.35V31.35H473.43V20.56h19.93V15.7H467.82ZM443,15.7h-5.6V52.92h24.32V48.06H443Zm-30.45,0h-5.61V52.92h24.32V48.06H412.52Z'/%3E%3C/svg%3E");
        case "textWithLogoLight":
            height = (0.25 * width).toFixed(2);
            return "data:image/svg+xml,%3Csvg width='".concat(width, "' height='").concat(height, "' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 308.44 77.61'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fefefe;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M142.94,20.2l-7.88,29H135l-8.15-29h-5.55l-8,28.93h-.11l-8-28.87H99.27l10.84,37.27h5.44l8.2-29.24h.1l8.41,29.24h5.66L148.39,20.2Zm17.82,0L146.48,57.42h5.82l3.28-8.88h16.65l3.34,8.88h6L167.16,20.2Zm-3.44,23.52,6.45-17.55h.11l6.56,17.55ZM278.2,20.2v4.86h12.32V57.42h5.6V25.06h12.32V20.2ZM248.11,57.42h25.54V52.55H253.71V40.61h18.35V35.85H253.71V25.06h19.94V20.2H248.11ZM223.26,20.2h-5.61V57.42H242V52.55H223.26Zm-30.46,0h-5.6V57.42h24.32V52.55H192.8Zm-154,38A19.41,19.41,0,1,1,57.92,35.57H77.47a38.81,38.81,0,1,0,0,6.47H57.92A19.39,19.39,0,0,1,38.81,58.21Z'/%3E%3C/svg%3E");
        default:
            height = width;
            return "data:image/svg+xml,%3Csvg width='".concat(width, "' height='").concat(height, "' viewBox='0 0 1024 1024' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect width='1024' height='1024' fill='%230052FF'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M152 512C152 710.823 313.177 872 512 872C710.823 872 872 710.823 872 512C872 313.177 710.823 152 512 152C313.177 152 152 313.177 152 512ZM420 396C406.745 396 396 406.745 396 420V604C396 617.255 406.745 628 420 628H604C617.255 628 628 617.255 628 604V420C628 406.745 617.255 396 604 396H420Z' fill='white'/%3E %3C/svg%3E ");
    }
};
module.exports.walletLogo = $b9d8bc8b7d9b7ecd$var$walletLogo;

});

parcelRegister("c7gMn", function(module, exports) {

var $d3H5E = parcelRequire("d3H5E");

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
"use strict";
var $8d23277ec776752e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8d23277ec776752e$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CoinbaseWalletProvider = void 0;

var $8d23277ec776752e$var$eventemitter3_1 = $8d23277ec776752e$var$__importDefault((parcelRequire("bCGfB")));

var $gBAGR = parcelRequire("gBAGR");

var $3jsDf = parcelRequire("3jsDf");

var $8JTtR = parcelRequire("8JTtR");

var $lBX3m = parcelRequire("lBX3m");

var $3lUOZ = parcelRequire("3lUOZ");

var $4IUJI = parcelRequire("4IUJI");

var $9Nfx7 = parcelRequire("9Nfx7");

var $fvyQt = parcelRequire("fvyQt");

var $ao3Zq = parcelRequire("ao3Zq");
var $8d23277ec776752e$var$CoinbaseWalletProvider = /*#__PURE__*/ function(_eventemitter3_1_default) {
    (0, $dcsZi._)(CoinbaseWalletProvider, _eventemitter3_1_default);
    var _super = (0, $ohfOJ._)(CoinbaseWalletProvider);
    function CoinbaseWalletProvider(_a) {
        (0, $4GJKx._)(this, CoinbaseWalletProvider);
        var _this;
        var _b, _c;
        var metadata = _a.metadata, _d = _a.preference, keysUrl = _d.keysUrl, preference = $8d23277ec776752e$var$__rest(_d, [
            "keysUrl"
        ]);
        _this = _super.call(this);
        _this.accounts = [];
        var _this1 = (0, $d3H5E._)(_this);
        var _this2 = (0, $d3H5E._)(_this);
        _this.handlers = {
            // eth_requestAccounts
            handshake: function() {
                var _ref = (0, $kSuI9._)(function(_) {
                    var signerType, signer, accounts, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                if (_this1.connected) {
                                    _this1.emit("connect", {
                                        chainId: (0, $lBX3m.hexStringFromIntNumber)((0, $8JTtR.IntNumber)(_this1.chain.id))
                                    });
                                    return [
                                        2,
                                        _this1.accounts
                                    ];
                                }
                                return [
                                    4,
                                    _this1.requestSignerSelection()
                                ];
                            case 1:
                                signerType = _state.sent();
                                signer = _this1.initSigner(signerType);
                                return [
                                    4,
                                    signer.handshake()
                                ];
                            case 2:
                                accounts = _state.sent();
                                _this1.signer = signer;
                                (0, $3lUOZ.storeSignerType)(signerType);
                                _this1.emit("connect", {
                                    chainId: (0, $lBX3m.hexStringFromIntNumber)((0, $8JTtR.IntNumber)(_this1.chain.id))
                                });
                                return [
                                    2,
                                    accounts
                                ];
                            case 3:
                                error = _state.sent();
                                _this1.handleUnauthorizedError(error);
                                throw error;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }(),
            sign: function() {
                var _ref = (0, $kSuI9._)(function(request) {
                    var error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this2.connected || !_this2.signer) throw $gBAGR.standardErrors.provider.unauthorized("Must call 'eth_requestAccounts' before other methods");
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this2.signer.request(request)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                error = _state.sent();
                                _this2.handleUnauthorizedError(error);
                                throw error;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(request) {
                    return _ref.apply(this, arguments);
                };
            }(),
            fetch: function(request) {
                return (0, $4IUJI.fetchRPCRequest)(request, _this.chain);
            },
            state: function(request) {
                var getConnectedAccounts = function() {
                    if (_this.connected) return _this.accounts;
                    throw $gBAGR.standardErrors.provider.unauthorized("Must call 'eth_requestAccounts' before other methods");
                };
                switch(request.method){
                    case "eth_chainId":
                        return (0, $lBX3m.hexStringFromIntNumber)((0, $8JTtR.IntNumber)(_this.chain.id));
                    case "net_version":
                        return _this.chain.id;
                    case "eth_accounts":
                        return getConnectedAccounts();
                    case "eth_coinbase":
                        return getConnectedAccounts()[0];
                    default:
                        return _this.handlers.unsupported(request);
                }
            },
            deprecated: function(param) {
                var method = param.method;
                throw $gBAGR.standardErrors.rpc.methodNotSupported("Method ".concat(method, " is deprecated."));
            },
            unsupported: function(param) {
                var method = param.method;
                throw $gBAGR.standardErrors.rpc.methodNotSupported("Method ".concat(method, " is not supported."));
            }
        };
        _this.isCoinbaseWallet = true;
        _this.updateListener = {
            onAccountsUpdate: function(param) {
                var accounts = param.accounts, source = param.source;
                if ((0, $lBX3m.areAddressArraysEqual)(_this.accounts, accounts)) return;
                _this.accounts = accounts;
                if (source === "storage") return;
                _this.emit("accountsChanged", _this.accounts);
            },
            onChainUpdate: function(param) {
                var chain = param.chain, source = param.source;
                if (chain.id === _this.chain.id && chain.rpcUrl === _this.chain.rpcUrl) return;
                _this.chain = chain;
                if (source === "storage") return;
                _this.emit("chainChanged", (0, $lBX3m.hexStringFromIntNumber)((0, $8JTtR.IntNumber)(chain.id)));
            }
        };
        _this.metadata = metadata;
        _this.preference = preference;
        _this.communicator = new $9Nfx7.Communicator(keysUrl);
        _this.chain = {
            id: (_c = (_b = metadata.appChainIds) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : 1
        };
        // Load states from storage
        var signerType = (0, $3lUOZ.loadSignerType)();
        _this.signer = signerType ? _this.initSigner(signerType) : null;
        return _this;
    }
    (0, $1wc17._)(CoinbaseWalletProvider, [
        {
            key: "connected",
            get: function get() {
                return this.accounts.length > 0;
            }
        },
        {
            key: "request",
            value: function request(args) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _a, invalidArgsError, category;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        try {
                            invalidArgsError = (0, $4IUJI.checkErrorForInvalidRequestArgs)(args);
                            if (invalidArgsError) throw invalidArgsError;
                            // unrecognized methods are treated as fetch requests
                            category = (_a = (0, $fvyQt.determineMethodCategory)(args.method)) !== null && _a !== void 0 ? _a : "fetch";
                            return [
                                2,
                                _this.handlers[category](args)
                            ];
                        } catch (error) {
                            return [
                                2,
                                Promise.reject((0, $3jsDf.serializeError)(error, args.method))
                            ];
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "handleUnauthorizedError",
            value: function handleUnauthorizedError(error) {
                var e = error;
                if (e.code === $gBAGR.standardErrorCodes.provider.unauthorized) this.disconnect();
            }
        },
        {
            key: "enable",
            value: /** @deprecated Use `.request({ method: 'eth_requestAccounts' })` instead. */ function enable() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                console.warn('.enable() has been deprecated. Please use .request({ method: "eth_requestAccounts" }) instead.');
                                return [
                                    4,
                                    _this.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        _this.accounts = [];
                        _this.chain = {
                            id: 1
                        };
                        $ao3Zq.ScopedLocalStorage.clearAll();
                        _this.emit("disconnect", $gBAGR.standardErrors.provider.disconnected("User initiated disconnection"));
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "requestSignerSelection",
            value: function requestSignerSelection() {
                return (0, $3lUOZ.fetchSignerType)({
                    communicator: this.communicator,
                    preference: this.preference,
                    metadata: this.metadata
                });
            }
        },
        {
            key: "initSigner",
            value: function initSigner(signerType) {
                return (0, $3lUOZ.createSigner)({
                    signerType: signerType,
                    metadata: this.metadata,
                    communicator: this.communicator,
                    updateListener: this.updateListener
                });
            }
        }
    ]);
    return CoinbaseWalletProvider;
}($8d23277ec776752e$var$eventemitter3_1.default);
module.exports.CoinbaseWalletProvider = $8d23277ec776752e$var$CoinbaseWalletProvider;

});
parcelRegister("bCGfB", function(module, exports) {
"use strict";
var $8764047110a2bd71$var$has = Object.prototype.hasOwnProperty, $8764047110a2bd71$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $8764047110a2bd71$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $8764047110a2bd71$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $8764047110a2bd71$var$Events().__proto__) $8764047110a2bd71$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $8764047110a2bd71$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $8764047110a2bd71$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $8764047110a2bd71$var$EE(fn, context || emitter, once), evt = $8764047110a2bd71$var$prefix ? $8764047110a2bd71$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $8764047110a2bd71$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $8764047110a2bd71$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $8764047110a2bd71$var$EventEmitter() {
    this._events = new $8764047110a2bd71$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $8764047110a2bd71$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($8764047110a2bd71$var$has.call(events, name)) names.push($8764047110a2bd71$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $8764047110a2bd71$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $8764047110a2bd71$var$prefix ? $8764047110a2bd71$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $8764047110a2bd71$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $8764047110a2bd71$var$prefix ? $8764047110a2bd71$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $8764047110a2bd71$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $8764047110a2bd71$var$prefix ? $8764047110a2bd71$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $8764047110a2bd71$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $8764047110a2bd71$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $8764047110a2bd71$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $8764047110a2bd71$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $8764047110a2bd71$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $8764047110a2bd71$var$prefix ? $8764047110a2bd71$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $8764047110a2bd71$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $8764047110a2bd71$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $8764047110a2bd71$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $8764047110a2bd71$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $8764047110a2bd71$var$prefix ? $8764047110a2bd71$var$prefix + event : event;
        if (this._events[evt]) $8764047110a2bd71$var$clearEvent(this, evt);
    } else {
        this._events = new $8764047110a2bd71$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$8764047110a2bd71$var$EventEmitter.prototype.off = $8764047110a2bd71$var$EventEmitter.prototype.removeListener;
$8764047110a2bd71$var$EventEmitter.prototype.addListener = $8764047110a2bd71$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$8764047110a2bd71$var$EventEmitter.prefixed = $8764047110a2bd71$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$8764047110a2bd71$var$EventEmitter.EventEmitter = $8764047110a2bd71$var$EventEmitter;
module.exports = $8764047110a2bd71$var$EventEmitter;

});

parcelRegister("gBAGR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.standardErrors = module.exports.standardErrorCodes = void 0;

var $h4Ifg = parcelRequire("h4Ifg");
Object.defineProperty(module.exports, "standardErrorCodes", {
    enumerable: true,
    get: function get() {
        return $h4Ifg.standardErrorCodes;
    }
});

var $f1VfL = parcelRequire("f1VfL");
Object.defineProperty(module.exports, "standardErrors", {
    enumerable: true,
    get: function get() {
        return $f1VfL.standardErrors;
    }
});

});
parcelRegister("h4Ifg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.errorValues = module.exports.standardErrorCodes = void 0;
module.exports.standardErrorCodes = {
    rpc: {
        invalidInput: -32000,
        resourceNotFound: -32001,
        resourceUnavailable: -32002,
        transactionRejected: -32003,
        methodNotSupported: -32004,
        limitExceeded: -32005,
        parse: -32700,
        invalidRequest: -32600,
        methodNotFound: -32601,
        invalidParams: -32602,
        internal: -32603
    },
    provider: {
        userRejectedRequest: 4001,
        unauthorized: 4100,
        unsupportedMethod: 4200,
        disconnected: 4900,
        chainDisconnected: 4901,
        unsupportedChain: 4902
    }
};
module.exports.errorValues = {
    "-32700": {
        standard: "JSON RPC 2.0",
        message: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
    },
    "-32600": {
        standard: "JSON RPC 2.0",
        message: "The JSON sent is not a valid Request object."
    },
    "-32601": {
        standard: "JSON RPC 2.0",
        message: "The method does not exist / is not available."
    },
    "-32602": {
        standard: "JSON RPC 2.0",
        message: "Invalid method parameter(s)."
    },
    "-32603": {
        standard: "JSON RPC 2.0",
        message: "Internal JSON-RPC error."
    },
    "-32000": {
        standard: "EIP-1474",
        message: "Invalid input."
    },
    "-32001": {
        standard: "EIP-1474",
        message: "Resource not found."
    },
    "-32002": {
        standard: "EIP-1474",
        message: "Resource unavailable."
    },
    "-32003": {
        standard: "EIP-1474",
        message: "Transaction rejected."
    },
    "-32004": {
        standard: "EIP-1474",
        message: "Method not supported."
    },
    "-32005": {
        standard: "EIP-1474",
        message: "Request limit exceeded."
    },
    "4001": {
        standard: "EIP-1193",
        message: "User rejected the request."
    },
    "4100": {
        standard: "EIP-1193",
        message: "The requested account and/or method has not been authorized by the user."
    },
    "4200": {
        standard: "EIP-1193",
        message: "The requested method is not supported by this Ethereum provider."
    },
    "4900": {
        standard: "EIP-1193",
        message: "The provider is disconnected from all chains."
    },
    "4901": {
        standard: "EIP-1193",
        message: "The provider is disconnected from the specified chain."
    },
    "4902": {
        standard: "EIP-3085",
        message: "Unrecognized chain ID."
    }
};

});

parcelRegister("f1VfL", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $cv9Rk = parcelRequire("cv9Rk");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.standardErrors = void 0;

var $h4Ifg = parcelRequire("h4Ifg");

var $f441N = parcelRequire("f441N");
module.exports.standardErrors = {
    rpc: {
        parse: function(arg) {
            return $af135c515b3a9caa$var$getEthJsonRpcError($h4Ifg.standardErrorCodes.rpc.parse, arg);
        },
        invalidRequest: function(arg) {
            return $af135c515b3a9caa$var$getEthJsonRpcError($h4Ifg.standardErrorCodes.rpc.invalidRequest, arg);
        },
        invalidParams: function(arg) {
            return $af135c515b3a9caa$var$getEthJsonRpcError($h4Ifg.standardErrorCodes.rpc.invalidParams, arg);
        },
        methodNotFound: function(arg) {
            return $af135c515b3a9caa$var$getEthJsonRpcError($h4Ifg.standardErrorCodes.rpc.methodNotFound, arg);
        },
        internal: function(arg) {
            return $af135c515b3a9caa$var$getEthJsonRpcError($h4Ifg.standardErrorCodes.rpc.internal, arg);
        },
        server: function(opts) {
            if (!opts || typeof opts !== "object" || Array.isArray(opts)) throw new Error("Ethereum RPC Server errors must provide single object argument.");
            var code = opts.code;
            if (!Number.isInteger(code) || code > -32005 || code < -32099) throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');
            return $af135c515b3a9caa$var$getEthJsonRpcError(code, opts);
        },
        invalidInput: function(arg) {
            return $af135c515b3a9caa$var$getEthJsonRpcError($h4Ifg.standardErrorCodes.rpc.invalidInput, arg);
        },
        resourceNotFound: function(arg) {
            return $af135c515b3a9caa$var$getEthJsonRpcError($h4Ifg.standardErrorCodes.rpc.resourceNotFound, arg);
        },
        resourceUnavailable: function(arg) {
            return $af135c515b3a9caa$var$getEthJsonRpcError($h4Ifg.standardErrorCodes.rpc.resourceUnavailable, arg);
        },
        transactionRejected: function(arg) {
            return $af135c515b3a9caa$var$getEthJsonRpcError($h4Ifg.standardErrorCodes.rpc.transactionRejected, arg);
        },
        methodNotSupported: function(arg) {
            return $af135c515b3a9caa$var$getEthJsonRpcError($h4Ifg.standardErrorCodes.rpc.methodNotSupported, arg);
        },
        limitExceeded: function(arg) {
            return $af135c515b3a9caa$var$getEthJsonRpcError($h4Ifg.standardErrorCodes.rpc.limitExceeded, arg);
        }
    },
    provider: {
        userRejectedRequest: function(arg) {
            return $af135c515b3a9caa$var$getEthProviderError($h4Ifg.standardErrorCodes.provider.userRejectedRequest, arg);
        },
        unauthorized: function(arg) {
            return $af135c515b3a9caa$var$getEthProviderError($h4Ifg.standardErrorCodes.provider.unauthorized, arg);
        },
        unsupportedMethod: function(arg) {
            return $af135c515b3a9caa$var$getEthProviderError($h4Ifg.standardErrorCodes.provider.unsupportedMethod, arg);
        },
        disconnected: function(arg) {
            return $af135c515b3a9caa$var$getEthProviderError($h4Ifg.standardErrorCodes.provider.disconnected, arg);
        },
        chainDisconnected: function(arg) {
            return $af135c515b3a9caa$var$getEthProviderError($h4Ifg.standardErrorCodes.provider.chainDisconnected, arg);
        },
        unsupportedChain: function(arg) {
            return $af135c515b3a9caa$var$getEthProviderError($h4Ifg.standardErrorCodes.provider.unsupportedChain, arg);
        },
        custom: function(opts) {
            if (!opts || typeof opts !== "object" || Array.isArray(opts)) throw new Error("Ethereum Provider custom errors must provide single object argument.");
            var code = opts.code, message = opts.message, data = opts.data;
            if (!message || typeof message !== "string") throw new Error('"message" must be a nonempty string');
            return new $af135c515b3a9caa$var$EthereumProviderError(code, message, data);
        }
    }
};
// Internal
function $af135c515b3a9caa$var$getEthJsonRpcError(code, arg) {
    var _parseOpts = (0, $cv9Rk._)($af135c515b3a9caa$var$parseOpts(arg), 2), message = _parseOpts[0], data = _parseOpts[1];
    return new $af135c515b3a9caa$var$EthereumRpcError(code, message || (0, $f441N.getMessageFromCode)(code), data);
}
function $af135c515b3a9caa$var$getEthProviderError(code, arg) {
    var _parseOpts = (0, $cv9Rk._)($af135c515b3a9caa$var$parseOpts(arg), 2), message = _parseOpts[0], data = _parseOpts[1];
    return new $af135c515b3a9caa$var$EthereumProviderError(code, message || (0, $f441N.getMessageFromCode)(code), data);
}
function $af135c515b3a9caa$var$parseOpts(arg) {
    if (arg) {
        if (typeof arg === "string") return [
            arg
        ];
        else if (typeof arg === "object" && !Array.isArray(arg)) {
            var message = arg.message, data = arg.data;
            if (message && typeof message !== "string") throw new Error("Must specify string message.");
            return [
                message || undefined,
                data
            ];
        }
    }
    return [];
}
var $af135c515b3a9caa$var$EthereumRpcError = /*#__PURE__*/ function(Error1) {
    (0, $dcsZi._)(EthereumRpcError, Error1);
    var _super = (0, $ohfOJ._)(EthereumRpcError);
    function EthereumRpcError(code, message, data) {
        (0, $4GJKx._)(this, EthereumRpcError);
        var _this;
        if (!Number.isInteger(code)) throw new Error('"code" must be an integer.');
        if (!message || typeof message !== "string") throw new Error('"message" must be a nonempty string.');
        _this = _super.call(this, message);
        _this.code = code;
        if (data !== undefined) _this.data = data;
        return _this;
    }
    return EthereumRpcError;
}((0, $FuVm8._)(Error));
var $af135c515b3a9caa$var$EthereumProviderError = /*#__PURE__*/ function(EthereumRpcError) {
    (0, $dcsZi._)(EthereumProviderError, EthereumRpcError);
    var _super = (0, $ohfOJ._)(EthereumProviderError);
    function EthereumProviderError(code, message, data) {
        (0, $4GJKx._)(this, EthereumProviderError);
        if (!$af135c515b3a9caa$var$isValidEthProviderCode(code)) throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
        return _super.call(this, code, message, data);
    }
    return EthereumProviderError;
}($af135c515b3a9caa$var$EthereumRpcError);
function $af135c515b3a9caa$var$isValidEthProviderCode(code) {
    return Number.isInteger(code) && code >= 1000 && code <= 4999;
}

});
parcelRegister("f441N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.serialize = module.exports.getErrorCode = module.exports.isValidCode = module.exports.getMessageFromCode = module.exports.JSON_RPC_SERVER_ERROR_MESSAGE = void 0;

var $h4Ifg = parcelRequire("h4Ifg");
var $af7a5a9e7b06a98b$var$FALLBACK_MESSAGE = "Unspecified error message.";
module.exports.JSON_RPC_SERVER_ERROR_MESSAGE = "Unspecified server error.";
/**
 * Gets the message for a given code, or a fallback message if the code has
 * no corresponding message.
 */ function $af7a5a9e7b06a98b$var$getMessageFromCode(code) {
    var fallbackMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $af7a5a9e7b06a98b$var$FALLBACK_MESSAGE;
    if (code && Number.isInteger(code)) {
        var codeString = code.toString();
        if ($af7a5a9e7b06a98b$var$hasKey($h4Ifg.errorValues, codeString)) return $h4Ifg.errorValues[codeString].message;
        if ($af7a5a9e7b06a98b$var$isJsonRpcServerError(code)) return module.exports.JSON_RPC_SERVER_ERROR_MESSAGE;
    }
    return fallbackMessage;
}
module.exports.getMessageFromCode = $af7a5a9e7b06a98b$var$getMessageFromCode;
/**
 * Returns whether the given code is valid.
 * A code is only valid if it has a message.
 */ function $af7a5a9e7b06a98b$var$isValidCode(code) {
    if (!Number.isInteger(code)) return false;
    var codeString = code.toString();
    if ($h4Ifg.errorValues[codeString]) return true;
    if ($af7a5a9e7b06a98b$var$isJsonRpcServerError(code)) return true;
    return false;
}
module.exports.isValidCode = $af7a5a9e7b06a98b$var$isValidCode;
/**
 * Returns the error code from an error object.
 */ function $af7a5a9e7b06a98b$var$getErrorCode(error) {
    var _a;
    if (typeof error === "number") return error;
    else if ($af7a5a9e7b06a98b$var$isErrorWithCode(error)) return (_a = error.code) !== null && _a !== void 0 ? _a : error.errorCode;
    return undefined;
}
module.exports.getErrorCode = $af7a5a9e7b06a98b$var$getErrorCode;
function $af7a5a9e7b06a98b$var$isErrorWithCode(error) {
    return typeof error === "object" && error !== null && (typeof error.code === "number" || typeof error.errorCode === "number");
}
function $af7a5a9e7b06a98b$var$serialize(error) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_shouldIncludeStack = _ref.shouldIncludeStack, shouldIncludeStack = _ref_shouldIncludeStack === void 0 ? false : _ref_shouldIncludeStack;
    var serialized = {};
    if (error && typeof error === "object" && !Array.isArray(error) && $af7a5a9e7b06a98b$var$hasKey(error, "code") && $af7a5a9e7b06a98b$var$isValidCode(error.code)) {
        var _error = error;
        serialized.code = _error.code;
        if (_error.message && typeof _error.message === "string") {
            serialized.message = _error.message;
            if ($af7a5a9e7b06a98b$var$hasKey(_error, "data")) serialized.data = _error.data;
        } else {
            serialized.message = $af7a5a9e7b06a98b$var$getMessageFromCode(serialized.code);
            serialized.data = {
                originalError: $af7a5a9e7b06a98b$var$assignOriginalError(error)
            };
        }
    } else {
        serialized.code = $h4Ifg.standardErrorCodes.rpc.internal;
        serialized.message = $af7a5a9e7b06a98b$var$hasStringProperty(error, "message") ? error.message : $af7a5a9e7b06a98b$var$FALLBACK_MESSAGE;
        serialized.data = {
            originalError: $af7a5a9e7b06a98b$var$assignOriginalError(error)
        };
    }
    if (shouldIncludeStack) serialized.stack = $af7a5a9e7b06a98b$var$hasStringProperty(error, "stack") ? error.stack : undefined;
    return serialized;
}
module.exports.serialize = $af7a5a9e7b06a98b$var$serialize;
// Internal
function $af7a5a9e7b06a98b$var$isJsonRpcServerError(code) {
    return code >= -32099 && code <= -32000;
}
function $af7a5a9e7b06a98b$var$assignOriginalError(error) {
    if (error && typeof error === "object" && !Array.isArray(error)) return Object.assign({}, error);
    return error;
}
function $af7a5a9e7b06a98b$var$hasKey(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $af7a5a9e7b06a98b$var$hasStringProperty(obj, prop) {
    return typeof obj === "object" && obj !== null && prop in obj && typeof obj[prop] === "string";
}

});



parcelRegister("3jsDf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.serializeError = void 0;

var $cJCoI = parcelRequire("cJCoI");

var $exvkr = parcelRequire("exvkr");

var $h4Ifg = parcelRequire("h4Ifg");

var $f441N = parcelRequire("f441N");
/**
 * Serializes an error to a format that is compatible with the Ethereum JSON RPC error format.
 * See https://docs.cloud.coinbase.com/wallet-sdk/docs/errors
 * for more information.
 */ function $26995b2e3737096f$var$serializeError(error, requestOrMethod) {
    var serialized = (0, $f441N.serialize)($26995b2e3737096f$var$getErrorObject(error), {
        shouldIncludeStack: true
    });
    var docUrl = new URL("https://docs.cloud.coinbase.com/wallet-sdk/docs/errors");
    docUrl.searchParams.set("version", $exvkr.LIB_VERSION);
    docUrl.searchParams.set("code", serialized.code.toString());
    var method = $26995b2e3737096f$var$getMethod(serialized.data, requestOrMethod);
    if (method) docUrl.searchParams.set("method", method);
    docUrl.searchParams.set("message", serialized.message);
    return Object.assign(Object.assign({}, serialized), {
        docUrl: docUrl.href
    });
}
module.exports.serializeError = $26995b2e3737096f$var$serializeError;
/**
 * Converts an error to a serializable object.
 */ function $26995b2e3737096f$var$getErrorObject(error) {
    if (typeof error === "string") return {
        message: error,
        code: $h4Ifg.standardErrorCodes.rpc.internal
    };
    else if ((0, $cJCoI.isErrorResponse)(error)) return Object.assign(Object.assign({}, error), {
        message: error.errorMessage,
        code: error.errorCode,
        data: {
            method: error.method
        }
    });
    return error;
}
/**
 * Gets the method name from the serialized data or the request.
 */ function $26995b2e3737096f$var$getMethod(serializedData, request) {
    var methodInData = serializedData === null || serializedData === void 0 ? void 0 : serializedData.method;
    if (methodInData) return methodInData;
    if (request === undefined) return undefined;
    else if (typeof request === "string") return request;
    else if (!Array.isArray(request)) return request.method;
    else if (request.length > 0) return request[0].method;
    return undefined;
}

});
parcelRegister("cJCoI", function(module, exports) {
"use strict";
// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isErrorResponse = void 0;
function $945778fdf945eb67$var$isErrorResponse(response) {
    return response.errorMessage !== undefined;
}
module.exports.isErrorResponse = $945778fdf945eb67$var$isErrorResponse;

});

parcelRegister("exvkr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LIB_VERSION = void 0;
module.exports.LIB_VERSION = "4.0.4";

});


parcelRegister("8JTtR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RegExpString = module.exports.IntNumber = module.exports.BigIntString = module.exports.AddressString = module.exports.HexString = module.exports.OpaqueType = void 0;
function $65cd8ff87b3c052b$var$OpaqueType() {
    return function(value) {
        return value;
    };
}
module.exports.OpaqueType = $65cd8ff87b3c052b$var$OpaqueType;
module.exports.HexString = $65cd8ff87b3c052b$var$OpaqueType();
module.exports.AddressString = $65cd8ff87b3c052b$var$OpaqueType();
module.exports.BigIntString = $65cd8ff87b3c052b$var$OpaqueType();
function $65cd8ff87b3c052b$var$IntNumber(num) {
    return Math.floor(num);
}
module.exports.IntNumber = $65cd8ff87b3c052b$var$IntNumber;
module.exports.RegExpString = $65cd8ff87b3c052b$var$OpaqueType();

});

parcelRegister("lBX3m", function(module, exports) {

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $8dlmd = parcelRequire("8dlmd");
var $fbbadc6fcadffce6$require$Buffer = $8dlmd.Buffer;
"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */ // Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.areAddressArraysEqual = module.exports.getFavicon = module.exports.range = module.exports.isBigNumber = module.exports.ensureParsedJSONObject = module.exports.ensureBigInt = module.exports.ensureRegExpString = module.exports.ensureIntNumber = module.exports.ensureBuffer = module.exports.ensureAddressString = module.exports.ensureEvenLengthHexString = module.exports.ensureHexString = module.exports.isHexString = module.exports.prepend0x = module.exports.strip0x = module.exports.has0xPrefix = module.exports.hexStringFromIntNumber = module.exports.intNumberFromHexString = module.exports.bigIntStringFromBigInt = module.exports.hexStringFromBuffer = module.exports.hexStringToUint8Array = module.exports.uint8ArrayToHex = module.exports.randomBytesHex = void 0;

var $gBAGR = parcelRequire("gBAGR");

var $8JTtR = parcelRequire("8JTtR");
var $fbbadc6fcadffce6$var$INT_STRING_REGEX = /^[0-9]*$/;
var $fbbadc6fcadffce6$var$HEXADECIMAL_STRING_REGEX = /^[a-f0-9]*$/;
/**
 * @param length number of bytes
 */ function $fbbadc6fcadffce6$var$randomBytesHex(length) {
    return $fbbadc6fcadffce6$var$uint8ArrayToHex(crypto.getRandomValues(new Uint8Array(length)));
}
module.exports.randomBytesHex = $fbbadc6fcadffce6$var$randomBytesHex;
function $fbbadc6fcadffce6$var$uint8ArrayToHex(value) {
    return (0, $c6Xmf._)(value).map(function(b) {
        return b.toString(16).padStart(2, "0");
    }).join("");
}
module.exports.uint8ArrayToHex = $fbbadc6fcadffce6$var$uint8ArrayToHex;
function $fbbadc6fcadffce6$var$hexStringToUint8Array(hexString) {
    return new Uint8Array(hexString.match(/.{1,2}/g).map(function(byte) {
        return parseInt(byte, 16);
    }));
}
module.exports.hexStringToUint8Array = $fbbadc6fcadffce6$var$hexStringToUint8Array;
function $fbbadc6fcadffce6$var$hexStringFromBuffer(buf) {
    var includePrefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var hex = buf.toString("hex");
    return (0, $8JTtR.HexString)(includePrefix ? "0x".concat(hex) : hex);
}
module.exports.hexStringFromBuffer = $fbbadc6fcadffce6$var$hexStringFromBuffer;
function $fbbadc6fcadffce6$var$bigIntStringFromBigInt(bi) {
    return (0, $8JTtR.BigIntString)(bi.toString(10));
}
module.exports.bigIntStringFromBigInt = $fbbadc6fcadffce6$var$bigIntStringFromBigInt;
function $fbbadc6fcadffce6$var$intNumberFromHexString(hex) {
    return (0, $8JTtR.IntNumber)(Number(BigInt($fbbadc6fcadffce6$var$ensureEvenLengthHexString(hex, true))));
}
module.exports.intNumberFromHexString = $fbbadc6fcadffce6$var$intNumberFromHexString;
function $fbbadc6fcadffce6$var$hexStringFromIntNumber(num) {
    return (0, $8JTtR.HexString)("0x".concat(BigInt(num).toString(16)));
}
module.exports.hexStringFromIntNumber = $fbbadc6fcadffce6$var$hexStringFromIntNumber;
function $fbbadc6fcadffce6$var$has0xPrefix(str) {
    return str.startsWith("0x") || str.startsWith("0X");
}
module.exports.has0xPrefix = $fbbadc6fcadffce6$var$has0xPrefix;
function $fbbadc6fcadffce6$var$strip0x(hex) {
    if ($fbbadc6fcadffce6$var$has0xPrefix(hex)) return hex.slice(2);
    return hex;
}
module.exports.strip0x = $fbbadc6fcadffce6$var$strip0x;
function $fbbadc6fcadffce6$var$prepend0x(hex) {
    if ($fbbadc6fcadffce6$var$has0xPrefix(hex)) return "0x".concat(hex.slice(2));
    return "0x".concat(hex);
}
module.exports.prepend0x = $fbbadc6fcadffce6$var$prepend0x;
function $fbbadc6fcadffce6$var$isHexString(hex) {
    if (typeof hex !== "string") return false;
    var s = $fbbadc6fcadffce6$var$strip0x(hex).toLowerCase();
    return $fbbadc6fcadffce6$var$HEXADECIMAL_STRING_REGEX.test(s);
}
module.exports.isHexString = $fbbadc6fcadffce6$var$isHexString;
function $fbbadc6fcadffce6$var$ensureHexString(hex) {
    var includePrefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (typeof hex === "string") {
        var s = $fbbadc6fcadffce6$var$strip0x(hex).toLowerCase();
        if ($fbbadc6fcadffce6$var$HEXADECIMAL_STRING_REGEX.test(s)) return (0, $8JTtR.HexString)(includePrefix ? "0x".concat(s) : s);
    }
    throw $gBAGR.standardErrors.rpc.invalidParams('"'.concat(String(hex), '" is not a hexadecimal string'));
}
module.exports.ensureHexString = $fbbadc6fcadffce6$var$ensureHexString;
function $fbbadc6fcadffce6$var$ensureEvenLengthHexString(hex) {
    var includePrefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var h = $fbbadc6fcadffce6$var$ensureHexString(hex, false);
    if (h.length % 2 === 1) h = (0, $8JTtR.HexString)("0".concat(h));
    return includePrefix ? (0, $8JTtR.HexString)("0x".concat(h)) : h;
}
module.exports.ensureEvenLengthHexString = $fbbadc6fcadffce6$var$ensureEvenLengthHexString;
function $fbbadc6fcadffce6$var$ensureAddressString(str) {
    if (typeof str === "string") {
        var s = $fbbadc6fcadffce6$var$strip0x(str).toLowerCase();
        if ($fbbadc6fcadffce6$var$isHexString(s) && s.length === 40) return (0, $8JTtR.AddressString)($fbbadc6fcadffce6$var$prepend0x(s));
    }
    throw $gBAGR.standardErrors.rpc.invalidParams("Invalid Ethereum address: ".concat(String(str)));
}
module.exports.ensureAddressString = $fbbadc6fcadffce6$var$ensureAddressString;
function $fbbadc6fcadffce6$var$ensureBuffer(str) {
    if ($fbbadc6fcadffce6$require$Buffer.isBuffer(str)) return str;
    if (typeof str === "string") {
        if ($fbbadc6fcadffce6$var$isHexString(str)) {
            var s = $fbbadc6fcadffce6$var$ensureEvenLengthHexString(str, false);
            return $fbbadc6fcadffce6$require$Buffer.from(s, "hex");
        }
        return $fbbadc6fcadffce6$require$Buffer.from(str, "utf8");
    }
    throw $gBAGR.standardErrors.rpc.invalidParams("Not binary data: ".concat(String(str)));
}
module.exports.ensureBuffer = $fbbadc6fcadffce6$var$ensureBuffer;
function $fbbadc6fcadffce6$var$ensureIntNumber(num) {
    if (typeof num === "number" && Number.isInteger(num)) return (0, $8JTtR.IntNumber)(num);
    if (typeof num === "string") {
        if ($fbbadc6fcadffce6$var$INT_STRING_REGEX.test(num)) return (0, $8JTtR.IntNumber)(Number(num));
        if ($fbbadc6fcadffce6$var$isHexString(num)) return (0, $8JTtR.IntNumber)(Number(BigInt($fbbadc6fcadffce6$var$ensureEvenLengthHexString(num, true))));
    }
    throw $gBAGR.standardErrors.rpc.invalidParams("Not an integer: ".concat(String(num)));
}
module.exports.ensureIntNumber = $fbbadc6fcadffce6$var$ensureIntNumber;
function $fbbadc6fcadffce6$var$ensureRegExpString(regExp) {
    if (regExp instanceof RegExp) return (0, $8JTtR.RegExpString)(regExp.toString());
    throw $gBAGR.standardErrors.rpc.invalidParams("Not a RegExp: ".concat(String(regExp)));
}
module.exports.ensureRegExpString = $fbbadc6fcadffce6$var$ensureRegExpString;
function $fbbadc6fcadffce6$var$ensureBigInt(val) {
    if (val !== null && ((typeof val === "undefined" ? "undefined" : (0, $l0HdX._)(val)) === "bigint" || $fbbadc6fcadffce6$var$isBigNumber(val))) return BigInt(val.toString(10));
    if (typeof val === "number") return BigInt($fbbadc6fcadffce6$var$ensureIntNumber(val));
    if (typeof val === "string") {
        if ($fbbadc6fcadffce6$var$INT_STRING_REGEX.test(val)) return BigInt(val);
        if ($fbbadc6fcadffce6$var$isHexString(val)) return BigInt($fbbadc6fcadffce6$var$ensureEvenLengthHexString(val, true));
    }
    throw $gBAGR.standardErrors.rpc.invalidParams("Not an integer: ".concat(String(val)));
}
module.exports.ensureBigInt = $fbbadc6fcadffce6$var$ensureBigInt;
function $fbbadc6fcadffce6$var$ensureParsedJSONObject(val) {
    if (typeof val === "string") return JSON.parse(val);
    if (typeof val === "object") return val;
    throw $gBAGR.standardErrors.rpc.invalidParams("Not a JSON string or an object: ".concat(String(val)));
}
module.exports.ensureParsedJSONObject = $fbbadc6fcadffce6$var$ensureParsedJSONObject;
function $fbbadc6fcadffce6$var$isBigNumber(val) {
    if (val == null || typeof val.constructor !== "function") return false;
    var constructor = val.constructor;
    return typeof constructor.config === "function" && typeof constructor.EUCLID === "number";
}
module.exports.isBigNumber = $fbbadc6fcadffce6$var$isBigNumber;
function $fbbadc6fcadffce6$var$range(start, stop) {
    return Array.from({
        length: stop - start
    }, function(_, i) {
        return start + i;
    });
}
module.exports.range = $fbbadc6fcadffce6$var$range;
function $fbbadc6fcadffce6$var$getFavicon() {
    var el = document.querySelector('link[sizes="192x192"]') || document.querySelector('link[sizes="180x180"]') || document.querySelector('link[rel="icon"]') || document.querySelector('link[rel="shortcut icon"]');
    var _document_location = document.location, protocol = _document_location.protocol, host = _document_location.host;
    var href = el ? el.getAttribute("href") : null;
    if (!href || href.startsWith("javascript:") || href.startsWith("vbscript:")) return null;
    if (href.startsWith("http://") || href.startsWith("https://") || href.startsWith("data:")) return href;
    if (href.startsWith("//")) return protocol + href;
    return "".concat(protocol, "//").concat(host).concat(href);
}
module.exports.getFavicon = $fbbadc6fcadffce6$var$getFavicon;
function $fbbadc6fcadffce6$var$areAddressArraysEqual(arr1, arr2) {
    return arr1.length === arr2.length && arr1.every(function(value, index) {
        return value === arr2[index];
    });
}
module.exports.areAddressArraysEqual = $fbbadc6fcadffce6$var$areAddressArraysEqual;

});

parcelRegister("3lUOZ", function(module, exports) {

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSigner = module.exports.fetchSignerType = module.exports.storeSignerType = module.exports.loadSignerType = void 0;

var $2H2n8 = parcelRequire("2H2n8");

var $dDmpc = parcelRequire("dDmpc");

var $gBAGR = parcelRequire("gBAGR");

var $4IUJI = parcelRequire("4IUJI");

var $ao3Zq = parcelRequire("ao3Zq");
var $270f68cd520e2c6a$var$SIGNER_TYPE_KEY = "SignerType";
var $270f68cd520e2c6a$var$storage = new $ao3Zq.ScopedLocalStorage("CBWSDK", "SignerConfigurator");
function $270f68cd520e2c6a$var$loadSignerType() {
    return $270f68cd520e2c6a$var$storage.getItem($270f68cd520e2c6a$var$SIGNER_TYPE_KEY);
}
module.exports.loadSignerType = $270f68cd520e2c6a$var$loadSignerType;
function $270f68cd520e2c6a$var$storeSignerType(signerType) {
    $270f68cd520e2c6a$var$storage.setItem($270f68cd520e2c6a$var$SIGNER_TYPE_KEY, signerType);
}
module.exports.storeSignerType = $270f68cd520e2c6a$var$storeSignerType;
function $270f68cd520e2c6a$var$fetchSignerType(params) {
    return $270f68cd520e2c6a$var$_fetchSignerType.apply(this, arguments);
}
function $270f68cd520e2c6a$var$_fetchSignerType() {
    $270f68cd520e2c6a$var$_fetchSignerType = (0, $kSuI9._)(function(params) {
        var communicator, metadata, request, data;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    communicator = params.communicator, metadata = params.metadata;
                    $270f68cd520e2c6a$var$listenForWalletLinkSessionRequest(communicator, metadata).catch(function() {});
                    request = {
                        id: crypto.randomUUID(),
                        event: "selectSignerType",
                        data: params.preference
                    };
                    return [
                        4,
                        communicator.postRequestAndWaitForResponse(request)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return $270f68cd520e2c6a$var$_fetchSignerType.apply(this, arguments);
}
module.exports.fetchSignerType = $270f68cd520e2c6a$var$fetchSignerType;
function $270f68cd520e2c6a$var$createSigner(params) {
    var signerType = params.signerType, metadata = params.metadata, communicator = params.communicator, updateListener = params.updateListener;
    switch(signerType){
        case "scw":
            return new $2H2n8.SCWSigner({
                metadata: metadata,
                updateListener: updateListener,
                communicator: communicator
            });
        case "walletlink":
            return new $dDmpc.WalletLinkSigner({
                metadata: metadata,
                updateListener: updateListener
            });
        case "extension":
            {
                var injectedSigner = (0, $4IUJI.getCoinbaseInjectedSigner)();
                if (!injectedSigner) throw $gBAGR.standardErrors.rpc.internal("injected signer not found");
                return injectedSigner;
            }
    }
}
module.exports.createSigner = $270f68cd520e2c6a$var$createSigner;
function $270f68cd520e2c6a$var$listenForWalletLinkSessionRequest(communicator, metadata) {
    return $270f68cd520e2c6a$var$_listenForWalletLinkSessionRequest.apply(this, arguments);
}
function $270f68cd520e2c6a$var$_listenForWalletLinkSessionRequest() {
    $270f68cd520e2c6a$var$_listenForWalletLinkSessionRequest = (0, $kSuI9._)(function(communicator, metadata) {
        var walletlink;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        communicator.onMessage(function(param) {
                            var event = param.event;
                            return event === "WalletLinkSessionRequest";
                        })
                    ];
                case 1:
                    _state.sent();
                    // temporary walletlink signer instance to handle WalletLinkSessionRequest
                    // will revisit this when refactoring the walletlink signer
                    walletlink = new $dDmpc.WalletLinkSigner({
                        metadata: metadata
                    });
                    // send wallet link session to popup
                    communicator.postMessage({
                        event: "WalletLinkUpdate",
                        data: {
                            session: walletlink.getSession()
                        }
                    });
                    // wait for handshake to complete
                    return [
                        4,
                        walletlink.handshake()
                    ];
                case 2:
                    _state.sent();
                    // send connected status to popup
                    communicator.postMessage({
                        event: "WalletLinkUpdate",
                        data: {
                            connected: true
                        }
                    });
                    return [
                        2
                    ];
            }
        });
    });
    return $270f68cd520e2c6a$var$_listenForWalletLinkSessionRequest.apply(this, arguments);
}

});
parcelRegister("2H2n8", function(module, exports) {

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $eha6O = parcelRequire("eha6O");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCWSigner = void 0;

var $9mvFg = parcelRequire("9mvFg");

var $5Zh1y = parcelRequire("5Zh1y");

var $gBAGR = parcelRequire("gBAGR");

var $lBX3m = parcelRequire("lBX3m");

var $73wyl = parcelRequire("73wyl");
var $1f616ffe8d63ea6d$var$SCWSigner = /*#__PURE__*/ function() {
    function SCWSigner(params) {
        (0, $4GJKx._)(this, SCWSigner);
        this.metadata = params.metadata;
        this.communicator = params.communicator;
        this.keyManager = new $9mvFg.SCWKeyManager();
        this.stateManager = new $5Zh1y.SCWStateManager({
            appChainIds: this.metadata.appChainIds,
            updateListener: params.updateListener
        });
        this.handshake = this.handshake.bind(this);
        this.request = this.request.bind(this);
        this.createRequestMessage = this.createRequestMessage.bind(this);
        this.decryptResponseMessage = this.decryptResponseMessage.bind(this);
    }
    (0, $1wc17._)(SCWSigner, [
        {
            key: "handshake",
            value: function handshake() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var handshakeMessage, response, peerPublicKey, decrypted, result;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.createRequestMessage({
                                        handshake: {
                                            method: "eth_requestAccounts",
                                            params: _this.metadata
                                        }
                                    })
                                ];
                            case 1:
                                handshakeMessage = _state.sent();
                                return [
                                    4,
                                    _this.communicator.postRequestAndWaitForResponse(handshakeMessage)
                                ];
                            case 2:
                                response = _state.sent();
                                // store peer's public key
                                if ("failure" in response.content) throw response.content.failure;
                                return [
                                    4,
                                    (0, $73wyl.importKeyFromHexString)("public", response.sender)
                                ];
                            case 3:
                                peerPublicKey = _state.sent();
                                return [
                                    4,
                                    _this.keyManager.setPeerPublicKey(peerPublicKey)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    _this.decryptResponseMessage(response)
                                ];
                            case 5:
                                decrypted = _state.sent();
                                _this.updateInternalState({
                                    method: "eth_requestAccounts"
                                }, decrypted);
                                result = decrypted.result;
                                if ("error" in result) throw result.error;
                                return [
                                    2,
                                    _this.stateManager.accounts
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "request",
            value: function request(request) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var localResult, response, decrypted, result;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                localResult = _this.tryLocalHandling(request);
                                if (localResult !== undefined) {
                                    if (localResult instanceof Error) throw localResult;
                                    return [
                                        2,
                                        localResult
                                    ];
                                }
                                // Open the popup before constructing the request message.
                                // This is to ensure that the popup is not blocked by some browsers (i.e. Safari)
                                return [
                                    4,
                                    _this.communicator.waitForPopupLoaded()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.sendEncryptedRequest(request)
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    _this.decryptResponseMessage(response)
                                ];
                            case 3:
                                decrypted = _state.sent();
                                _this.updateInternalState(request, decrypted);
                                result = decrypted.result;
                                if ("error" in result) throw result.error;
                                return [
                                    2,
                                    result.value
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.stateManager.clear();
                                return [
                                    4,
                                    _this.keyManager.clear()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "tryLocalHandling",
            value: function tryLocalHandling(request) {
                var _a;
                switch(request.method){
                    case "wallet_switchEthereumChain":
                        {
                            var params = request.params;
                            if (!params || !((_a = params[0]) === null || _a === void 0 ? void 0 : _a.chainId)) throw $gBAGR.standardErrors.rpc.invalidParams();
                            var chainId = (0, $lBX3m.ensureIntNumber)(params[0].chainId);
                            var switched = this.stateManager.switchChain(chainId);
                            // "return null if the request was successful"
                            // https://eips.ethereum.org/EIPS/eip-3326#wallet_switchethereumchain
                            return switched ? null : undefined;
                        }
                    case "wallet_getCapabilities":
                        {
                            var walletCapabilities = this.stateManager.walletCapabilities;
                            if (!walletCapabilities) // This should never be the case for scw connections as capabilities are set during handshake
                            throw $gBAGR.standardErrors.provider.unauthorized("No wallet capabilities found, please disconnect and reconnect");
                            return walletCapabilities;
                        }
                    default:
                        return undefined;
                }
            }
        },
        {
            key: "sendEncryptedRequest",
            value: function sendEncryptedRequest(request) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var sharedSecret, encrypted, message;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.keyManager.getSharedSecret()
                                ];
                            case 1:
                                sharedSecret = _state.sent();
                                if (!sharedSecret) throw $gBAGR.standardErrors.provider.unauthorized("No valid session found, try requestAccounts before other methods");
                                return [
                                    4,
                                    (0, $73wyl.encryptContent)({
                                        action: request,
                                        chainId: _this.stateManager.activeChain.id
                                    }, sharedSecret)
                                ];
                            case 2:
                                encrypted = _state.sent();
                                return [
                                    4,
                                    _this.createRequestMessage({
                                        encrypted: encrypted
                                    })
                                ];
                            case 3:
                                message = _state.sent();
                                return [
                                    2,
                                    _this.communicator.postRequestAndWaitForResponse(message)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createRequestMessage",
            value: function createRequestMessage(content) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var publicKey, _, _tmp;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = (0, $73wyl.exportKeyToHexString);
                                _tmp = [
                                    "public"
                                ];
                                return [
                                    4,
                                    _this.keyManager.getOwnPublicKey()
                                ];
                            case 1:
                                return [
                                    4,
                                    _.apply(void 0, _tmp.concat([
                                        _state.sent()
                                    ]))
                                ];
                            case 2:
                                publicKey = _state.sent();
                                return [
                                    2,
                                    {
                                        id: crypto.randomUUID(),
                                        sender: publicKey,
                                        content: content,
                                        timestamp: new Date()
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "decryptResponseMessage",
            value: function decryptResponseMessage(message) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var content, sharedSecret;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                content = message.content;
                                // throw protocol level error
                                if ("failure" in content) throw content.failure;
                                return [
                                    4,
                                    _this.keyManager.getSharedSecret()
                                ];
                            case 1:
                                sharedSecret = _state.sent();
                                if (!sharedSecret) throw $gBAGR.standardErrors.provider.unauthorized("Invalid session");
                                return [
                                    2,
                                    (0, $73wyl.decryptContent)(content.encrypted, sharedSecret)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateInternalState",
            value: function updateInternalState(request, response) {
                var _a, _b;
                var availableChains = (_a = response.data) === null || _a === void 0 ? void 0 : _a.chains;
                if (availableChains) this.stateManager.updateAvailableChains(availableChains);
                var walletCapabilities = (_b = response.data) === null || _b === void 0 ? void 0 : _b.capabilities;
                if (walletCapabilities) this.stateManager.updateWalletCapabilities(walletCapabilities);
                var result = response.result;
                if ("error" in result) return;
                switch(request.method){
                    case "eth_requestAccounts":
                        {
                            var accounts = result.value;
                            this.stateManager.updateAccounts(accounts);
                            break;
                        }
                    case "wallet_switchEthereumChain":
                        {
                            // "return null if the request was successful"
                            // https://eips.ethereum.org/EIPS/eip-3326#wallet_switchethereumchain
                            if (result.value !== null) return;
                            var params = request.params;
                            var chainId = (0, $lBX3m.ensureIntNumber)(params[0].chainId);
                            this.stateManager.switchChain(chainId);
                            break;
                        }
                    default:
                        break;
                }
            }
        }
    ]);
    return SCWSigner;
}();
module.exports.SCWSigner = $1f616ffe8d63ea6d$var$SCWSigner;

});
parcelRegister("9mvFg", function(module, exports) {

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $eha6O = parcelRequire("eha6O");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCWKeyManager = void 0;

var $73wyl = parcelRequire("73wyl");

var $ao3Zq = parcelRequire("ao3Zq");
var $6d0ebb0968f3b526$var$OWN_PRIVATE_KEY = {
    storageKey: "ownPrivateKey",
    keyType: "private"
};
var $6d0ebb0968f3b526$var$OWN_PUBLIC_KEY = {
    storageKey: "ownPublicKey",
    keyType: "public"
};
var $6d0ebb0968f3b526$var$PEER_PUBLIC_KEY = {
    storageKey: "peerPublicKey",
    keyType: "public"
};
var $6d0ebb0968f3b526$var$SCWKeyManager = /*#__PURE__*/ function() {
    function SCWKeyManager() {
        (0, $4GJKx._)(this, SCWKeyManager);
        this.storage = new $ao3Zq.ScopedLocalStorage("CBWSDK", "SCWKeyManager");
        this.ownPrivateKey = null;
        this.ownPublicKey = null;
        this.peerPublicKey = null;
        this.sharedSecret = null;
    }
    (0, $1wc17._)(SCWKeyManager, [
        {
            key: "getOwnPublicKey",
            value: function getOwnPublicKey() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.loadKeysIfNeeded()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this.ownPublicKey
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSharedSecret",
            value: // returns null if the shared secret is not yet derived
            function getSharedSecret() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.loadKeysIfNeeded()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this.sharedSecret
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setPeerPublicKey",
            value: function setPeerPublicKey(key) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.sharedSecret = null;
                                _this.peerPublicKey = key;
                                return [
                                    4,
                                    _this.storeKey($6d0ebb0968f3b526$var$PEER_PUBLIC_KEY, key)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.loadKeysIfNeeded()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        _this.ownPrivateKey = null;
                        _this.ownPublicKey = null;
                        _this.peerPublicKey = null;
                        _this.sharedSecret = null;
                        _this.storage.removeItem($6d0ebb0968f3b526$var$OWN_PUBLIC_KEY.storageKey);
                        _this.storage.removeItem($6d0ebb0968f3b526$var$OWN_PRIVATE_KEY.storageKey);
                        _this.storage.removeItem($6d0ebb0968f3b526$var$PEER_PUBLIC_KEY.storageKey);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "generateKeyPair",
            value: function generateKeyPair() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var newKeyPair;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $73wyl.generateKeyPair)()
                                ];
                            case 1:
                                newKeyPair = _state.sent();
                                _this.ownPrivateKey = newKeyPair.privateKey;
                                _this.ownPublicKey = newKeyPair.publicKey;
                                return [
                                    4,
                                    _this.storeKey($6d0ebb0968f3b526$var$OWN_PRIVATE_KEY, newKeyPair.privateKey)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    _this.storeKey($6d0ebb0968f3b526$var$OWN_PUBLIC_KEY, newKeyPair.publicKey)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "loadKeysIfNeeded",
            value: function loadKeysIfNeeded() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this.ownPrivateKey === null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.loadKey($6d0ebb0968f3b526$var$OWN_PRIVATE_KEY)
                                ];
                            case 1:
                                _this.ownPrivateKey = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (!(_this.ownPublicKey === null)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.loadKey($6d0ebb0968f3b526$var$OWN_PUBLIC_KEY)
                                ];
                            case 3:
                                _this.ownPublicKey = _state.sent();
                                _state.label = 4;
                            case 4:
                                if (!(_this.ownPrivateKey === null || _this.ownPublicKey === null)) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    _this.generateKeyPair()
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                if (!(_this.peerPublicKey === null)) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    _this.loadKey($6d0ebb0968f3b526$var$PEER_PUBLIC_KEY)
                                ];
                            case 7:
                                _this.peerPublicKey = _state.sent();
                                _state.label = 8;
                            case 8:
                                if (!(_this.sharedSecret === null)) return [
                                    3,
                                    10
                                ];
                                if (_this.ownPrivateKey === null || _this.peerPublicKey === null) return [
                                    2
                                ];
                                return [
                                    4,
                                    (0, $73wyl.deriveSharedSecret)(_this.ownPrivateKey, _this.peerPublicKey)
                                ];
                            case 9:
                                _this.sharedSecret = _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "loadKey",
            value: // storage methods
            function loadKey(item) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var key;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        key = _this.storage.getItem(item.storageKey);
                        if (!key) return [
                            2,
                            null
                        ];
                        return [
                            2,
                            (0, $73wyl.importKeyFromHexString)(item.keyType, key)
                        ];
                    });
                })();
            }
        },
        {
            key: "storeKey",
            value: function storeKey(item, key) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var hexString;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $73wyl.exportKeyToHexString)(item.keyType, key)
                                ];
                            case 1:
                                hexString = _state.sent();
                                _this.storage.setItem(item.storageKey, hexString);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return SCWKeyManager;
}();
module.exports.SCWKeyManager = $6d0ebb0968f3b526$var$SCWKeyManager;

});
parcelRegister("73wyl", function(module, exports) {

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decryptContent = module.exports.encryptContent = module.exports.importKeyFromHexString = module.exports.exportKeyToHexString = module.exports.decrypt = module.exports.encrypt = module.exports.deriveSharedSecret = module.exports.generateKeyPair = void 0;

var $lBX3m = parcelRequire("lBX3m");
function $52321092cf7642b2$var$generateKeyPair() {
    return $52321092cf7642b2$var$_generateKeyPair.apply(this, arguments);
}
function $52321092cf7642b2$var$_generateKeyPair() {
    $52321092cf7642b2$var$_generateKeyPair = (0, $kSuI9._)(function() {
        return (0, $eha6O.__generator)(this, function(_state) {
            return [
                2,
                crypto.subtle.generateKey({
                    name: "ECDH",
                    namedCurve: "P-256"
                }, true, [
                    "deriveKey"
                ])
            ];
        });
    });
    return $52321092cf7642b2$var$_generateKeyPair.apply(this, arguments);
}
module.exports.generateKeyPair = $52321092cf7642b2$var$generateKeyPair;
function $52321092cf7642b2$var$deriveSharedSecret(ownPrivateKey, peerPublicKey) {
    return $52321092cf7642b2$var$_deriveSharedSecret.apply(this, arguments);
}
function $52321092cf7642b2$var$_deriveSharedSecret() {
    $52321092cf7642b2$var$_deriveSharedSecret = (0, $kSuI9._)(function(ownPrivateKey, peerPublicKey) {
        return (0, $eha6O.__generator)(this, function(_state) {
            return [
                2,
                crypto.subtle.deriveKey({
                    name: "ECDH",
                    public: peerPublicKey
                }, ownPrivateKey, {
                    name: "AES-GCM",
                    length: 256
                }, false, [
                    "encrypt",
                    "decrypt"
                ])
            ];
        });
    });
    return $52321092cf7642b2$var$_deriveSharedSecret.apply(this, arguments);
}
module.exports.deriveSharedSecret = $52321092cf7642b2$var$deriveSharedSecret;
function $52321092cf7642b2$var$encrypt(sharedSecret, plainText) {
    return $52321092cf7642b2$var$_encrypt.apply(this, arguments);
}
function $52321092cf7642b2$var$_encrypt() {
    $52321092cf7642b2$var$_encrypt = (0, $kSuI9._)(function(sharedSecret, plainText) {
        var iv, cipherText;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    iv = crypto.getRandomValues(new Uint8Array(12));
                    return [
                        4,
                        crypto.subtle.encrypt({
                            name: "AES-GCM",
                            iv: iv
                        }, sharedSecret, new TextEncoder().encode(plainText))
                    ];
                case 1:
                    cipherText = _state.sent();
                    return [
                        2,
                        {
                            iv: iv,
                            cipherText: cipherText
                        }
                    ];
            }
        });
    });
    return $52321092cf7642b2$var$_encrypt.apply(this, arguments);
}
module.exports.encrypt = $52321092cf7642b2$var$encrypt;
function $52321092cf7642b2$var$decrypt(sharedSecret, _) {
    return $52321092cf7642b2$var$_decrypt.apply(this, arguments);
}
function $52321092cf7642b2$var$_decrypt() {
    $52321092cf7642b2$var$_decrypt = (0, $kSuI9._)(function(sharedSecret, param) {
        var iv, cipherText, plainText;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    iv = param.iv, cipherText = param.cipherText;
                    return [
                        4,
                        crypto.subtle.decrypt({
                            name: "AES-GCM",
                            iv: iv
                        }, sharedSecret, cipherText)
                    ];
                case 1:
                    plainText = _state.sent();
                    return [
                        2,
                        new TextDecoder().decode(plainText)
                    ];
            }
        });
    });
    return $52321092cf7642b2$var$_decrypt.apply(this, arguments);
}
module.exports.decrypt = $52321092cf7642b2$var$decrypt;
function $52321092cf7642b2$var$getFormat(keyType) {
    switch(keyType){
        case "public":
            return "spki";
        case "private":
            return "pkcs8";
    }
}
function $52321092cf7642b2$var$exportKeyToHexString(type, key) {
    return $52321092cf7642b2$var$_exportKeyToHexString.apply(this, arguments);
}
function $52321092cf7642b2$var$_exportKeyToHexString() {
    $52321092cf7642b2$var$_exportKeyToHexString = (0, $kSuI9._)(function(type, key) {
        var format, exported;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    format = $52321092cf7642b2$var$getFormat(type);
                    return [
                        4,
                        crypto.subtle.exportKey(format, key)
                    ];
                case 1:
                    exported = _state.sent();
                    return [
                        2,
                        (0, $lBX3m.uint8ArrayToHex)(new Uint8Array(exported))
                    ];
            }
        });
    });
    return $52321092cf7642b2$var$_exportKeyToHexString.apply(this, arguments);
}
module.exports.exportKeyToHexString = $52321092cf7642b2$var$exportKeyToHexString;
function $52321092cf7642b2$var$importKeyFromHexString(type, hexString) {
    return $52321092cf7642b2$var$_importKeyFromHexString.apply(this, arguments);
}
function $52321092cf7642b2$var$_importKeyFromHexString() {
    $52321092cf7642b2$var$_importKeyFromHexString = (0, $kSuI9._)(function(type, hexString) {
        var format, arrayBuffer;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    format = $52321092cf7642b2$var$getFormat(type);
                    arrayBuffer = (0, $lBX3m.hexStringToUint8Array)(hexString).buffer;
                    return [
                        4,
                        crypto.subtle.importKey(format, arrayBuffer, {
                            name: "ECDH",
                            namedCurve: "P-256"
                        }, true, type === "private" ? [
                            "deriveKey"
                        ] : [])
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $52321092cf7642b2$var$_importKeyFromHexString.apply(this, arguments);
}
module.exports.importKeyFromHexString = $52321092cf7642b2$var$importKeyFromHexString;
function $52321092cf7642b2$var$encryptContent(content, sharedSecret) {
    return $52321092cf7642b2$var$_encryptContent.apply(this, arguments);
}
function $52321092cf7642b2$var$_encryptContent() {
    $52321092cf7642b2$var$_encryptContent = (0, $kSuI9._)(function(content, sharedSecret) {
        var serialized;
        return (0, $eha6O.__generator)(this, function(_state) {
            serialized = JSON.stringify(content, function(_, value) {
                if (!(value instanceof Error)) return value;
                var error = value;
                return Object.assign(Object.assign({}, error.code ? {
                    code: error.code
                } : {}), {
                    message: error.message
                });
            });
            return [
                2,
                $52321092cf7642b2$var$encrypt(sharedSecret, serialized)
            ];
        });
    });
    return $52321092cf7642b2$var$_encryptContent.apply(this, arguments);
}
module.exports.encryptContent = $52321092cf7642b2$var$encryptContent;
function $52321092cf7642b2$var$decryptContent(encryptedData, sharedSecret) {
    return $52321092cf7642b2$var$_decryptContent.apply(this, arguments);
}
function $52321092cf7642b2$var$_decryptContent() {
    $52321092cf7642b2$var$_decryptContent = (0, $kSuI9._)(function(encryptedData, sharedSecret) {
        var _;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = JSON.parse;
                    return [
                        4,
                        $52321092cf7642b2$var$decrypt(sharedSecret, encryptedData)
                    ];
                case 1:
                    return [
                        2,
                        _.apply(JSON, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return $52321092cf7642b2$var$_decryptContent.apply(this, arguments);
}
module.exports.decryptContent = $52321092cf7642b2$var$decryptContent;

});

parcelRegister("ao3Zq", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
"use strict";
// Copyright (c) 2018-2024 Coinbase, Inc. <https://www.coinbase.com/>
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ScopedLocalStorage = void 0;
var $78ff3d86dd4603af$var$ScopedLocalStorage = /*#__PURE__*/ function() {
    function ScopedLocalStorage(scope, module) {
        (0, $4GJKx._)(this, ScopedLocalStorage);
        this.scope = scope;
        this.module = module;
    }
    (0, $1wc17._)(ScopedLocalStorage, [
        {
            key: "setItem",
            value: function setItem(key, value) {
                localStorage.setItem(this.scopedKey(key), value);
            }
        },
        {
            key: "getItem",
            value: function getItem(key) {
                return localStorage.getItem(this.scopedKey(key));
            }
        },
        {
            key: "removeItem",
            value: function removeItem(key) {
                localStorage.removeItem(this.scopedKey(key));
            }
        },
        {
            key: "clear",
            value: function clear() {
                var prefix = this.scopedKey("");
                var keysToRemove = [];
                for(var i = 0; i < localStorage.length; i++){
                    var key = localStorage.key(i);
                    if (typeof key === "string" && key.startsWith(prefix)) keysToRemove.push(key);
                }
                keysToRemove.forEach(function(key) {
                    return localStorage.removeItem(key);
                });
            }
        },
        {
            key: "scopedKey",
            value: function scopedKey(key) {
                return "-".concat(this.scope).concat(this.module ? ":".concat(this.module) : "", ":").concat(key);
            }
        }
    ], [
        {
            key: "clearAll",
            value: function clearAll() {
                new ScopedLocalStorage("CBWSDK").clear();
                new ScopedLocalStorage("walletlink").clear();
            }
        }
    ]);
    return ScopedLocalStorage;
}();
module.exports.ScopedLocalStorage = $78ff3d86dd4603af$var$ScopedLocalStorage;

});


parcelRegister("5Zh1y", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $cv9Rk = parcelRequire("cv9Rk");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCWStateManager = void 0;

var $ao3Zq = parcelRequire("ao3Zq");
var $45bfdadfbc1515b0$var$ACCOUNTS_KEY = "accounts";
var $45bfdadfbc1515b0$var$ACTIVE_CHAIN_STORAGE_KEY = "activeChain";
var $45bfdadfbc1515b0$var$AVAILABLE_CHAINS_STORAGE_KEY = "availableChains";
var $45bfdadfbc1515b0$var$WALLET_CAPABILITIES_STORAGE_KEY = "walletCapabilities";
var $45bfdadfbc1515b0$var$SCWStateManager = /*#__PURE__*/ function() {
    function SCWStateManager(params) {
        (0, $4GJKx._)(this, SCWStateManager);
        var _a, _b;
        this.storage = new $ao3Zq.ScopedLocalStorage("CBWSDK", "SCWStateManager");
        this.updateListener = params.updateListener;
        this.availableChains = this.loadItemFromStorage($45bfdadfbc1515b0$var$AVAILABLE_CHAINS_STORAGE_KEY);
        this._walletCapabilities = this.loadItemFromStorage($45bfdadfbc1515b0$var$WALLET_CAPABILITIES_STORAGE_KEY);
        var accounts = this.loadItemFromStorage($45bfdadfbc1515b0$var$ACCOUNTS_KEY);
        var chain = this.loadItemFromStorage($45bfdadfbc1515b0$var$ACTIVE_CHAIN_STORAGE_KEY);
        if (accounts) this.updateListener.onAccountsUpdate({
            accounts: accounts,
            source: "storage"
        });
        if (chain) this.updateListener.onChainUpdate({
            chain: chain,
            source: "storage"
        });
        this._accounts = accounts || [];
        this._activeChain = chain || {
            id: (_b = (_a = params.appChainIds) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : 1
        };
    }
    (0, $1wc17._)(SCWStateManager, [
        {
            key: "accounts",
            get: function get() {
                return this._accounts;
            }
        },
        {
            key: "activeChain",
            get: function get() {
                return this._activeChain;
            }
        },
        {
            key: "walletCapabilities",
            get: function get() {
                return this._walletCapabilities;
            }
        },
        {
            key: "updateAccounts",
            value: function updateAccounts(accounts) {
                this._accounts = accounts;
                this.storeItemToStorage($45bfdadfbc1515b0$var$ACCOUNTS_KEY, accounts);
                this.updateListener.onAccountsUpdate({
                    accounts: accounts,
                    source: "wallet"
                });
            }
        },
        {
            key: "switchChain",
            value: function switchChain(chainId) {
                var _a;
                var chain = (_a = this.availableChains) === null || _a === void 0 ? void 0 : _a.find(function(chain) {
                    return chain.id === chainId;
                });
                if (!chain) return false;
                if (chain === this._activeChain) return true;
                this._activeChain = chain;
                this.storeItemToStorage($45bfdadfbc1515b0$var$ACTIVE_CHAIN_STORAGE_KEY, chain);
                this.updateListener.onChainUpdate({
                    chain: chain,
                    source: "wallet"
                });
                return true;
            }
        },
        {
            key: "updateAvailableChains",
            value: function updateAvailableChains(rawChains) {
                if (!rawChains || Object.keys(rawChains).length === 0) return;
                var chains = Object.entries(rawChains).map(function(param) {
                    var _param = (0, $cv9Rk._)(param, 2), id = _param[0], rpcUrl = _param[1];
                    return {
                        id: Number(id),
                        rpcUrl: rpcUrl
                    };
                });
                this.availableChains = chains;
                this.storeItemToStorage($45bfdadfbc1515b0$var$AVAILABLE_CHAINS_STORAGE_KEY, chains);
                this.switchChain(this._activeChain.id);
            }
        },
        {
            key: "updateWalletCapabilities",
            value: function updateWalletCapabilities(capabilities) {
                this._walletCapabilities = capabilities;
                this.storeItemToStorage($45bfdadfbc1515b0$var$WALLET_CAPABILITIES_STORAGE_KEY, capabilities);
            }
        },
        {
            key: "storeItemToStorage",
            value: function storeItemToStorage(key, item) {
                this.storage.setItem(key, JSON.stringify(item));
            }
        },
        {
            key: "loadItemFromStorage",
            value: function loadItemFromStorage(key) {
                var item = this.storage.getItem(key);
                return item ? JSON.parse(item) : undefined;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.storage.clear();
            }
        }
    ]);
    return SCWStateManager;
}();
module.exports.SCWStateManager = $45bfdadfbc1515b0$var$SCWStateManager;

});


parcelRegister("dDmpc", function(module, exports) {

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");

var $8dlmd = parcelRequire("8dlmd");
var $9ed04c24f9513043$require$Buffer = $8dlmd.Buffer;
"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */ var $9ed04c24f9513043$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletLinkSigner = void 0;

// Copyright (c) 2018-2024 Coinbase, Inc. <https://www.coinbase.com/>
var $9ed04c24f9513043$var$eth_eip712_util_1 = $9ed04c24f9513043$var$__importDefault((parcelRequire("eB0l5")));

var $6TzQe = parcelRequire("6TzQe");

var $jFncN = parcelRequire("jFncN");

var $cJCoI = parcelRequire("cJCoI");

var $iaz6m = parcelRequire("iaz6m");

var $aulvc = parcelRequire("aulvc");

var $gBAGR = parcelRequire("gBAGR");

var $lBX3m = parcelRequire("lBX3m");

var $ao3Zq = parcelRequire("ao3Zq");
var $9ed04c24f9513043$var$DEFAULT_CHAIN_ID_KEY = "DefaultChainId";
var $9ed04c24f9513043$var$DEFAULT_JSON_RPC_URL = "DefaultJsonRpcUrl";
// original source: https://github.com/coinbase/coinbase-wallet-sdk/blob/v3.7.1/packages/wallet-sdk/src/provider/CoinbaseWalletProvider.ts
var $9ed04c24f9513043$var$WalletLinkSigner = /*#__PURE__*/ function() {
    "use strict";
    function WalletLinkSigner(options) {
        (0, $4GJKx._)(this, WalletLinkSigner);
        var _a, _b;
        this._relay = null;
        this._addresses = [];
        this.hasMadeFirstChainChangedEmission = false;
        var _options_metadata = options.metadata, appName = _options_metadata.appName, appLogoUrl = _options_metadata.appLogoUrl;
        this._appName = appName;
        this._appLogoUrl = appLogoUrl;
        this._storage = new $ao3Zq.ScopedLocalStorage("walletlink", $aulvc.WALLETLINK_URL);
        this.updateListener = options.updateListener;
        this._relayEventManager = new $jFncN.RelayEventManager();
        this._jsonRpcUrlFromOpts = "";
        var cachedAddresses = this._storage.getItem($6TzQe.LOCAL_STORAGE_ADDRESSES_KEY);
        if (cachedAddresses) {
            var addresses = cachedAddresses.split(" ");
            if (addresses[0] !== "") {
                this._addresses = addresses.map(function(address) {
                    return (0, $lBX3m.ensureAddressString)(address);
                });
                (_a = this.updateListener) === null || _a === void 0 || _a.onAccountsUpdate({
                    accounts: this._addresses,
                    source: "storage"
                });
            }
        }
        var cachedChainId = this._storage.getItem($9ed04c24f9513043$var$DEFAULT_CHAIN_ID_KEY);
        if (cachedChainId) {
            (_b = this.updateListener) === null || _b === void 0 || _b.onChainUpdate({
                chain: {
                    id: this.getChainId(),
                    rpcUrl: this.jsonRpcUrl
                },
                source: "storage"
            });
            this.hasMadeFirstChainChangedEmission = true;
        }
        this.initializeRelay();
    }
    (0, $1wc17._)(WalletLinkSigner, [
        {
            key: "getSession",
            value: function getSession() {
                var relay = this.initializeRelay();
                var _relay_getWalletLinkSession = relay.getWalletLinkSession(), id = _relay_getWalletLinkSession.id, secret = _relay_getWalletLinkSession.secret;
                return {
                    id: id,
                    secret: secret
                };
            }
        },
        {
            key: "handshake",
            value: function handshake() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var ethAddresses;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 1:
                                ethAddresses = _state.sent();
                                return [
                                    2,
                                    ethAddresses
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "selectedAddress",
            get: function get() {
                return this._addresses[0] || undefined;
            }
        },
        {
            key: "jsonRpcUrl",
            get: function get() {
                var _a;
                return (_a = this._storage.getItem($9ed04c24f9513043$var$DEFAULT_JSON_RPC_URL)) !== null && _a !== void 0 ? _a : this._jsonRpcUrlFromOpts;
            },
            set: function set(value) {
                this._storage.setItem($9ed04c24f9513043$var$DEFAULT_JSON_RPC_URL, value);
            }
        },
        {
            key: "updateProviderInfo",
            value: function updateProviderInfo(jsonRpcUrl, chainId) {
                var _a;
                this.jsonRpcUrl = jsonRpcUrl;
                // emit chainChanged event if necessary
                var originalChainId = this.getChainId();
                this._storage.setItem($9ed04c24f9513043$var$DEFAULT_CHAIN_ID_KEY, chainId.toString(10));
                var chainChanged = (0, $lBX3m.ensureIntNumber)(chainId) !== originalChainId;
                if (chainChanged || !this.hasMadeFirstChainChangedEmission) {
                    (_a = this.updateListener) === null || _a === void 0 || _a.onChainUpdate({
                        chain: {
                            id: chainId,
                            rpcUrl: jsonRpcUrl
                        },
                        source: "wallet"
                    });
                    this.hasMadeFirstChainChangedEmission = true;
                }
            }
        },
        {
            key: "watchAsset",
            value: function watchAsset(type, address, symbol, decimals, image, chainId) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var relay, result;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                relay = _this.initializeRelay();
                                return [
                                    4,
                                    relay.watchAsset(type, address, symbol, decimals, image, chainId === null || chainId === void 0 ? void 0 : chainId.toString())
                                ];
                            case 1:
                                result = _state.sent();
                                if ((0, $cJCoI.isErrorResponse)(result)) return [
                                    2,
                                    false
                                ];
                                return [
                                    2,
                                    !!result.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addEthereumChain",
            value: function addEthereumChain(chainId, rpcUrls, blockExplorerUrls, chainName, iconUrls, nativeCurrency) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _a, _b, relay, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if ((0, $lBX3m.ensureIntNumber)(chainId) === _this.getChainId()) return [
                                    2,
                                    false
                                ];
                                relay = _this.initializeRelay();
                                if (!!_this._isAuthorized()) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    relay.requestEthereumAccounts()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    relay.addEthereumChain(chainId.toString(), rpcUrls, iconUrls, blockExplorerUrls, chainName, nativeCurrency)
                                ];
                            case 3:
                                res = _state.sent();
                                if ((0, $cJCoI.isErrorResponse)(res)) return [
                                    2,
                                    false
                                ];
                                if (((_a = res.result) === null || _a === void 0 ? void 0 : _a.isApproved) === true) _this.updateProviderInfo(rpcUrls[0], chainId);
                                return [
                                    2,
                                    ((_b = res.result) === null || _b === void 0 ? void 0 : _b.isApproved) === true
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "switchEthereumChain",
            value: function switchEthereumChain(chainId) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var relay, res, switchResponse;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                relay = _this.initializeRelay();
                                return [
                                    4,
                                    relay.switchEthereumChain(chainId.toString(10), _this.selectedAddress || undefined)
                                ];
                            case 1:
                                res = _state.sent();
                                // backward compatibility
                                if ((0, $cJCoI.isErrorResponse)(res)) {
                                    if (!res.errorCode) return [
                                        2
                                    ];
                                    if (res.errorCode === $gBAGR.standardErrorCodes.provider.unsupportedChain) throw $gBAGR.standardErrors.provider.unsupportedChain();
                                    else throw $gBAGR.standardErrors.provider.custom({
                                        message: res.errorMessage,
                                        code: res.errorCode
                                    });
                                }
                                switchResponse = res.result;
                                if (switchResponse.isApproved && switchResponse.rpcUrl.length > 0) _this.updateProviderInfo(switchResponse.rpcUrl, chainId);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        if (_this._relay) _this._relay.resetAndReload();
                        _this._storage.clear();
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "request",
            value: function request(args) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        try {
                            return [
                                2,
                                _this._request(args).catch(function(error) {
                                    throw error;
                                })
                            ];
                        } catch (error) {
                            return [
                                2,
                                Promise.reject(error)
                            ];
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "_request",
            value: function _request(args) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var method, params, newParams, id, result;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!args || typeof args !== "object" || Array.isArray(args)) throw $gBAGR.standardErrors.rpc.invalidRequest({
                                    message: "Expected a single, non-array, object argument.",
                                    data: args
                                });
                                method = args.method, params = args.params;
                                if (typeof method !== "string" || method.length === 0) throw $gBAGR.standardErrors.rpc.invalidRequest({
                                    message: "'args.method' must be a non-empty string.",
                                    data: args
                                });
                                if (params !== undefined && !Array.isArray(params) && (typeof params !== "object" || params === null)) throw $gBAGR.standardErrors.rpc.invalidRequest({
                                    message: "'args.params' must be an object or array if provided.",
                                    data: args
                                });
                                newParams = params === undefined ? [] : params;
                                // Coinbase Wallet Requests
                                id = _this._relayEventManager.makeRequestId();
                                return [
                                    4,
                                    _this._sendRequestAsync({
                                        method: method,
                                        params: newParams,
                                        jsonrpc: "2.0",
                                        id: id
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_setAddresses",
            value: function _setAddresses(addresses, _) {
                var _a;
                if (!Array.isArray(addresses)) throw new Error("addresses is not an array");
                var newAddresses = addresses.map(function(address) {
                    return (0, $lBX3m.ensureAddressString)(address);
                });
                if (JSON.stringify(newAddresses) === JSON.stringify(this._addresses)) return;
                this._addresses = newAddresses;
                (_a = this.updateListener) === null || _a === void 0 || _a.onAccountsUpdate({
                    accounts: newAddresses,
                    source: "wallet"
                });
                this._storage.setItem($6TzQe.LOCAL_STORAGE_ADDRESSES_KEY, newAddresses.join(" "));
            }
        },
        {
            key: "_sendRequestAsync",
            value: function _sendRequestAsync(request) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    try {
                        var syncResult = _this._handleSynchronousMethods(request);
                        if (syncResult !== undefined) return resolve({
                            jsonrpc: "2.0",
                            id: request.id,
                            result: syncResult
                        });
                    } catch (err) {
                        return reject(err);
                    }
                    _this._handleAsynchronousMethods(request).then(function(res) {
                        return res && resolve(Object.assign(Object.assign({}, res), {
                            id: request.id
                        }));
                    }).catch(function(err) {
                        return reject(err);
                    });
                });
            }
        },
        {
            key: "_handleSynchronousMethods",
            value: function _handleSynchronousMethods(request) {
                var method = request.method;
                switch(method){
                    case "eth_accounts":
                        return this._eth_accounts();
                    case "eth_coinbase":
                        return this._eth_coinbase();
                    case "net_version":
                        return this._net_version();
                    case "eth_chainId":
                        return this._eth_chainId();
                    default:
                        return undefined;
                }
            }
        },
        {
            key: "_handleAsynchronousMethods",
            value: function _handleAsynchronousMethods(request) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var method, params;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        method = request.method;
                        params = request.params || [];
                        switch(method){
                            case "eth_requestAccounts":
                                return [
                                    2,
                                    _this._eth_requestAccounts()
                                ];
                            case "eth_sign":
                                return [
                                    2,
                                    _this._eth_sign(params)
                                ];
                            case "eth_ecRecover":
                                return [
                                    2,
                                    _this._eth_ecRecover(params)
                                ];
                            case "personal_sign":
                                return [
                                    2,
                                    _this._personal_sign(params)
                                ];
                            case "personal_ecRecover":
                                return [
                                    2,
                                    _this._personal_ecRecover(params)
                                ];
                            case "eth_signTransaction":
                                return [
                                    2,
                                    _this._eth_signTransaction(params)
                                ];
                            case "eth_sendRawTransaction":
                                return [
                                    2,
                                    _this._eth_sendRawTransaction(params)
                                ];
                            case "eth_sendTransaction":
                                return [
                                    2,
                                    _this._eth_sendTransaction(params)
                                ];
                            case "eth_signTypedData_v1":
                                return [
                                    2,
                                    _this._eth_signTypedData_v1(params)
                                ];
                            case "eth_signTypedData_v2":
                                return [
                                    2,
                                    _this._throwUnsupportedMethodError()
                                ];
                            case "eth_signTypedData_v3":
                                return [
                                    2,
                                    _this._eth_signTypedData_v3(params)
                                ];
                            case "eth_signTypedData_v4":
                            case "eth_signTypedData":
                                return [
                                    2,
                                    _this._eth_signTypedData_v4(params)
                                ];
                            case "wallet_addEthereumChain":
                                return [
                                    2,
                                    _this._wallet_addEthereumChain(params)
                                ];
                            case "wallet_switchEthereumChain":
                                return [
                                    2,
                                    _this._wallet_switchEthereumChain(params)
                                ];
                            case "wallet_watchAsset":
                                return [
                                    2,
                                    _this._wallet_watchAsset(params)
                                ];
                            default:
                                return [
                                    2,
                                    _this._throwUnsupportedMethodError()
                                ];
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "_isKnownAddress",
            value: function _isKnownAddress(addressString) {
                try {
                    var addressStr = (0, $lBX3m.ensureAddressString)(addressString);
                    var lowercaseAddresses = this._addresses.map(function(address) {
                        return (0, $lBX3m.ensureAddressString)(address);
                    });
                    return lowercaseAddresses.includes(addressStr);
                } catch (_a) {
                // noop
                }
                return false;
            }
        },
        {
            key: "_ensureKnownAddress",
            value: function _ensureKnownAddress(addressString) {
                if (!this._isKnownAddress(addressString)) throw new Error("Unknown Ethereum address");
            }
        },
        {
            key: "_prepareTransactionParams",
            value: function _prepareTransactionParams(tx) {
                var fromAddress = tx.from ? (0, $lBX3m.ensureAddressString)(tx.from) : this.selectedAddress;
                if (!fromAddress) throw new Error("Ethereum address is unavailable");
                this._ensureKnownAddress(fromAddress);
                var toAddress = tx.to ? (0, $lBX3m.ensureAddressString)(tx.to) : null;
                var weiValue = tx.value != null ? (0, $lBX3m.ensureBigInt)(tx.value) : BigInt(0);
                var data = tx.data ? (0, $lBX3m.ensureBuffer)(tx.data) : $9ed04c24f9513043$require$Buffer.alloc(0);
                var nonce = tx.nonce != null ? (0, $lBX3m.ensureIntNumber)(tx.nonce) : null;
                var gasPriceInWei = tx.gasPrice != null ? (0, $lBX3m.ensureBigInt)(tx.gasPrice) : null;
                var maxFeePerGas = tx.maxFeePerGas != null ? (0, $lBX3m.ensureBigInt)(tx.maxFeePerGas) : null;
                var maxPriorityFeePerGas = tx.maxPriorityFeePerGas != null ? (0, $lBX3m.ensureBigInt)(tx.maxPriorityFeePerGas) : null;
                var gasLimit = tx.gas != null ? (0, $lBX3m.ensureBigInt)(tx.gas) : null;
                var chainId = tx.chainId ? (0, $lBX3m.ensureIntNumber)(tx.chainId) : this.getChainId();
                return {
                    fromAddress: fromAddress,
                    toAddress: toAddress,
                    weiValue: weiValue,
                    data: data,
                    nonce: nonce,
                    gasPriceInWei: gasPriceInWei,
                    maxFeePerGas: maxFeePerGas,
                    maxPriorityFeePerGas: maxPriorityFeePerGas,
                    gasLimit: gasLimit,
                    chainId: chainId
                };
            }
        },
        {
            key: "_isAuthorized",
            value: function _isAuthorized() {
                return this._addresses.length > 0;
            }
        },
        {
            key: "_requireAuthorization",
            value: function _requireAuthorization() {
                if (!this._isAuthorized()) throw $gBAGR.standardErrors.provider.unauthorized({});
            }
        },
        {
            key: "_throwUnsupportedMethodError",
            value: function _throwUnsupportedMethodError() {
                throw $gBAGR.standardErrors.provider.unsupportedMethod({});
            }
        },
        {
            key: "_signEthereumMessage",
            value: function _signEthereumMessage(message, address, addPrefix, typedDataJson) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var relay, res, err;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this._ensureKnownAddress(address);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                relay = _this.initializeRelay();
                                return [
                                    4,
                                    relay.signEthereumMessage(message, address, addPrefix, typedDataJson)
                                ];
                            case 2:
                                res = _state.sent();
                                if ((0, $cJCoI.isErrorResponse)(res)) throw new Error(res.errorMessage);
                                return [
                                    2,
                                    {
                                        jsonrpc: "2.0",
                                        id: 0,
                                        result: res.result
                                    }
                                ];
                            case 3:
                                err = _state.sent();
                                if (typeof err.message === "string" && err.message.match(/(denied|rejected)/i)) throw $gBAGR.standardErrors.provider.userRejectedRequest("User denied message signature");
                                throw err;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_ethereumAddressFromSignedMessage",
            value: function _ethereumAddressFromSignedMessage(message, signature, addPrefix) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var relay, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                relay = _this.initializeRelay();
                                return [
                                    4,
                                    relay.ethereumAddressFromSignedMessage(message, signature, addPrefix)
                                ];
                            case 1:
                                res = _state.sent();
                                if ((0, $cJCoI.isErrorResponse)(res)) throw new Error(res.errorMessage);
                                return [
                                    2,
                                    {
                                        jsonrpc: "2.0",
                                        id: 0,
                                        result: res.result
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_eth_accounts",
            value: function _eth_accounts() {
                return (0, $c6Xmf._)(this._addresses);
            }
        },
        {
            key: "_eth_coinbase",
            value: function _eth_coinbase() {
                return this.selectedAddress || null;
            }
        },
        {
            key: "_net_version",
            value: function _net_version() {
                return this.getChainId().toString(10);
            }
        },
        {
            key: "_eth_chainId",
            value: function _eth_chainId() {
                return (0, $lBX3m.hexStringFromIntNumber)(this.getChainId());
            }
        },
        {
            key: "getChainId",
            value: function getChainId() {
                var chainIdStr = this._storage.getItem($9ed04c24f9513043$var$DEFAULT_CHAIN_ID_KEY);
                if (!chainIdStr) return (0, $lBX3m.ensureIntNumber)(1); // default to mainnet
                var chainId = parseInt(chainIdStr, 10);
                return (0, $lBX3m.ensureIntNumber)(chainId);
            }
        },
        {
            key: "_eth_requestAccounts",
            value: function _eth_requestAccounts() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var res, relay, err;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this._isAuthorized()) return [
                                    2,
                                    Promise.resolve({
                                        jsonrpc: "2.0",
                                        id: 0,
                                        result: _this._addresses
                                    })
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                relay = _this.initializeRelay();
                                return [
                                    4,
                                    relay.requestEthereumAccounts()
                                ];
                            case 2:
                                res = _state.sent();
                                if ((0, $cJCoI.isErrorResponse)(res)) throw new Error(res.errorMessage);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                err = _state.sent();
                                if (typeof err.message === "string" && err.message.match(/(denied|rejected)/i)) throw $gBAGR.standardErrors.provider.userRejectedRequest("User denied account authorization");
                                throw err;
                            case 4:
                                if (!res.result) throw new Error("accounts received is empty");
                                _this._setAddresses(res.result);
                                return [
                                    2,
                                    {
                                        jsonrpc: "2.0",
                                        id: 0,
                                        result: _this._addresses
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_eth_sign",
            value: function _eth_sign(params) {
                this._requireAuthorization();
                var address = (0, $lBX3m.ensureAddressString)(params[0]);
                var message = (0, $lBX3m.ensureBuffer)(params[1]);
                return this._signEthereumMessage(message, address, false);
            }
        },
        {
            key: "_eth_ecRecover",
            value: function _eth_ecRecover(params) {
                var message = (0, $lBX3m.ensureBuffer)(params[0]);
                var signature = (0, $lBX3m.ensureBuffer)(params[1]);
                return this._ethereumAddressFromSignedMessage(message, signature, false);
            }
        },
        {
            key: "_personal_sign",
            value: function _personal_sign(params) {
                this._requireAuthorization();
                var message = (0, $lBX3m.ensureBuffer)(params[0]);
                var address = (0, $lBX3m.ensureAddressString)(params[1]);
                return this._signEthereumMessage(message, address, true);
            }
        },
        {
            key: "_personal_ecRecover",
            value: function _personal_ecRecover(params) {
                var message = (0, $lBX3m.ensureBuffer)(params[0]);
                var signature = (0, $lBX3m.ensureBuffer)(params[1]);
                return this._ethereumAddressFromSignedMessage(message, signature, true);
            }
        },
        {
            key: "_eth_signTransaction",
            value: function _eth_signTransaction(params) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var tx, relay, res, err;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this._requireAuthorization();
                                tx = _this._prepareTransactionParams(params[0] || {});
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                relay = _this.initializeRelay();
                                return [
                                    4,
                                    relay.signEthereumTransaction(tx)
                                ];
                            case 2:
                                res = _state.sent();
                                if ((0, $cJCoI.isErrorResponse)(res)) throw new Error(res.errorMessage);
                                return [
                                    2,
                                    {
                                        jsonrpc: "2.0",
                                        id: 0,
                                        result: res.result
                                    }
                                ];
                            case 3:
                                err = _state.sent();
                                if (typeof err.message === "string" && err.message.match(/(denied|rejected)/i)) throw $gBAGR.standardErrors.provider.userRejectedRequest("User denied transaction signature");
                                throw err;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_eth_sendRawTransaction",
            value: function _eth_sendRawTransaction(params) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var signedTransaction, relay, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                signedTransaction = (0, $lBX3m.ensureBuffer)(params[0]);
                                relay = _this.initializeRelay();
                                return [
                                    4,
                                    relay.submitEthereumTransaction(signedTransaction, _this.getChainId())
                                ];
                            case 1:
                                res = _state.sent();
                                if ((0, $cJCoI.isErrorResponse)(res)) throw new Error(res.errorMessage);
                                return [
                                    2,
                                    {
                                        jsonrpc: "2.0",
                                        id: 0,
                                        result: res.result
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_eth_sendTransaction",
            value: function _eth_sendTransaction(params) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var tx, relay, res, err;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this._requireAuthorization();
                                tx = _this._prepareTransactionParams(params[0] || {});
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                relay = _this.initializeRelay();
                                return [
                                    4,
                                    relay.signAndSubmitEthereumTransaction(tx)
                                ];
                            case 2:
                                res = _state.sent();
                                if ((0, $cJCoI.isErrorResponse)(res)) throw new Error(res.errorMessage);
                                return [
                                    2,
                                    {
                                        jsonrpc: "2.0",
                                        id: 0,
                                        result: res.result
                                    }
                                ];
                            case 3:
                                err = _state.sent();
                                if (typeof err.message === "string" && err.message.match(/(denied|rejected)/i)) throw $gBAGR.standardErrors.provider.userRejectedRequest("User denied transaction signature");
                                throw err;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_eth_signTypedData_v1",
            value: function _eth_signTypedData_v1(params) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var typedData, address, message, typedDataJSON;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        _this._requireAuthorization();
                        typedData = (0, $lBX3m.ensureParsedJSONObject)(params[0]);
                        address = (0, $lBX3m.ensureAddressString)(params[1]);
                        _this._ensureKnownAddress(address);
                        message = $9ed04c24f9513043$var$eth_eip712_util_1.default.hashForSignTypedDataLegacy({
                            data: typedData
                        });
                        typedDataJSON = JSON.stringify(typedData, null, 2);
                        return [
                            2,
                            _this._signEthereumMessage(message, address, false, typedDataJSON)
                        ];
                    });
                })();
            }
        },
        {
            key: "_eth_signTypedData_v3",
            value: function _eth_signTypedData_v3(params) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var address, typedData, message, typedDataJSON;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        _this._requireAuthorization();
                        address = (0, $lBX3m.ensureAddressString)(params[0]);
                        typedData = (0, $lBX3m.ensureParsedJSONObject)(params[1]);
                        _this._ensureKnownAddress(address);
                        message = $9ed04c24f9513043$var$eth_eip712_util_1.default.hashForSignTypedData_v3({
                            data: typedData
                        });
                        typedDataJSON = JSON.stringify(typedData, null, 2);
                        return [
                            2,
                            _this._signEthereumMessage(message, address, false, typedDataJSON)
                        ];
                    });
                })();
            }
        },
        {
            key: "_eth_signTypedData_v4",
            value: function _eth_signTypedData_v4(params) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var address, typedData, message, typedDataJSON;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        _this._requireAuthorization();
                        address = (0, $lBX3m.ensureAddressString)(params[0]);
                        typedData = (0, $lBX3m.ensureParsedJSONObject)(params[1]);
                        _this._ensureKnownAddress(address);
                        message = $9ed04c24f9513043$var$eth_eip712_util_1.default.hashForSignTypedData_v4({
                            data: typedData
                        });
                        typedDataJSON = JSON.stringify(typedData, null, 2);
                        return [
                            2,
                            _this._signEthereumMessage(message, address, false, typedDataJSON)
                        ];
                    });
                })();
            }
        },
        {
            key: "_wallet_addEthereumChain",
            value: function _wallet_addEthereumChain(params) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _a, _b, _c, _d, request, chainIdNumber, success;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                request = params[0];
                                if (((_a = request.rpcUrls) === null || _a === void 0 ? void 0 : _a.length) === 0) return [
                                    2,
                                    {
                                        jsonrpc: "2.0",
                                        id: 0,
                                        error: {
                                            code: 2,
                                            message: "please pass in at least 1 rpcUrl"
                                        }
                                    }
                                ];
                                if (!request.chainName || request.chainName.trim() === "") throw $gBAGR.standardErrors.rpc.invalidParams("chainName is a required field");
                                if (!request.nativeCurrency) throw $gBAGR.standardErrors.rpc.invalidParams("nativeCurrency is a required field");
                                chainIdNumber = parseInt(request.chainId, 16);
                                return [
                                    4,
                                    _this.addEthereumChain(chainIdNumber, (_b = request.rpcUrls) !== null && _b !== void 0 ? _b : [], (_c = request.blockExplorerUrls) !== null && _c !== void 0 ? _c : [], request.chainName, (_d = request.iconUrls) !== null && _d !== void 0 ? _d : [], request.nativeCurrency)
                                ];
                            case 1:
                                success = _state.sent();
                                if (success) return [
                                    2,
                                    {
                                        jsonrpc: "2.0",
                                        id: 0,
                                        result: null
                                    }
                                ];
                                return [
                                    2,
                                    {
                                        jsonrpc: "2.0",
                                        id: 0,
                                        error: {
                                            code: 2,
                                            message: "unable to add ethereum chain"
                                        }
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_wallet_switchEthereumChain",
            value: function _wallet_switchEthereumChain(params) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var request;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                request = params[0];
                                return [
                                    4,
                                    _this.switchEthereumChain(parseInt(request.chainId, 16))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    {
                                        jsonrpc: "2.0",
                                        id: 0,
                                        result: null
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_wallet_watchAsset",
            value: function _wallet_watchAsset(params) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var request, chainId, _request_options, address, symbol, image, decimals, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                request = Array.isArray(params) ? params[0] : params;
                                if (!request.type) throw $gBAGR.standardErrors.rpc.invalidParams("Type is required");
                                if ((request === null || request === void 0 ? void 0 : request.type) !== "ERC20") throw $gBAGR.standardErrors.rpc.invalidParams("Asset of type '".concat(request.type, "' is not supported"));
                                if (!(request === null || request === void 0 ? void 0 : request.options)) throw $gBAGR.standardErrors.rpc.invalidParams("Options are required");
                                if (!(request === null || request === void 0 ? void 0 : request.options.address)) throw $gBAGR.standardErrors.rpc.invalidParams("Address is required");
                                chainId = _this.getChainId();
                                _request_options = request.options, address = _request_options.address, symbol = _request_options.symbol, image = _request_options.image, decimals = _request_options.decimals;
                                return [
                                    4,
                                    _this.watchAsset(request.type, address, symbol, decimals, image, chainId)
                                ];
                            case 1:
                                res = _state.sent();
                                return [
                                    2,
                                    {
                                        jsonrpc: "2.0",
                                        id: 0,
                                        result: res
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initializeRelay",
            value: function initializeRelay() {
                var _this = this;
                if (!this._relay) {
                    var relay = new $iaz6m.WalletLinkRelay({
                        linkAPIUrl: $aulvc.WALLETLINK_URL,
                        storage: this._storage
                    });
                    relay.setAppInfo(this._appName, this._appLogoUrl);
                    relay.attachUI();
                    relay.setAccountsCallback(function(accounts, isDisconnect) {
                        return _this._setAddresses(accounts, isDisconnect);
                    });
                    relay.setChainCallback(function(chainId, jsonRpcUrl) {
                        _this.updateProviderInfo(jsonRpcUrl, parseInt(chainId, 10));
                    });
                    this._relay = relay;
                }
                return this._relay;
            }
        }
    ]);
    return WalletLinkSigner;
}();
module.exports.WalletLinkSigner = $9ed04c24f9513043$var$WalletLinkSigner;

});
parcelRegister("eB0l5", function(module, exports) {

var $cv9Rk = parcelRequire("cv9Rk");

var $8dlmd = parcelRequire("8dlmd");
var $aa04c8b7abfc052b$require$Buffer = $8dlmd.Buffer;

var $bSygJ = parcelRequire("bSygJ");

var $956qt = parcelRequire("956qt");
var $aa04c8b7abfc052b$var$TYPED_MESSAGE_SCHEMA = {
    type: "object",
    properties: {
        types: {
            type: "object",
            additionalProperties: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        name: {
                            type: "string"
                        },
                        type: {
                            type: "string"
                        }
                    },
                    required: [
                        "name",
                        "type"
                    ]
                }
            }
        },
        primaryType: {
            type: "string"
        },
        domain: {
            type: "object"
        },
        message: {
            type: "object"
        }
    },
    required: [
        "types",
        "primaryType",
        "domain",
        "message"
    ]
};
/**
 * A collection of utility functions used for signing typed data
 */ var $aa04c8b7abfc052b$var$TypedDataUtils = {
    /**
   * Encodes an object by encoding and concatenating each of its members
   *
   * @param {string} primaryType - Root type
   * @param {Object} data - Object to encode
   * @param {Object} types - Type definitions
   * @returns {string} - Encoded representation of an object
   */ encodeData: function(primaryType, data, types) {
        var _this = this;
        var useV4 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
        var encodedTypes = [
            "bytes32"
        ];
        var encodedValues = [
            this.hashType(primaryType, types)
        ];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (useV4) {
            var encodeField = function(name, type, value) {
                if (types[type] !== undefined) return [
                    "bytes32",
                    value == null ? "0x0000000000000000000000000000000000000000000000000000000000000000" : $bSygJ.keccak(_this.encodeData(type, value, types, useV4))
                ];
                if (value === undefined) throw new Error("missing value for field ".concat(name, " of type ").concat(type));
                if (type === "bytes") return [
                    "bytes32",
                    $bSygJ.keccak(value)
                ];
                if (type === "string") {
                    // convert string to buffer - prevents ethUtil from interpreting strings like '0xabcd' as hex
                    if (typeof value === "string") value = $aa04c8b7abfc052b$require$Buffer.from(value, "utf8");
                    return [
                        "bytes32",
                        $bSygJ.keccak(value)
                    ];
                }
                if (type.lastIndexOf("]") === type.length - 1) {
                    var parsedType = type.slice(0, type.lastIndexOf("["));
                    var typeValuePairs = value.map(function(item) {
                        return encodeField(name, parsedType, item);
                    });
                    return [
                        "bytes32",
                        $bSygJ.keccak($956qt.rawEncode(typeValuePairs.map(function(param) {
                            var _param = (0, $cv9Rk._)(param, 1), _$type = _param[0];
                            return _$type;
                        }), typeValuePairs.map(function(param) {
                            var _param = (0, $cv9Rk._)(param, 2), _$value = _param[1];
                            return _$value;
                        })))
                    ];
                }
                return [
                    type,
                    value
                ];
            };
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator = types[primaryType][Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                    var field = _step.value;
                    var _encodeField = (0, $cv9Rk._)(encodeField(field.name, field.type, data[field.name]), 2), type = _encodeField[0], value = _encodeField[1];
                    encodedTypes.push(type);
                    encodedValues.push(value);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        } else try {
            for(var _iterator1 = types[primaryType][Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                var field1 = _step1.value;
                var value1 = data[field1.name];
                if (value1 !== undefined) {
                    if (field1.type === "bytes") {
                        encodedTypes.push("bytes32");
                        value1 = $bSygJ.keccak(value1);
                        encodedValues.push(value1);
                    } else if (field1.type === "string") {
                        encodedTypes.push("bytes32");
                        // convert string to buffer - prevents ethUtil from interpreting strings like '0xabcd' as hex
                        if (typeof value1 === "string") value1 = $aa04c8b7abfc052b$require$Buffer.from(value1, "utf8");
                        value1 = $bSygJ.keccak(value1);
                        encodedValues.push(value1);
                    } else if (types[field1.type] !== undefined) {
                        encodedTypes.push("bytes32");
                        value1 = $bSygJ.keccak(this.encodeData(field1.type, value1, types, useV4));
                        encodedValues.push(value1);
                    } else if (field1.type.lastIndexOf("]") === field1.type.length - 1) throw new Error("Arrays currently unimplemented in encodeData");
                    else {
                        encodedTypes.push(field1.type);
                        encodedValues.push(value1);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return $956qt.rawEncode(encodedTypes, encodedValues);
    },
    /**
   * Encodes the type of an object by encoding a comma delimited list of its members
   *
   * @param {string} primaryType - Root type to encode
   * @param {Object} types - Type definitions
   * @returns {string} - Encoded representation of the type of an object
   */ encodeType: function(primaryType, types) {
        var result = "";
        var deps = this.findTypeDependencies(primaryType, types).filter(function(dep) {
            return dep !== primaryType;
        });
        deps = [
            primaryType
        ].concat(deps.sort());
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = deps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var type = _step.value;
                var children = types[type];
                if (!children) throw new Error("No type definition specified: " + type);
                result += type + "(" + types[type].map(function(param) {
                    var name = param.name, type = param.type;
                    return type + " " + name;
                }).join(",") + ")";
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return result;
    },
    /**
   * Finds all types within a type definition object
   *
   * @param {string} primaryType - Root type
   * @param {Object} types - Type definitions
   * @param {Array} results - current set of accumulated types
   * @returns {Array} - Set of all types found in the type definition
   */ findTypeDependencies: function(primaryType, types) {
        var results = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
        primaryType = primaryType.match(/^\w*/)[0];
        if (results.includes(primaryType) || types[primaryType] === undefined) return results;
        results.push(primaryType);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator = types[primaryType][Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                var field = _step.value;
                try {
                    for(var _iterator1 = this.findTypeDependencies(field.type, types, results)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                        var dep = _step1.value;
                        !results.includes(dep) && results.push(dep);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return results;
    },
    /**
   * Hashes an object
   *
   * @param {string} primaryType - Root type
   * @param {Object} data - Object to hash
   * @param {Object} types - Type definitions
   * @returns {Buffer} - Hash of an object
   */ hashStruct: function(primaryType, data, types) {
        var useV4 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
        return $bSygJ.keccak(this.encodeData(primaryType, data, types, useV4));
    },
    /**
   * Hashes the type of an object
   *
   * @param {string} primaryType - Root type to hash
   * @param {Object} types - Type definitions
   * @returns {string} - Hash of an object
   */ hashType: function(primaryType, types) {
        return $bSygJ.keccak(this.encodeType(primaryType, types));
    },
    /**
   * Removes properties from a message object that are not defined per EIP-712
   *
   * @param {Object} data - typed message object
   * @returns {Object} - typed message object with only allowed fields
   */ sanitizeData: function(data) {
        var sanitizedData = {};
        for(var key in $aa04c8b7abfc052b$var$TYPED_MESSAGE_SCHEMA.properties)data[key] && (sanitizedData[key] = data[key]);
        if (sanitizedData.types) sanitizedData.types = Object.assign({
            EIP712Domain: []
        }, sanitizedData.types);
        return sanitizedData;
    },
    /**
   * Returns the hash of a typed message as per EIP-712 for signing
   *
   * @param {Object} typedData - Types message data to sign
   * @returns {string} - sha3 hash for signing
   */ hash: function(typedData) {
        var useV4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var sanitizedData = this.sanitizeData(typedData);
        var parts = [
            $aa04c8b7abfc052b$require$Buffer.from("1901", "hex")
        ];
        parts.push(this.hashStruct("EIP712Domain", sanitizedData.domain, sanitizedData.types, useV4));
        if (sanitizedData.primaryType !== "EIP712Domain") parts.push(this.hashStruct(sanitizedData.primaryType, sanitizedData.message, sanitizedData.types, useV4));
        return $bSygJ.keccak($aa04c8b7abfc052b$require$Buffer.concat(parts));
    }
};
module.exports = {
    TYPED_MESSAGE_SCHEMA: $aa04c8b7abfc052b$var$TYPED_MESSAGE_SCHEMA,
    TypedDataUtils: $aa04c8b7abfc052b$var$TypedDataUtils,
    hashForSignTypedDataLegacy: function hashForSignTypedDataLegacy(msgParams) {
        return $aa04c8b7abfc052b$var$typedSignatureHashLegacy(msgParams.data);
    },
    hashForSignTypedData_v3: function hashForSignTypedData_v3(msgParams) {
        return $aa04c8b7abfc052b$var$TypedDataUtils.hash(msgParams.data, false);
    },
    hashForSignTypedData_v4: function hashForSignTypedData_v4(msgParams) {
        return $aa04c8b7abfc052b$var$TypedDataUtils.hash(msgParams.data);
    }
};
/**
 * @param typedData - Array of data along with types, as per EIP712.
 * @returns Buffer
 */ function $aa04c8b7abfc052b$var$typedSignatureHashLegacy(typedData) {
    var error = new Error("Expect argument to be non-empty array");
    if (typeof typedData !== "object" || !typedData.length) throw error;
    var data = typedData.map(function(e) {
        return e.type === "bytes" ? $bSygJ.toBuffer(e.value) : e.value;
    });
    var types = typedData.map(function(e) {
        return e.type;
    });
    var schema = typedData.map(function(e) {
        if (!e.name) throw error;
        return e.type + " " + e.name;
    });
    return $956qt.soliditySHA3([
        "bytes32",
        "bytes32"
    ], [
        $956qt.soliditySHA3(new Array(typedData.length).fill("string"), schema),
        $956qt.soliditySHA3(types, data)
    ]);
}

});
parcelRegister("bSygJ", function(module, exports) {
// Extracted from https://github.com/ethereumjs/ethereumjs-util and stripped out irrelevant code
// Original code licensed under the Mozilla Public License Version 2.0
/* eslint-disable */ //prettier-ignore

var $l0HdX = parcelRequire("l0HdX");

var $8dlmd = parcelRequire("8dlmd");
var $8a5f51f0300fae4d$require$Buffer = $8dlmd.Buffer;

var $5XtUl = parcelRequire("5XtUl");
/**
 * Returns a buffer filled with 0s
 * @method zeros
 * @param {Number} bytes  the number of bytes the buffer should be
 * @return {Buffer}
 */ function $8a5f51f0300fae4d$var$zeros(bytes) {
    return $8a5f51f0300fae4d$require$Buffer.allocUnsafe(bytes).fill(0);
}
function $8a5f51f0300fae4d$var$bitLengthFromBigInt(num) {
    return num.toString(2).length;
}
function $8a5f51f0300fae4d$var$bufferBEFromBigInt(num, length) {
    var hex = num.toString(16);
    // Ensure the hex string length is even
    if (hex.length % 2 !== 0) hex = "0" + hex;
    // Convert hex string to a byte array
    var byteArray = hex.match(/.{1,2}/g).map(function(byte) {
        return parseInt(byte, 16);
    });
    // Ensure the byte array is of the specified length
    while(byteArray.length < length)byteArray.unshift(0); // Prepend with zeroes if shorter than required length
    return $8a5f51f0300fae4d$require$Buffer.from(byteArray);
}
function $8a5f51f0300fae4d$var$twosFromBigInt(value, width) {
    var isNegative = value < 0n;
    var result;
    if (isNegative) {
        // Prepare a mask for the specified width to perform NOT operation
        var mask = (1n << BigInt(width)) - 1n;
        // Invert bits (using NOT) and add one
        result = (~value & mask) + 1n;
    } else result = value;
    // Ensure the result fits in the specified width
    result &= (1n << BigInt(width)) - 1n;
    return result;
}
/**
 * Left Pads an `Array` or `Buffer` with leading zeros till it has `length` bytes.
 * Or it truncates the beginning if it exceeds.
 * @method setLength
 * @param {Buffer|Array} msg the value to pad
 * @param {Number} length the number of bytes the output should be
 * @param {Boolean} [right=false] whether to start padding form the left or right
 * @return {Buffer|Array}
 */ function $8a5f51f0300fae4d$var$setLength(msg, length, right) {
    var buf = $8a5f51f0300fae4d$var$zeros(length);
    msg = $8a5f51f0300fae4d$var$toBuffer(msg);
    if (right) {
        if (msg.length < length) {
            msg.copy(buf);
            return buf;
        }
        return msg.slice(0, length);
    } else {
        if (msg.length < length) {
            msg.copy(buf, length - msg.length);
            return buf;
        }
        return msg.slice(-length);
    }
}
/**
 * Right Pads an `Array` or `Buffer` with leading zeros till it has `length` bytes.
 * Or it truncates the beginning if it exceeds.
 * @param {Buffer|Array} msg the value to pad
 * @param {Number} length the number of bytes the output should be
 * @return {Buffer|Array}
 */ function $8a5f51f0300fae4d$var$setLengthRight(msg, length) {
    return $8a5f51f0300fae4d$var$setLength(msg, length, true);
}
/**
 * Attempts to turn a value into a `Buffer`. As input it supports `Buffer`, `String`, `Number`, null/undefined, `BIgInt` and other objects with a `toArray()` method.
 * @param {*} v the value
 */ function $8a5f51f0300fae4d$var$toBuffer(v) {
    if (!$8a5f51f0300fae4d$require$Buffer.isBuffer(v)) {
        if (Array.isArray(v)) v = $8a5f51f0300fae4d$require$Buffer.from(v);
        else if (typeof v === "string") {
            if ($8a5f51f0300fae4d$var$isHexString(v)) v = $8a5f51f0300fae4d$require$Buffer.from($8a5f51f0300fae4d$var$padToEven($8a5f51f0300fae4d$var$stripHexPrefix(v)), "hex");
            else v = $8a5f51f0300fae4d$require$Buffer.from(v);
        } else if (typeof v === "number") v = intToBuffer(v);
        else if (v === null || v === undefined) v = $8a5f51f0300fae4d$require$Buffer.allocUnsafe(0);
        else if ((typeof v === "undefined" ? "undefined" : (0, $l0HdX._)(v)) === "bigint") v = $8a5f51f0300fae4d$var$bufferBEFromBigInt(v);
        else if (v.toArray) // TODO: bigint should be handled above, may remove this duplicate
        // converts a BigInt to a Buffer
        v = $8a5f51f0300fae4d$require$Buffer.from(v.toArray());
        else throw new Error("invalid type");
    }
    return v;
}
/**
 * Converts a `Buffer` into a hex `String`
 * @param {Buffer} buf
 * @return {String}
 */ function $8a5f51f0300fae4d$var$bufferToHex(buf) {
    buf = $8a5f51f0300fae4d$var$toBuffer(buf);
    return "0x" + buf.toString("hex");
}
/**
 * Creates Keccak hash of the input
 * @param {Buffer|Array|String|Number} a the input data
 * @param {Number} [bits=256] the Keccak width
 * @return {Buffer}
 */ function $8a5f51f0300fae4d$var$keccak(a, bits) {
    a = $8a5f51f0300fae4d$var$toBuffer(a);
    if (!bits) bits = 256;
    return $5XtUl("keccak" + bits).update(a).digest();
}
function $8a5f51f0300fae4d$var$padToEven(str) {
    return str.length % 2 ? "0" + str : str;
}
function $8a5f51f0300fae4d$var$isHexString(str) {
    return typeof str === "string" && str.match(/^0x[0-9A-Fa-f]*$/);
}
function $8a5f51f0300fae4d$var$stripHexPrefix(str) {
    if (typeof str === "string" && str.startsWith("0x")) return str.slice(2);
    return str;
}
module.exports = {
    zeros: $8a5f51f0300fae4d$var$zeros,
    setLength: $8a5f51f0300fae4d$var$setLength,
    setLengthRight: $8a5f51f0300fae4d$var$setLengthRight,
    isHexString: $8a5f51f0300fae4d$var$isHexString,
    stripHexPrefix: $8a5f51f0300fae4d$var$stripHexPrefix,
    toBuffer: $8a5f51f0300fae4d$var$toBuffer,
    bufferToHex: $8a5f51f0300fae4d$var$bufferToHex,
    keccak: $8a5f51f0300fae4d$var$keccak,
    bitLengthFromBigInt: $8a5f51f0300fae4d$var$bitLengthFromBigInt,
    bufferBEFromBigInt: $8a5f51f0300fae4d$var$bufferBEFromBigInt,
    twosFromBigInt: $8a5f51f0300fae4d$var$twosFromBigInt
};

});

parcelRegister("956qt", function(module, exports) {
// Extracted from https://github.com/ethereumjs/ethereumjs-abi and stripped out irrelevant code
// Original code licensed under the MIT License - Copyright (c) 2015 Alex Beregszaszi
/* eslint-disable */ //prettier-ignore

var $l0HdX = parcelRequire("l0HdX");

var $8dlmd = parcelRequire("8dlmd");
var $69c990c37a181156$require$Buffer = $8dlmd.Buffer;

var $bSygJ = parcelRequire("bSygJ");
// Convert from short to canonical names
// FIXME: optimise or make this nicer?
function $69c990c37a181156$var$elementaryName(name) {
    if (name.startsWith("int[")) return "int256" + name.slice(3);
    else if (name === "int") return "int256";
    else if (name.startsWith("uint[")) return "uint256" + name.slice(4);
    else if (name === "uint") return "uint256";
    else if (name.startsWith("fixed[")) return "fixed128x128" + name.slice(5);
    else if (name === "fixed") return "fixed128x128";
    else if (name.startsWith("ufixed[")) return "ufixed128x128" + name.slice(6);
    else if (name === "ufixed") return "ufixed128x128";
    return name;
}
// Parse N from type<N>
function $69c990c37a181156$var$parseTypeN(type) {
    return parseInt(/^\D+(\d+)$/.exec(type)[1], 10);
}
// Parse N,M from type<N>x<M>
function $69c990c37a181156$var$parseTypeNxM(type) {
    var tmp = /^\D+(\d+)x(\d+)$/.exec(type);
    return [
        parseInt(tmp[1], 10),
        parseInt(tmp[2], 10)
    ];
}
// Parse N in type[<N>] where "type" can itself be an array type.
function $69c990c37a181156$var$parseTypeArray(type) {
    var tmp = type.match(/(.*)\[(.*?)\]$/);
    if (tmp) return tmp[2] === "" ? "dynamic" : parseInt(tmp[2], 10);
    return null;
}
function $69c990c37a181156$var$parseNumber(arg) {
    var type = typeof arg === "undefined" ? "undefined" : (0, $l0HdX._)(arg);
    if (type === "string" || type === "number") return BigInt(arg);
    else if (type === "bigint") return arg;
    else throw new Error("Argument is not a number");
}
// Encodes a single item (can be dynamic array)
// @returns: Buffer
function $69c990c37a181156$var$encodeSingle(type, arg) {
    var size, num, ret, i;
    if (type === "address") return $69c990c37a181156$var$encodeSingle("uint160", $69c990c37a181156$var$parseNumber(arg));
    else if (type === "bool") return $69c990c37a181156$var$encodeSingle("uint8", arg ? 1 : 0);
    else if (type === "string") return $69c990c37a181156$var$encodeSingle("bytes", new $69c990c37a181156$require$Buffer(arg, "utf8"));
    else if ($69c990c37a181156$var$isArray(type)) {
        // this part handles fixed-length ([2]) and variable length ([]) arrays
        // NOTE: we catch here all calls to arrays, that simplifies the rest
        if (typeof arg.length === "undefined") throw new Error("Not an array?");
        size = $69c990c37a181156$var$parseTypeArray(type);
        if (size !== "dynamic" && size !== 0 && arg.length > size) throw new Error("Elements exceed array size: " + size);
        ret = [];
        type = type.slice(0, type.lastIndexOf("["));
        if (typeof arg === "string") arg = JSON.parse(arg);
        for(i in arg)ret.push($69c990c37a181156$var$encodeSingle(type, arg[i]));
        if (size === "dynamic") {
            var length = $69c990c37a181156$var$encodeSingle("uint256", arg.length);
            ret.unshift(length);
        }
        return $69c990c37a181156$require$Buffer.concat(ret);
    } else if (type === "bytes") {
        arg = new $69c990c37a181156$require$Buffer(arg);
        ret = $69c990c37a181156$require$Buffer.concat([
            $69c990c37a181156$var$encodeSingle("uint256", arg.length),
            arg
        ]);
        if (arg.length % 32 !== 0) ret = $69c990c37a181156$require$Buffer.concat([
            ret,
            $bSygJ.zeros(32 - arg.length % 32)
        ]);
        return ret;
    } else if (type.startsWith("bytes")) {
        size = $69c990c37a181156$var$parseTypeN(type);
        if (size < 1 || size > 32) throw new Error("Invalid bytes<N> width: " + size);
        return $bSygJ.setLengthRight(arg, 32);
    } else if (type.startsWith("uint")) {
        size = $69c990c37a181156$var$parseTypeN(type);
        if (size % 8 || size < 8 || size > 256) throw new Error("Invalid uint<N> width: " + size);
        num = $69c990c37a181156$var$parseNumber(arg);
        var bitLength = $bSygJ.bitLengthFromBigInt(num);
        if (bitLength > size) throw new Error("Supplied uint exceeds width: " + size + " vs " + bitLength);
        if (num < 0) throw new Error("Supplied uint is negative");
        return $bSygJ.bufferBEFromBigInt(num, 32);
    } else if (type.startsWith("int")) {
        size = $69c990c37a181156$var$parseTypeN(type);
        if (size % 8 || size < 8 || size > 256) throw new Error("Invalid int<N> width: " + size);
        num = $69c990c37a181156$var$parseNumber(arg);
        var bitLength1 = $bSygJ.bitLengthFromBigInt(num);
        if (bitLength1 > size) throw new Error("Supplied int exceeds width: " + size + " vs " + bitLength1);
        var twos = $bSygJ.twosFromBigInt(num, 256);
        return $bSygJ.bufferBEFromBigInt(twos, 32);
    } else if (type.startsWith("ufixed")) {
        size = $69c990c37a181156$var$parseTypeNxM(type);
        num = $69c990c37a181156$var$parseNumber(arg);
        if (num < 0) throw new Error("Supplied ufixed is negative");
        return $69c990c37a181156$var$encodeSingle("uint256", num * Math.pow(BigInt(2), BigInt(size[1])));
    } else if (type.startsWith("fixed")) {
        size = $69c990c37a181156$var$parseTypeNxM(type);
        return $69c990c37a181156$var$encodeSingle("int256", $69c990c37a181156$var$parseNumber(arg) * Math.pow(BigInt(2), BigInt(size[1])));
    }
    throw new Error("Unsupported or invalid type: " + type);
}
// Is a type dynamic?
function $69c990c37a181156$var$isDynamic(type) {
    // FIXME: handle all types? I don't think anything is missing now
    return type === "string" || type === "bytes" || $69c990c37a181156$var$parseTypeArray(type) === "dynamic";
}
// Is a type an array?
function $69c990c37a181156$var$isArray(type) {
    return type.lastIndexOf("]") === type.length - 1;
}
// Encode a method/event with arguments
// @types an array of string type names
// @args  an array of the appropriate values
function $69c990c37a181156$var$rawEncode(types, values) {
    var output = [];
    var data = [];
    var headLength = 32 * types.length;
    for(var i in types){
        var type = $69c990c37a181156$var$elementaryName(types[i]);
        var value = values[i];
        var cur = $69c990c37a181156$var$encodeSingle(type, value);
        // Use the head/tail method for storing dynamic data
        if ($69c990c37a181156$var$isDynamic(type)) {
            output.push($69c990c37a181156$var$encodeSingle("uint256", headLength));
            data.push(cur);
            headLength += cur.length;
        } else output.push(cur);
    }
    return $69c990c37a181156$require$Buffer.concat(output.concat(data));
}
function $69c990c37a181156$var$solidityPack(types, values) {
    if (types.length !== values.length) throw new Error("Number of types are not matching the values");
    var size, num;
    var ret = [];
    for(var i = 0; i < types.length; i++){
        var type = $69c990c37a181156$var$elementaryName(types[i]);
        var value = values[i];
        if (type === "bytes") ret.push(value);
        else if (type === "string") ret.push(new $69c990c37a181156$require$Buffer(value, "utf8"));
        else if (type === "bool") ret.push(new $69c990c37a181156$require$Buffer(value ? "01" : "00", "hex"));
        else if (type === "address") ret.push($bSygJ.setLength(value, 20));
        else if (type.startsWith("bytes")) {
            size = $69c990c37a181156$var$parseTypeN(type);
            if (size < 1 || size > 32) throw new Error("Invalid bytes<N> width: " + size);
            ret.push($bSygJ.setLengthRight(value, size));
        } else if (type.startsWith("uint")) {
            size = $69c990c37a181156$var$parseTypeN(type);
            if (size % 8 || size < 8 || size > 256) throw new Error("Invalid uint<N> width: " + size);
            num = $69c990c37a181156$var$parseNumber(value);
            var bitLength = $bSygJ.bitLengthFromBigInt(num);
            if (bitLength > size) throw new Error("Supplied uint exceeds width: " + size + " vs " + bitLength);
            ret.push($bSygJ.bufferBEFromBigInt(num, size / 8));
        } else if (type.startsWith("int")) {
            size = $69c990c37a181156$var$parseTypeN(type);
            if (size % 8 || size < 8 || size > 256) throw new Error("Invalid int<N> width: " + size);
            num = $69c990c37a181156$var$parseNumber(value);
            var bitLength1 = $bSygJ.bitLengthFromBigInt(num);
            if (bitLength1 > size) throw new Error("Supplied int exceeds width: " + size + " vs " + bitLength1);
            var twos = $bSygJ.twosFromBigInt(num, size);
            ret.push($bSygJ.bufferBEFromBigInt(twos, size / 8));
        } else // FIXME: support all other types
        throw new Error("Unsupported or invalid type: " + type);
    }
    return $69c990c37a181156$require$Buffer.concat(ret);
}
function $69c990c37a181156$var$soliditySHA3(types, values) {
    return $bSygJ.keccak($69c990c37a181156$var$solidityPack(types, values));
}
module.exports = {
    rawEncode: $69c990c37a181156$var$rawEncode,
    solidityPack: $69c990c37a181156$var$solidityPack,
    soliditySHA3: $69c990c37a181156$var$soliditySHA3
};

});


parcelRegister("6TzQe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.APP_VERSION_KEY = module.exports.LOCAL_STORAGE_ADDRESSES_KEY = module.exports.WALLET_USER_NAME_KEY = void 0;
module.exports.WALLET_USER_NAME_KEY = "walletUsername";
module.exports.LOCAL_STORAGE_ADDRESSES_KEY = "Addresses";
module.exports.APP_VERSION_KEY = "AppVersion";

});

parcelRegister("jFncN", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RelayEventManager = void 0;

var $lBX3m = parcelRequire("lBX3m");
var $e513d8c40b6c174e$var$RelayEventManager = /*#__PURE__*/ function() {
    function RelayEventManager() {
        (0, $4GJKx._)(this, RelayEventManager);
        this._nextRequestId = 0;
        this.callbacks = new Map();
    }
    (0, $1wc17._)(RelayEventManager, [
        {
            key: "makeRequestId",
            value: function makeRequestId() {
                // max nextId == max int32 for compatibility with mobile
                this._nextRequestId = (this._nextRequestId + 1) % 0x7fffffff;
                var id = this._nextRequestId;
                var idStr = (0, $lBX3m.prepend0x)(id.toString(16));
                // unlikely that this will ever be an issue, but just to be safe
                var callback = this.callbacks.get(idStr);
                if (callback) this.callbacks.delete(idStr);
                return id;
            }
        }
    ]);
    return RelayEventManager;
}();
module.exports.RelayEventManager = $e513d8c40b6c174e$var$RelayEventManager;

});

parcelRegister("iaz6m", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
"use strict";
// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletLinkRelay = void 0;

var $7ch9Z = parcelRequire("7ch9Z");

var $6TzQe = parcelRequire("6TzQe");

var $jFncN = parcelRequire("jFncN");

var $8l7I1 = parcelRequire("8l7I1");

var $cJCoI = parcelRequire("cJCoI");

var $5XDHL = parcelRequire("5XDHL");

var $2dFjj = parcelRequire("2dFjj");

var $ir4DJ = parcelRequire("ir4DJ");

var $gBAGR = parcelRequire("gBAGR");

var $lBX3m = parcelRequire("lBX3m");

var $ao3Zq = parcelRequire("ao3Zq");
var $d3a4639bcc226f52$var$WalletLinkRelay = /*#__PURE__*/ function() {
    function WalletLinkRelay(options) {
        var _this = this;
        (0, $4GJKx._)(this, WalletLinkRelay);
        this.accountsCallback = null;
        this.chainCallbackParams = {
            chainId: "",
            jsonRpcUrl: ""
        }; // to implement distinctUntilChanged
        this.chainCallback = null;
        this.dappDefaultChain = 1;
        this.isMobileWeb = (0, $5XDHL.isMobileWeb)();
        this.appName = "";
        this.appLogoUrl = null;
        this.linkedUpdated = function(linked) {
            _this.isLinked = linked;
            var cachedAddresses = _this.storage.getItem($6TzQe.LOCAL_STORAGE_ADDRESSES_KEY);
            if (linked) // Only set linked session variable one way
            _this._session.linked = linked;
            _this.isUnlinkedErrorState = false;
            if (cachedAddresses) {
                var addresses = cachedAddresses.split(" ");
                var wasConnectedViaStandalone = _this.storage.getItem("IsStandaloneSigning") === "true";
                if (addresses[0] !== "" && !linked && _this._session.linked && !wasConnectedViaStandalone) _this.isUnlinkedErrorState = true;
            }
        };
        this.metadataUpdated = function(key, value) {
            _this.storage.setItem(key, value);
        };
        this.chainUpdated = function(chainId, jsonRpcUrl) {
            if (_this.chainCallbackParams.chainId === chainId && _this.chainCallbackParams.jsonRpcUrl === jsonRpcUrl) return;
            _this.chainCallbackParams = {
                chainId: chainId,
                jsonRpcUrl: jsonRpcUrl
            };
            if (_this.chainCallback) _this.chainCallback(chainId, jsonRpcUrl);
        };
        this.accountUpdated = function(selectedAddress) {
            if (_this.accountsCallback) _this.accountsCallback([
                selectedAddress
            ]);
            if (WalletLinkRelay.accountRequestCallbackIds.size > 0) {
                // We get the ethereum address from the metadata.  If for whatever
                // reason we don't get a response via an explicit web3 message
                // we can still fulfill the eip1102 request.
                Array.from(WalletLinkRelay.accountRequestCallbackIds.values()).forEach(function(id) {
                    var message = {
                        type: "WEB3_RESPONSE",
                        id: id,
                        response: {
                            method: "requestEthereumAccounts",
                            result: [
                                selectedAddress
                            ]
                        }
                    };
                    _this.invokeCallback(Object.assign(Object.assign({}, message), {
                        id: id
                    }));
                });
                WalletLinkRelay.accountRequestCallbackIds.clear();
            }
        };
        this.resetAndReload = this.resetAndReload.bind(this);
        this.linkAPIUrl = options.linkAPIUrl;
        this.storage = options.storage;
        var _this_subscribe = this.subscribe(), session = _this_subscribe.session, ui = _this_subscribe.ui, connection = _this_subscribe.connection;
        this._session = session;
        this.connection = connection;
        this.relayEventManager = new $jFncN.RelayEventManager();
        this.ui = ui;
    }
    (0, $1wc17._)(WalletLinkRelay, [
        {
            key: "subscribe",
            value: function subscribe() {
                var session = $8l7I1.WalletLinkSession.load(this.storage) || new $8l7I1.WalletLinkSession(this.storage).save();
                var linkAPIUrl = this.linkAPIUrl;
                var connection = new $7ch9Z.WalletLinkConnection({
                    session: session,
                    linkAPIUrl: linkAPIUrl,
                    listener: this
                });
                var ui = this.isMobileWeb ? new $ir4DJ.WLMobileRelayUI() : new $2dFjj.WalletLinkRelayUI();
                connection.connect();
                return {
                    session: session,
                    ui: ui,
                    connection: connection
                };
            }
        },
        {
            key: "attachUI",
            value: function attachUI() {
                this.ui.attach();
            }
        },
        {
            key: "resetAndReload",
            value: function resetAndReload() {
                var _this = this;
                Promise.race([
                    this.connection.setSessionMetadata("__destroyed", "1"),
                    new Promise(function(resolve) {
                        return setTimeout(function() {
                            return resolve(null);
                        }, 1000);
                    })
                ]).then(function() {
                    _this.connection.destroy();
                    /**
             * Only clear storage if the session id we have in memory matches the one on disk
             * Otherwise, in the case where we have 2 tabs, another tab might have cleared
             * storage already.  In that case if we clear storage again, the user will be in
             * a state where the first tab allows the user to connect but the session that
             * was used isn't persisted.  This leaves the user in a state where they aren't
             * connected to the mobile app.
             */ var storedSession = $8l7I1.WalletLinkSession.load(_this.storage);
                    if ((storedSession === null || storedSession === void 0 ? void 0 : storedSession.id) === _this._session.id) $ao3Zq.ScopedLocalStorage.clearAll();
                    document.location.reload();
                }).catch(function(_) {});
            }
        },
        {
            key: "setAppInfo",
            value: function setAppInfo(appName, appLogoUrl) {
                this.appName = appName;
                this.appLogoUrl = appLogoUrl;
            }
        },
        {
            key: "getStorageItem",
            value: function getStorageItem(key) {
                return this.storage.getItem(key);
            }
        },
        {
            key: "setStorageItem",
            value: function setStorageItem(key, value) {
                this.storage.setItem(key, value);
            }
        },
        {
            key: "signEthereumMessage",
            value: function signEthereumMessage(message, address, addPrefix, typedDataJson) {
                return this.sendRequest({
                    method: "signEthereumMessage",
                    params: {
                        message: (0, $lBX3m.hexStringFromBuffer)(message, true),
                        address: address,
                        addPrefix: addPrefix,
                        typedDataJson: typedDataJson || null
                    }
                });
            }
        },
        {
            key: "ethereumAddressFromSignedMessage",
            value: function ethereumAddressFromSignedMessage(message, signature, addPrefix) {
                return this.sendRequest({
                    method: "ethereumAddressFromSignedMessage",
                    params: {
                        message: (0, $lBX3m.hexStringFromBuffer)(message, true),
                        signature: (0, $lBX3m.hexStringFromBuffer)(signature, true),
                        addPrefix: addPrefix
                    }
                });
            }
        },
        {
            key: "signEthereumTransaction",
            value: function signEthereumTransaction(params) {
                return this.sendRequest({
                    method: "signEthereumTransaction",
                    params: {
                        fromAddress: params.fromAddress,
                        toAddress: params.toAddress,
                        weiValue: (0, $lBX3m.bigIntStringFromBigInt)(params.weiValue),
                        data: (0, $lBX3m.hexStringFromBuffer)(params.data, true),
                        nonce: params.nonce,
                        gasPriceInWei: params.gasPriceInWei ? (0, $lBX3m.bigIntStringFromBigInt)(params.gasPriceInWei) : null,
                        maxFeePerGas: params.gasPriceInWei ? (0, $lBX3m.bigIntStringFromBigInt)(params.gasPriceInWei) : null,
                        maxPriorityFeePerGas: params.gasPriceInWei ? (0, $lBX3m.bigIntStringFromBigInt)(params.gasPriceInWei) : null,
                        gasLimit: params.gasLimit ? (0, $lBX3m.bigIntStringFromBigInt)(params.gasLimit) : null,
                        chainId: params.chainId,
                        shouldSubmit: false
                    }
                });
            }
        },
        {
            key: "signAndSubmitEthereumTransaction",
            value: function signAndSubmitEthereumTransaction(params) {
                return this.sendRequest({
                    method: "signEthereumTransaction",
                    params: {
                        fromAddress: params.fromAddress,
                        toAddress: params.toAddress,
                        weiValue: (0, $lBX3m.bigIntStringFromBigInt)(params.weiValue),
                        data: (0, $lBX3m.hexStringFromBuffer)(params.data, true),
                        nonce: params.nonce,
                        gasPriceInWei: params.gasPriceInWei ? (0, $lBX3m.bigIntStringFromBigInt)(params.gasPriceInWei) : null,
                        maxFeePerGas: params.maxFeePerGas ? (0, $lBX3m.bigIntStringFromBigInt)(params.maxFeePerGas) : null,
                        maxPriorityFeePerGas: params.maxPriorityFeePerGas ? (0, $lBX3m.bigIntStringFromBigInt)(params.maxPriorityFeePerGas) : null,
                        gasLimit: params.gasLimit ? (0, $lBX3m.bigIntStringFromBigInt)(params.gasLimit) : null,
                        chainId: params.chainId,
                        shouldSubmit: true
                    }
                });
            }
        },
        {
            key: "submitEthereumTransaction",
            value: function submitEthereumTransaction(signedTransaction, chainId) {
                return this.sendRequest({
                    method: "submitEthereumTransaction",
                    params: {
                        signedTransaction: (0, $lBX3m.hexStringFromBuffer)(signedTransaction, true),
                        chainId: chainId
                    }
                });
            }
        },
        {
            key: "scanQRCode",
            value: function scanQRCode(regExp) {
                return this.sendRequest({
                    method: "scanQRCode",
                    params: {
                        regExp: regExp
                    }
                });
            }
        },
        {
            key: "getWalletLinkSession",
            value: function getWalletLinkSession() {
                return this._session;
            }
        },
        {
            key: "genericRequest",
            value: function genericRequest(data, action) {
                return this.sendRequest({
                    method: "generic",
                    params: {
                        action: action,
                        data: data
                    }
                });
            }
        },
        {
            key: "sendGenericMessage",
            value: function sendGenericMessage(request) {
                return this.sendRequest(request);
            }
        },
        {
            key: "sendRequest",
            value: function sendRequest(request) {
                var _this = this;
                var hideSnackbarItem = null;
                var id = (0, $lBX3m.randomBytesHex)(8);
                var cancel = function(error) {
                    _this.publishWeb3RequestCanceledEvent(id);
                    _this.handleErrorResponse(id, request.method, error);
                    hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                };
                return new Promise(function(resolve, reject) {
                    hideSnackbarItem = _this.ui.showConnecting({
                        isUnlinkedErrorState: _this.isUnlinkedErrorState,
                        onCancel: cancel,
                        onResetConnection: _this.resetAndReload
                    });
                    _this.relayEventManager.callbacks.set(id, function(response) {
                        hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                        if ((0, $cJCoI.isErrorResponse)(response)) return reject(new Error(response.errorMessage));
                        resolve(response);
                    });
                    _this.publishWeb3RequestEvent(id, request);
                });
            }
        },
        {
            key: "setAccountsCallback",
            value: function setAccountsCallback(accountsCallback) {
                this.accountsCallback = accountsCallback;
            }
        },
        {
            key: "setChainCallback",
            value: function setChainCallback(chainCallback) {
                this.chainCallback = chainCallback;
            }
        },
        {
            key: "setDappDefaultChainCallback",
            value: function setDappDefaultChainCallback(chainId) {
                this.dappDefaultChain = chainId;
            }
        },
        {
            key: "publishWeb3RequestEvent",
            value: function publishWeb3RequestEvent(id, request) {
                var _this = this;
                var message = {
                    type: "WEB3_REQUEST",
                    id: id,
                    request: request
                };
                this.publishEvent("Web3Request", message, true).then(function(_) {}).catch(function(err) {
                    _this.handleWeb3ResponseMessage({
                        type: "WEB3_RESPONSE",
                        id: message.id,
                        response: {
                            method: request.method,
                            errorMessage: err.message
                        }
                    });
                });
                if (this.isMobileWeb) this.openCoinbaseWalletDeeplink(request.method);
            }
        },
        {
            // copied from MobileRelay
            key: "openCoinbaseWalletDeeplink",
            value: function openCoinbaseWalletDeeplink(method) {
                var _this = this;
                if (!(this.ui instanceof $ir4DJ.WLMobileRelayUI)) return;
                // For mobile relay requests, open the Coinbase Wallet app
                switch(method){
                    case "requestEthereumAccounts":
                    case "switchEthereumChain":
                        return;
                    default:
                        window.addEventListener("blur", function() {
                            window.addEventListener("focus", function() {
                                _this.connection.checkUnseenEvents();
                            }, {
                                once: true
                            });
                        }, {
                            once: true
                        });
                        this.ui.openCoinbaseWalletDeeplink();
                        break;
                }
            }
        },
        {
            key: "publishWeb3RequestCanceledEvent",
            value: function publishWeb3RequestCanceledEvent(id) {
                var message = {
                    type: "WEB3_REQUEST_CANCELED",
                    id: id
                };
                this.publishEvent("Web3RequestCanceled", message, false).then();
            }
        },
        {
            key: "publishEvent",
            value: function publishEvent(event, message, callWebhook) {
                return this.connection.publishEvent(event, message, callWebhook);
            }
        },
        {
            key: "handleWeb3ResponseMessage",
            value: function handleWeb3ResponseMessage(message) {
                var _this = this;
                var response = message.response;
                if (response.method === "requestEthereumAccounts") {
                    WalletLinkRelay.accountRequestCallbackIds.forEach(function(id) {
                        return _this.invokeCallback(Object.assign(Object.assign({}, message), {
                            id: id
                        }));
                    });
                    WalletLinkRelay.accountRequestCallbackIds.clear();
                    return;
                }
                this.invokeCallback(message);
            }
        },
        {
            key: "handleErrorResponse",
            value: function handleErrorResponse(id, method, error) {
                var _a;
                var errorMessage = (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : "Unspecified error message.";
                this.handleWeb3ResponseMessage({
                    type: "WEB3_RESPONSE",
                    id: id,
                    response: {
                        method: method,
                        errorMessage: errorMessage
                    }
                });
            }
        },
        {
            key: "invokeCallback",
            value: function invokeCallback(message) {
                var callback = this.relayEventManager.callbacks.get(message.id);
                if (callback) {
                    callback(message.response);
                    this.relayEventManager.callbacks.delete(message.id);
                }
            }
        },
        {
            key: "requestEthereumAccounts",
            value: function requestEthereumAccounts() {
                var _this = this;
                var request = {
                    method: "requestEthereumAccounts",
                    params: {
                        appName: this.appName,
                        appLogoUrl: this.appLogoUrl || null
                    }
                };
                var hideSnackbarItem = null;
                var id = (0, $lBX3m.randomBytesHex)(8);
                return new Promise(function(resolve, reject) {
                    _this.relayEventManager.callbacks.set(id, function(response) {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                        if ((0, $cJCoI.isErrorResponse)(response)) return reject(new Error(response.errorMessage));
                        resolve(response);
                    });
                    WalletLinkRelay.accountRequestCallbackIds.add(id);
                    _this.publishWeb3RequestEvent(id, request);
                });
            }
        },
        {
            key: "watchAsset",
            value: function watchAsset(type, address, symbol, decimals, image, chainId) {
                var _this = this;
                var request = {
                    method: "watchAsset",
                    params: {
                        type: type,
                        options: {
                            address: address,
                            symbol: symbol,
                            decimals: decimals,
                            image: image
                        },
                        chainId: chainId
                    }
                };
                var hideSnackbarItem = null;
                var id = (0, $lBX3m.randomBytesHex)(8);
                var cancel = function(error) {
                    _this.publishWeb3RequestCanceledEvent(id);
                    _this.handleErrorResponse(id, request.method, error);
                    hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                };
                hideSnackbarItem = this.ui.showConnecting({
                    isUnlinkedErrorState: this.isUnlinkedErrorState,
                    onCancel: cancel,
                    onResetConnection: this.resetAndReload
                });
                return new Promise(function(resolve, reject) {
                    _this.relayEventManager.callbacks.set(id, function(response) {
                        hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                        if ((0, $cJCoI.isErrorResponse)(response)) return reject(new Error(response.errorMessage));
                        resolve(response);
                    });
                    _this.publishWeb3RequestEvent(id, request);
                });
            }
        },
        {
            key: "addEthereumChain",
            value: function addEthereumChain(chainId, rpcUrls, iconUrls, blockExplorerUrls, chainName, nativeCurrency) {
                var _this = this;
                var request = {
                    method: "addEthereumChain",
                    params: {
                        chainId: chainId,
                        rpcUrls: rpcUrls,
                        blockExplorerUrls: blockExplorerUrls,
                        chainName: chainName,
                        iconUrls: iconUrls,
                        nativeCurrency: nativeCurrency
                    }
                };
                var hideSnackbarItem = null;
                var id = (0, $lBX3m.randomBytesHex)(8);
                var cancel = function(error) {
                    _this.publishWeb3RequestCanceledEvent(id);
                    _this.handleErrorResponse(id, request.method, error);
                    hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                };
                hideSnackbarItem = this.ui.showConnecting({
                    isUnlinkedErrorState: this.isUnlinkedErrorState,
                    onCancel: cancel,
                    onResetConnection: this.resetAndReload
                });
                return new Promise(function(resolve, reject) {
                    _this.relayEventManager.callbacks.set(id, function(response) {
                        hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                        if ((0, $cJCoI.isErrorResponse)(response)) return reject(new Error(response.errorMessage));
                        resolve(response);
                    });
                    _this.publishWeb3RequestEvent(id, request);
                });
            }
        },
        {
            key: "switchEthereumChain",
            value: function switchEthereumChain(chainId, address) {
                var _this = this;
                var request = {
                    method: "switchEthereumChain",
                    params: Object.assign({
                        chainId: chainId
                    }, {
                        address: address
                    })
                };
                var id = (0, $lBX3m.randomBytesHex)(8);
                return new Promise(function(resolve, reject) {
                    _this.relayEventManager.callbacks.set(id, function(response) {
                        if ((0, $cJCoI.isErrorResponse)(response) && response.errorCode) return reject($gBAGR.standardErrors.provider.custom({
                            code: response.errorCode,
                            message: "Unrecognized chain ID. Try adding the chain using addEthereumChain first."
                        }));
                        else if ((0, $cJCoI.isErrorResponse)(response)) return reject(new Error(response.errorMessage));
                        resolve(response);
                    });
                    _this.publishWeb3RequestEvent(id, request);
                });
            }
        }
    ]);
    return WalletLinkRelay;
}();
module.exports.WalletLinkRelay = $d3a4639bcc226f52$var$WalletLinkRelay;
$d3a4639bcc226f52$var$WalletLinkRelay.accountRequestCallbackIds = new Set();

});
parcelRegister("7ch9Z", function(module, exports) {

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $eha6O = parcelRequire("eha6O");
"use strict";
// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletLinkConnection = void 0;

var $6TzQe = parcelRequire("6TzQe");

var $bttr8 = parcelRequire("bttr8");

var $9e6l6 = parcelRequire("9e6l6");

var $3MVC0 = parcelRequire("3MVC0");

var $8JTtR = parcelRequire("8JTtR");
var $53d6f70be4ccb546$var$HEARTBEAT_INTERVAL = 10000;
var $53d6f70be4ccb546$var$REQUEST_TIMEOUT = 60000;
/**
 * Coinbase Wallet Connection
 */ var $53d6f70be4ccb546$var$WalletLinkConnection = /*#__PURE__*/ function() {
    function WalletLinkConnection(param) {
        var _this = this;
        var session = param.session, linkAPIUrl = param.linkAPIUrl, listener = param.listener, _param_WebSocketClass = param.WebSocketClass, WebSocketClass = _param_WebSocketClass === void 0 ? WebSocket : _param_WebSocketClass;
        (0, $4GJKx._)(this, WalletLinkConnection);
        this.destroyed = false;
        this.lastHeartbeatResponse = 0;
        this.nextReqId = (0, $8JTtR.IntNumber)(1);
        /**
         * true if connected and authenticated, else false
         * runs listener when connected status changes
         */ this._connected = false;
        /**
         * true if linked (a guest has joined before)
         * runs listener when linked status changes
         */ this._linked = false;
        this.shouldFetchUnseenEventsOnConnect = false;
        this.requestResolutions = new Map();
        this.handleSessionMetadataUpdated = function(metadata) {
            if (!metadata) return;
            // Map of metadata key to handler function
            var handlers = new Map([
                [
                    "__destroyed",
                    _this.handleDestroyed
                ],
                [
                    "EthereumAddress",
                    _this.handleAccountUpdated
                ],
                [
                    "WalletUsername",
                    _this.handleWalletUsernameUpdated
                ],
                [
                    "AppVersion",
                    _this.handleAppVersionUpdated
                ],
                [
                    "ChainId",
                    function(v) {
                        return metadata.JsonRpcUrl && _this.handleChainUpdated(v, metadata.JsonRpcUrl);
                    }
                ]
            ]);
            // call handler for each metadata key if value is defined
            handlers.forEach(function(handler, key) {
                var value = metadata[key];
                if (value === undefined) return;
                handler(value);
            });
        };
        this.handleDestroyed = function(__destroyed) {
            var _a;
            if (__destroyed !== "1") return;
            (_a = _this.listener) === null || _a === void 0 || _a.resetAndReload();
        };
        var _this1 = this;
        this.handleAccountUpdated = function() {
            var _ref = (0, $kSuI9._)(function(encryptedEthereumAddress) {
                var _a, address;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this1.cipher.decrypt(encryptedEthereumAddress)
                            ];
                        case 1:
                            address = _state.sent();
                            (_a = _this1.listener) === null || _a === void 0 || _a.accountUpdated(address);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(encryptedEthereumAddress) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this2 = this;
        this.handleMetadataUpdated = function() {
            var _ref = (0, $kSuI9._)(function(key, encryptedMetadataValue) {
                var _a, decryptedValue;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this2.cipher.decrypt(encryptedMetadataValue)
                            ];
                        case 1:
                            decryptedValue = _state.sent();
                            (_a = _this2.listener) === null || _a === void 0 || _a.metadataUpdated(key, decryptedValue);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(key, encryptedMetadataValue) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this3 = this;
        this.handleWalletUsernameUpdated = function() {
            var _ref = (0, $kSuI9._)(function(walletUsername) {
                return (0, $eha6O.__generator)(this, function(_state) {
                    _this3.handleMetadataUpdated($6TzQe.WALLET_USER_NAME_KEY, walletUsername);
                    return [
                        2
                    ];
                });
            });
            return function(walletUsername) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this4 = this;
        this.handleAppVersionUpdated = function() {
            var _ref = (0, $kSuI9._)(function(appVersion) {
                return (0, $eha6O.__generator)(this, function(_state) {
                    _this4.handleMetadataUpdated($6TzQe.APP_VERSION_KEY, appVersion);
                    return [
                        2
                    ];
                });
            });
            return function(appVersion) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this5 = this;
        this.handleChainUpdated = function() {
            var _ref = (0, $kSuI9._)(function(encryptedChainId, encryptedJsonRpcUrl) {
                var _a, chainId, jsonRpcUrl;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this5.cipher.decrypt(encryptedChainId)
                            ];
                        case 1:
                            chainId = _state.sent();
                            return [
                                4,
                                _this5.cipher.decrypt(encryptedJsonRpcUrl)
                            ];
                        case 2:
                            jsonRpcUrl = _state.sent();
                            (_a = _this5.listener) === null || _a === void 0 || _a.chainUpdated(chainId, jsonRpcUrl);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(encryptedChainId, encryptedJsonRpcUrl) {
                return _ref.apply(this, arguments);
            };
        }();
        this.session = session;
        this.cipher = new $bttr8.WalletLinkCipher(session.secret);
        this.listener = listener;
        var ws = new $3MVC0.WalletLinkWebSocket("".concat(linkAPIUrl, "/rpc"), WebSocketClass);
        var _this6 = this;
        ws.setConnectionStateListener(function() {
            var _ref = (0, $kSuI9._)(function(state) {
                var connected, connect, _a;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            // attempt to reconnect every 5 seconds when disconnected
                            connected = false;
                            switch(state){
                                case $3MVC0.ConnectionState.DISCONNECTED:
                                    return [
                                        3,
                                        1
                                    ];
                                case $3MVC0.ConnectionState.CONNECTED:
                                    return [
                                        3,
                                        2
                                    ];
                                case $3MVC0.ConnectionState.CONNECTING:
                                    return [
                                        3,
                                        6
                                    ];
                            }
                            return [
                                3,
                                7
                            ];
                        case 1:
                            // if DISCONNECTED and not destroyed
                            if (!_this6.destroyed) {
                                connect = function() {
                                    var _ref = (0, $kSuI9._)(function() {
                                        return (0, $eha6O.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    // wait 5 seconds
                                                    return [
                                                        4,
                                                        new Promise(function(resolve) {
                                                            return setTimeout(resolve, 5000);
                                                        })
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    // check whether it's destroyed again
                                                    if (!_this6.destroyed) // reconnect
                                                    ws.connect().catch(function() {
                                                        connect();
                                                    });
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function connect() {
                                        return _ref.apply(this, arguments);
                                    };
                                }();
                                connect();
                            }
                            return [
                                3,
                                7
                            ];
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            // if CONNECTED, authenticate, and then check link status
                            return [
                                4,
                                _this6.authenticate()
                            ];
                        case 3:
                            _state.sent();
                            _this6.sendIsLinked();
                            _this6.sendGetSessionConfig();
                            connected = true;
                            return [
                                3,
                                5
                            ];
                        case 4:
                            _a = _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 5:
                            // send heartbeat every n seconds while connected
                            // if CONNECTED, start the heartbeat timer
                            // first timer event updates lastHeartbeat timestamp
                            // subsequent calls send heartbeat message
                            _this6.updateLastHeartbeat();
                            setInterval(function() {
                                _this6.heartbeat();
                            }, $53d6f70be4ccb546$var$HEARTBEAT_INTERVAL);
                            // check for unseen events
                            if (_this6.shouldFetchUnseenEventsOnConnect) _this6.fetchUnseenEventsAPI();
                            return [
                                3,
                                7
                            ];
                        case 6:
                            return [
                                3,
                                7
                            ];
                        case 7:
                            // distinctUntilChanged
                            if (_this6.connected !== connected) _this6.connected = connected;
                            return [
                                2
                            ];
                    }
                });
            });
            return function(state) {
                return _ref.apply(this, arguments);
            };
        }());
        ws.setIncomingDataListener(function(m) {
            var _a;
            switch(m.type){
                // handle server's heartbeat responses
                case "Heartbeat":
                    _this.updateLastHeartbeat();
                    return;
                // handle link status updates
                case "IsLinkedOK":
                case "Linked":
                    {
                        var linked = m.type === "IsLinkedOK" ? m.linked : undefined;
                        _this.linked = linked || m.onlineGuests > 0;
                        break;
                    }
                // handle session config updates
                case "GetSessionConfigOK":
                case "SessionConfigUpdated":
                    _this.handleSessionMetadataUpdated(m.metadata);
                    break;
                case "Event":
                    _this.handleIncomingEvent(m);
                    break;
            }
            // resolve request promises
            if (m.id !== undefined) (_a = _this.requestResolutions.get(m.id)) === null || _a === void 0 || _a(m);
        });
        this.ws = ws;
        this.http = new $9e6l6.WalletLinkHTTP(linkAPIUrl, session.id, session.key);
    }
    (0, $1wc17._)(WalletLinkConnection, [
        {
            /**
     * Make a connection to the server
     */ key: "connect",
            value: function connect() {
                if (this.destroyed) throw new Error("instance is destroyed");
                this.ws.connect();
            }
        },
        {
            /**
     * Terminate connection, and mark as destroyed. To reconnect, create a new
     * instance of WalletSDKConnection
     */ key: "destroy",
            value: function destroy() {
                this.destroyed = true;
                this.ws.disconnect();
                this.listener = undefined;
            }
        },
        {
            key: "isDestroyed",
            get: function get() {
                return this.destroyed;
            }
        },
        {
            key: "connected",
            get: function get() {
                return this._connected;
            },
            set: function set(connected) {
                var _a;
                this._connected = connected;
                if (connected) (_a = this.onceConnected) === null || _a === void 0 || _a.call(this);
            }
        },
        {
            key: "setOnceConnected",
            value: function setOnceConnected(callback) {
                var _this = this;
                return new Promise(function(resolve) {
                    if (_this.connected) callback().then(resolve);
                    else _this.onceConnected = function() {
                        callback().then(resolve);
                        _this.onceConnected = undefined;
                    };
                });
            }
        },
        {
            key: "linked",
            get: function get() {
                return this._linked;
            },
            set: function set(linked) {
                var _a, _b;
                this._linked = linked;
                if (linked) (_a = this.onceLinked) === null || _a === void 0 || _a.call(this);
                (_b = this.listener) === null || _b === void 0 || _b.linkedUpdated(linked);
            }
        },
        {
            key: "setOnceLinked",
            value: function setOnceLinked(callback) {
                var _this = this;
                return new Promise(function(resolve) {
                    if (_this.linked) callback().then(resolve);
                    else _this.onceLinked = function() {
                        callback().then(resolve);
                        _this.onceLinked = undefined;
                    };
                });
            }
        },
        {
            key: "handleIncomingEvent",
            value: function handleIncomingEvent(m) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _a, decryptedData, message;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (m.type !== "Event" || m.event !== "Web3Response") return [
                                    2
                                ];
                                return [
                                    4,
                                    _this.cipher.decrypt(m.data)
                                ];
                            case 1:
                                decryptedData = _state.sent();
                                message = JSON.parse(decryptedData);
                                if (message.type !== "WEB3_RESPONSE") return [
                                    2
                                ];
                                (_a = _this.listener) === null || _a === void 0 || _a.handleWeb3ResponseMessage(message);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "checkUnseenEvents",
            value: function checkUnseenEvents() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.connected) {
                                    _this.shouldFetchUnseenEventsOnConnect = true;
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        return setTimeout(resolve, 250);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    _this.fetchUnseenEventsAPI()
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e = _state.sent();
                                console.error("Unable to check for unseen events", e);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchUnseenEventsAPI",
            value: function fetchUnseenEventsAPI() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var responseEvents;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.shouldFetchUnseenEventsOnConnect = false;
                                return [
                                    4,
                                    _this.http.fetchUnseenEvents()
                                ];
                            case 1:
                                responseEvents = _state.sent();
                                responseEvents.forEach(function(e) {
                                    return _this.handleIncomingEvent(e);
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setSessionMetadata",
            value: /**
     * Set session metadata in SessionConfig object
     * @param key
     * @param value
     * @returns a Promise that completes when successful
     */ function setSessionMetadata(key, value) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var message;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        message = {
                            type: "SetSessionConfig",
                            id: (0, $8JTtR.IntNumber)(_this.nextReqId++),
                            sessionId: _this.session.id,
                            metadata: (0, $3sHb8._)({}, key, value)
                        };
                        return [
                            2,
                            _this.setOnceConnected(/*#__PURE__*/ (0, $kSuI9._)(function() {
                                var res;
                                return (0, $eha6O.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                _this.makeRequest(message)
                                            ];
                                        case 1:
                                            res = _state.sent();
                                            if (res.type === "Fail") throw new Error(res.error || "failed to set session metadata");
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }))
                        ];
                    });
                })();
            }
        },
        {
            key: "publishEvent",
            value: /**
     * Publish an event and emit event ID when successful
     * @param event event name
     * @param unencryptedData unencrypted event data
     * @param callWebhook whether the webhook should be invoked
     * @returns a Promise that emits event ID when successful
     */ function publishEvent(event, unencryptedData) {
                var callWebhook = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var data, message;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.cipher.encrypt(JSON.stringify(Object.assign(Object.assign({}, unencryptedData), {
                                        origin: location.origin,
                                        relaySource: "coinbaseWalletExtension" in window && window.coinbaseWalletExtension ? "injected_sdk" : "sdk"
                                    })))
                                ];
                            case 1:
                                data = _state.sent();
                                message = {
                                    type: "PublishEvent",
                                    id: (0, $8JTtR.IntNumber)(_this.nextReqId++),
                                    sessionId: _this.session.id,
                                    event: event,
                                    data: data,
                                    callWebhook: callWebhook
                                };
                                return [
                                    2,
                                    _this.setOnceLinked(/*#__PURE__*/ (0, $kSuI9._)(function() {
                                        var res;
                                        return (0, $eha6O.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        _this.makeRequest(message)
                                                    ];
                                                case 1:
                                                    res = _state.sent();
                                                    if (res.type === "Fail") throw new Error(res.error || "failed to publish event");
                                                    return [
                                                        2,
                                                        res.eventId
                                                    ];
                                            }
                                        });
                                    }))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendData",
            value: function sendData(message) {
                this.ws.sendData(JSON.stringify(message));
            }
        },
        {
            key: "updateLastHeartbeat",
            value: function updateLastHeartbeat() {
                this.lastHeartbeatResponse = Date.now();
            }
        },
        {
            key: "heartbeat",
            value: function heartbeat() {
                if (Date.now() - this.lastHeartbeatResponse > $53d6f70be4ccb546$var$HEARTBEAT_INTERVAL * 2) {
                    this.ws.disconnect();
                    return;
                }
                try {
                    this.ws.sendData("h");
                } catch (_a) {
                // noop
                }
            }
        },
        {
            key: "makeRequest",
            value: function makeRequest(message) {
                var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $53d6f70be4ccb546$var$REQUEST_TIMEOUT;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var reqId, timeoutId;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        reqId = message.id;
                        _this.sendData(message);
                        return [
                            2,
                            Promise.race([
                                new Promise(function(_, reject) {
                                    timeoutId = window.setTimeout(function() {
                                        reject(new Error("request ".concat(reqId, " timed out")));
                                    }, timeout);
                                }),
                                new Promise(function(resolve) {
                                    _this.requestResolutions.set(reqId, function(m) {
                                        clearTimeout(timeoutId); // clear the timeout
                                        resolve(m);
                                        _this.requestResolutions.delete(reqId);
                                    });
                                })
                            ])
                        ];
                    });
                })();
            }
        },
        {
            key: "authenticate",
            value: function authenticate() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var m, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                m = {
                                    type: "HostSession",
                                    id: (0, $8JTtR.IntNumber)(_this.nextReqId++),
                                    sessionId: _this.session.id,
                                    sessionKey: _this.session.key
                                };
                                return [
                                    4,
                                    _this.makeRequest(m)
                                ];
                            case 1:
                                res = _state.sent();
                                if (res.type === "Fail") throw new Error(res.error || "failed to authenticate");
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendIsLinked",
            value: function sendIsLinked() {
                var m = {
                    type: "IsLinked",
                    id: (0, $8JTtR.IntNumber)(this.nextReqId++),
                    sessionId: this.session.id
                };
                this.sendData(m);
            }
        },
        {
            key: "sendGetSessionConfig",
            value: function sendGetSessionConfig() {
                var m = {
                    type: "GetSessionConfig",
                    id: (0, $8JTtR.IntNumber)(this.nextReqId++),
                    sessionId: this.session.id
                };
                this.sendData(m);
            }
        }
    ]);
    return WalletLinkConnection;
}();
module.exports.WalletLinkConnection = $53d6f70be4ccb546$var$WalletLinkConnection;

});
parcelRegister("bttr8", function(module, exports) {

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");
"use strict";
// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletLinkCipher = void 0;

var $lBX3m = parcelRequire("lBX3m");
var $85a93cace4eec7a7$var$WalletLinkCipher = /*#__PURE__*/ function() {
    function WalletLinkCipher(secret) {
        (0, $4GJKx._)(this, WalletLinkCipher);
        this.secret = secret;
    }
    (0, $1wc17._)(WalletLinkCipher, [
        {
            key: "encrypt",
            value: /**
     *
     * @param plainText string to be encrypted
     * returns hex string representation of bytes in the order: initialization vector (iv),
     * auth tag, encrypted plaintext. IV is 12 bytes. Auth tag is 16 bytes. Remaining bytes are the
     * encrypted plainText.
     */ function encrypt(plainText) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var secret, ivBytes, secretKey, enc, encryptedResult, tagLength, authTag, encryptedPlaintext, authTagBytes, encryptedPlaintextBytes, concatted;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                secret = _this.secret;
                                if (secret.length !== 64) throw Error("secret must be 256 bits");
                                ivBytes = crypto.getRandomValues(new Uint8Array(12));
                                return [
                                    4,
                                    crypto.subtle.importKey("raw", (0, $lBX3m.hexStringToUint8Array)(secret), {
                                        name: "aes-gcm"
                                    }, false, [
                                        "encrypt",
                                        "decrypt"
                                    ])
                                ];
                            case 1:
                                secretKey = _state.sent();
                                enc = new TextEncoder();
                                return [
                                    4,
                                    window.crypto.subtle.encrypt({
                                        name: "AES-GCM",
                                        iv: ivBytes
                                    }, secretKey, enc.encode(plainText))
                                ];
                            case 2:
                                encryptedResult = _state.sent();
                                tagLength = 16;
                                authTag = encryptedResult.slice(encryptedResult.byteLength - tagLength);
                                encryptedPlaintext = encryptedResult.slice(0, encryptedResult.byteLength - tagLength);
                                authTagBytes = new Uint8Array(authTag);
                                encryptedPlaintextBytes = new Uint8Array(encryptedPlaintext);
                                concatted = new Uint8Array((0, $c6Xmf._)(ivBytes).concat((0, $c6Xmf._)(authTagBytes), (0, $c6Xmf._)(encryptedPlaintextBytes)));
                                return [
                                    2,
                                    (0, $lBX3m.uint8ArrayToHex)(concatted)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "decrypt",
            value: /**
     *
     * @param cipherText hex string representation of bytes in the order: initialization vector (iv),
     * auth tag, encrypted plaintext. IV is 12 bytes. Auth tag is 16 bytes.
     */ function decrypt(cipherText) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var secret;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        secret = _this.secret;
                        if (secret.length !== 64) throw Error("secret must be 256 bits");
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                (0, $kSuI9._)(function() {
                                    var secretKey, encrypted, ivBytes, authTagBytes, encryptedPlaintextBytes, concattedBytes, algo, decrypted, decoder, err;
                                    return (0, $eha6O.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    crypto.subtle.importKey("raw", (0, $lBX3m.hexStringToUint8Array)(secret), {
                                                        name: "aes-gcm"
                                                    }, false, [
                                                        "encrypt",
                                                        "decrypt"
                                                    ])
                                                ];
                                            case 1:
                                                secretKey = _state.sent();
                                                encrypted = (0, $lBX3m.hexStringToUint8Array)(cipherText);
                                                ivBytes = encrypted.slice(0, 12);
                                                authTagBytes = encrypted.slice(12, 28);
                                                encryptedPlaintextBytes = encrypted.slice(28);
                                                concattedBytes = new Uint8Array((0, $c6Xmf._)(encryptedPlaintextBytes).concat((0, $c6Xmf._)(authTagBytes)));
                                                algo = {
                                                    name: "AES-GCM",
                                                    iv: new Uint8Array(ivBytes)
                                                };
                                                _state.label = 2;
                                            case 2:
                                                _state.trys.push([
                                                    2,
                                                    4,
                                                    ,
                                                    5
                                                ]);
                                                return [
                                                    4,
                                                    window.crypto.subtle.decrypt(algo, secretKey, concattedBytes)
                                                ];
                                            case 3:
                                                decrypted = _state.sent();
                                                decoder = new TextDecoder();
                                                resolve(decoder.decode(decrypted));
                                                return [
                                                    3,
                                                    5
                                                ];
                                            case 4:
                                                err = _state.sent();
                                                reject(err);
                                                return [
                                                    3,
                                                    5
                                                ];
                                            case 5:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return WalletLinkCipher;
}();
module.exports.WalletLinkCipher = $85a93cace4eec7a7$var$WalletLinkCipher;

});

parcelRegister("9e6l6", function(module, exports) {

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $eha6O = parcelRequire("eha6O");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletLinkHTTP = void 0;
var $6b7a56bb5e5601cb$var$WalletLinkHTTP = /*#__PURE__*/ function() {
    function WalletLinkHTTP(linkAPIUrl, sessionId, sessionKey) {
        (0, $4GJKx._)(this, WalletLinkHTTP);
        this.linkAPIUrl = linkAPIUrl;
        this.sessionId = sessionId;
        var credentials = "".concat(sessionId, ":").concat(sessionKey);
        this.auth = "Basic ".concat(btoa(credentials));
    }
    (0, $1wc17._)(WalletLinkHTTP, [
        {
            key: "markUnseenEventsAsSeen",
            value: // mark unseen events as seen
            function markUnseenEventsAsSeen(events) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        return [
                            2,
                            Promise.all(events.map(function(e) {
                                return fetch("".concat(_this.linkAPIUrl, "/events/").concat(e.eventId, "/seen"), {
                                    method: "POST",
                                    headers: {
                                        Authorization: _this.auth
                                    }
                                });
                            })).catch(function(error) {
                                return console.error("Unabled to mark event as failed:", error);
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchUnseenEvents",
            value: function fetchUnseenEvents() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _a, response, _ref, events, error, responseEvents;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("".concat(_this.linkAPIUrl, "/events?unseen=true"), {
                                        headers: {
                                            Authorization: _this.auth
                                        }
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                _ref = _state.sent(), events = _ref.events, error = _ref.error;
                                if (error) throw new Error("Check unseen events failed: ".concat(error));
                                responseEvents = (_a = events === null || events === void 0 ? void 0 : events.filter(function(e) {
                                    return e.event === "Web3Response";
                                }).map(function(e) {
                                    return {
                                        type: "Event",
                                        sessionId: _this.sessionId,
                                        eventId: e.id,
                                        event: e.event,
                                        data: e.data
                                    };
                                })) !== null && _a !== void 0 ? _a : [];
                                _this.markUnseenEventsAsSeen(responseEvents);
                                return [
                                    2,
                                    responseEvents
                                ];
                            case 3:
                                throw new Error("Check unseen events failed: ".concat(response.status));
                        }
                    });
                })();
            }
        }
    ]);
    return WalletLinkHTTP;
}();
module.exports.WalletLinkHTTP = $6b7a56bb5e5601cb$var$WalletLinkHTTP;

});

parcelRegister("3MVC0", function(module, exports) {

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");
"use strict";
// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletLinkWebSocket = module.exports.ConnectionState = void 0;
var $2c228b5186683de6$var$ConnectionState;
(function(ConnectionState) {
    ConnectionState[ConnectionState["DISCONNECTED"] = 0] = "DISCONNECTED";
    ConnectionState[ConnectionState["CONNECTING"] = 1] = "CONNECTING";
    ConnectionState[ConnectionState["CONNECTED"] = 2] = "CONNECTED";
})($2c228b5186683de6$var$ConnectionState || (module.exports.ConnectionState = $2c228b5186683de6$var$ConnectionState = {}));
var $2c228b5186683de6$var$WalletLinkWebSocket = /*#__PURE__*/ function() {
    function WalletLinkWebSocket(url) {
        var WebSocketClass = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : WebSocket;
        (0, $4GJKx._)(this, WalletLinkWebSocket);
        this.WebSocketClass = WebSocketClass;
        this.webSocket = null;
        this.pendingData = [];
        this.url = url.replace(/^http/, "ws");
    }
    (0, $1wc17._)(WalletLinkWebSocket, [
        {
            key: "setConnectionStateListener",
            value: function setConnectionStateListener(listener) {
                this.connectionStateListener = listener;
            }
        },
        {
            key: "setIncomingDataListener",
            value: function setIncomingDataListener(listener) {
                this.incomingDataListener = listener;
            }
        },
        {
            key: "connect",
            value: /**
     * Make a websocket connection
     * @returns a Promise that resolves when connected
     */ function connect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        if (_this.webSocket) throw new Error("webSocket object is not null");
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var _a;
                                var webSocket;
                                try {
                                    _this.webSocket = webSocket = new _this.WebSocketClass(_this.url);
                                } catch (err) {
                                    reject(err);
                                    return;
                                }
                                (_a = _this.connectionStateListener) === null || _a === void 0 || _a.call(_this, $2c228b5186683de6$var$ConnectionState.CONNECTING);
                                webSocket.onclose = function(evt) {
                                    var _a;
                                    _this.clearWebSocket();
                                    reject(new Error("websocket error ".concat(evt.code, ": ").concat(evt.reason)));
                                    (_a = _this.connectionStateListener) === null || _a === void 0 || _a.call(_this, $2c228b5186683de6$var$ConnectionState.DISCONNECTED);
                                };
                                webSocket.onopen = function(_) {
                                    var _a;
                                    resolve();
                                    (_a = _this.connectionStateListener) === null || _a === void 0 || _a.call(_this, $2c228b5186683de6$var$ConnectionState.CONNECTED);
                                    if (_this.pendingData.length > 0) {
                                        var pending = (0, $c6Xmf._)(_this.pendingData);
                                        pending.forEach(function(data) {
                                            return _this.sendData(data);
                                        });
                                        _this.pendingData = [];
                                    }
                                };
                                webSocket.onmessage = function(evt) {
                                    var _a, _b;
                                    if (evt.data === "h") (_a = _this.incomingDataListener) === null || _a === void 0 || _a.call(_this, {
                                        type: "Heartbeat"
                                    });
                                    else try {
                                        var message = JSON.parse(evt.data);
                                        (_b = _this.incomingDataListener) === null || _b === void 0 || _b.call(_this, message);
                                    } catch (_c) {
                                    /* empty */ }
                                };
                            })
                        ];
                    });
                })();
            }
        },
        {
            /**
     * Disconnect from server
     */ key: "disconnect",
            value: function disconnect() {
                var _a;
                var webSocket = this.webSocket;
                if (!webSocket) return;
                this.clearWebSocket();
                (_a = this.connectionStateListener) === null || _a === void 0 || _a.call(this, $2c228b5186683de6$var$ConnectionState.DISCONNECTED);
                this.connectionStateListener = undefined;
                this.incomingDataListener = undefined;
                try {
                    webSocket.close();
                } catch (_b) {
                // noop
                }
            }
        },
        {
            /**
     * Send data to server
     * @param data text to send
     */ key: "sendData",
            value: function sendData(data) {
                var webSocket = this.webSocket;
                if (!webSocket) {
                    this.pendingData.push(data);
                    this.connect();
                    return;
                }
                webSocket.send(data);
            }
        },
        {
            key: "clearWebSocket",
            value: function clearWebSocket() {
                var webSocket = this.webSocket;
                if (!webSocket) return;
                this.webSocket = null;
                webSocket.onclose = null;
                webSocket.onerror = null;
                webSocket.onmessage = null;
                webSocket.onopen = null;
            }
        }
    ]);
    return WalletLinkWebSocket;
}();
module.exports.WalletLinkWebSocket = $2c228b5186683de6$var$WalletLinkWebSocket;

});


parcelRegister("8l7I1", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
"use strict";
// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletLinkSession = void 0;

var $2K8vW = parcelRequire("2K8vW");

var $lBX3m = parcelRequire("lBX3m");
var $612643c5688cdd14$var$STORAGE_KEY_SESSION_ID = "session:id";
var $612643c5688cdd14$var$STORAGE_KEY_SESSION_SECRET = "session:secret";
var $612643c5688cdd14$var$STORAGE_KEY_SESSION_LINKED = "session:linked";
var $612643c5688cdd14$var$WalletLinkSession = /*#__PURE__*/ function() {
    function WalletLinkSession(storage, id, secret, linked) {
        (0, $4GJKx._)(this, WalletLinkSession);
        this._storage = storage;
        this._id = id || (0, $lBX3m.randomBytesHex)(16);
        this._secret = secret || (0, $lBX3m.randomBytesHex)(32);
        this._key = new $2K8vW.sha256().update("".concat(this._id, ", ").concat(this._secret, " WalletLink")) // ensure old sessions stay connected
        .digest("hex");
        this._linked = !!linked;
    }
    (0, $1wc17._)(WalletLinkSession, [
        {
            key: "id",
            get: function get() {
                return this._id;
            }
        },
        {
            key: "secret",
            get: function get() {
                return this._secret;
            }
        },
        {
            key: "key",
            get: function get() {
                return this._key;
            }
        },
        {
            key: "linked",
            get: function get() {
                return this._linked;
            },
            set: function set(val) {
                this._linked = val;
                this.persistLinked();
            }
        },
        {
            key: "save",
            value: function save() {
                this._storage.setItem($612643c5688cdd14$var$STORAGE_KEY_SESSION_ID, this._id);
                this._storage.setItem($612643c5688cdd14$var$STORAGE_KEY_SESSION_SECRET, this._secret);
                this.persistLinked();
                return this;
            }
        },
        {
            key: "persistLinked",
            value: function persistLinked() {
                this._storage.setItem($612643c5688cdd14$var$STORAGE_KEY_SESSION_LINKED, this._linked ? "1" : "0");
            }
        }
    ], [
        {
            key: "load",
            value: function load(storage) {
                var id = storage.getItem($612643c5688cdd14$var$STORAGE_KEY_SESSION_ID);
                var linked = storage.getItem($612643c5688cdd14$var$STORAGE_KEY_SESSION_LINKED);
                var secret = storage.getItem($612643c5688cdd14$var$STORAGE_KEY_SESSION_SECRET);
                if (id && secret) return new WalletLinkSession(storage, id, secret, linked === "1");
                return null;
            }
        }
    ]);
    return WalletLinkSession;
}();
module.exports.WalletLinkSession = $612643c5688cdd14$var$WalletLinkSession;

});

parcelRegister("5XDHL", function(module, exports) {

var $3sHb8 = parcelRequire("3sHb8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isDarkMode = module.exports.isMobileWeb = module.exports.getLocation = module.exports.createQrUrl = void 0;
function $45714301983389bf$var$createQrUrl(sessionId, sessionSecret, serverUrl, isParentConnection, version, chainId) {
    var sessionIdKey = isParentConnection ? "parent-id" : "id";
    var _obj;
    var query = new URLSearchParams((_obj = {}, (0, $3sHb8._)(_obj, sessionIdKey, sessionId), (0, $3sHb8._)(_obj, "secret", sessionSecret), (0, $3sHb8._)(_obj, "server", serverUrl), (0, $3sHb8._)(_obj, "v", version), (0, $3sHb8._)(_obj, "chainId", chainId.toString()), _obj)).toString();
    var qrUrl = "".concat(serverUrl, "/#/link?").concat(query);
    return qrUrl;
}
module.exports.createQrUrl = $45714301983389bf$var$createQrUrl;
function $45714301983389bf$var$isInIFrame() {
    try {
        return window.frameElement !== null;
    } catch (e) {
        return false;
    }
}
function $45714301983389bf$var$getLocation() {
    try {
        if ($45714301983389bf$var$isInIFrame() && window.top) return window.top.location;
        return window.location;
    } catch (e) {
        return window.location;
    }
}
module.exports.getLocation = $45714301983389bf$var$getLocation;
function $45714301983389bf$var$isMobileWeb() {
    var _a;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent);
}
module.exports.isMobileWeb = $45714301983389bf$var$isMobileWeb;
function $45714301983389bf$var$isDarkMode() {
    var _a, _b;
    return (_b = (_a = window === null || window === void 0 ? void 0 : window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, "(prefers-color-scheme: dark)").matches) !== null && _b !== void 0 ? _b : false;
}
module.exports.isDarkMode = $45714301983389bf$var$isDarkMode;

});

parcelRegister("2dFjj", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletLinkRelayUI = void 0;

var $ltRCg = parcelRequire("ltRCg");

var $dm3GT = parcelRequire("dm3GT");
var $19dcd7123c430076$var$WalletLinkRelayUI = /*#__PURE__*/ function() {
    function WalletLinkRelayUI() {
        (0, $4GJKx._)(this, WalletLinkRelayUI);
        this.attached = false;
        this.snackbar = new $dm3GT.Snackbar();
    }
    (0, $1wc17._)(WalletLinkRelayUI, [
        {
            key: "attach",
            value: function attach() {
                if (this.attached) throw new Error("Coinbase Wallet SDK UI is already attached");
                var el = document.documentElement;
                var container = document.createElement("div");
                container.className = "-cbwsdk-css-reset";
                el.appendChild(container);
                this.snackbar.attach(container);
                this.attached = true;
                (0, $ltRCg.injectCssReset)();
            }
        },
        {
            key: "showConnecting",
            value: function showConnecting(options) {
                var snackbarProps;
                if (options.isUnlinkedErrorState) snackbarProps = {
                    autoExpand: true,
                    message: "Connection lost",
                    menuItems: [
                        {
                            isRed: false,
                            info: "Reset connection",
                            svgWidth: "10",
                            svgHeight: "11",
                            path: "M5.00008 0.96875C6.73133 0.96875 8.23758 1.94375 9.00008 3.375L10.0001 2.375V5.5H9.53133H7.96883H6.87508L7.80633 4.56875C7.41258 3.3875 6.31258 2.53125 5.00008 2.53125C3.76258 2.53125 2.70633 3.2875 2.25633 4.36875L0.812576 3.76875C1.50008 2.125 3.11258 0.96875 5.00008 0.96875ZM2.19375 6.43125C2.5875 7.6125 3.6875 8.46875 5 8.46875C6.2375 8.46875 7.29375 7.7125 7.74375 6.63125L9.1875 7.23125C8.5 8.875 6.8875 10.0312 5 10.0312C3.26875 10.0312 1.7625 9.05625 1 7.625L0 8.625V5.5H0.46875H2.03125H3.125L2.19375 6.43125Z",
                            defaultFillRule: "evenodd",
                            defaultClipRule: "evenodd",
                            onClick: options.onResetConnection
                        }
                    ]
                };
                else snackbarProps = {
                    message: "Confirm on phone",
                    menuItems: [
                        {
                            isRed: true,
                            info: "Cancel transaction",
                            svgWidth: "11",
                            svgHeight: "11",
                            path: "M10.3711 1.52346L9.21775 0.370117L5.37109 4.21022L1.52444 0.370117L0.371094 1.52346L4.2112 5.37012L0.371094 9.21677L1.52444 10.3701L5.37109 6.53001L9.21775 10.3701L10.3711 9.21677L6.53099 5.37012L10.3711 1.52346Z",
                            defaultFillRule: "inherit",
                            defaultClipRule: "inherit",
                            onClick: options.onCancel
                        },
                        {
                            isRed: false,
                            info: "Reset connection",
                            svgWidth: "10",
                            svgHeight: "11",
                            path: "M5.00008 0.96875C6.73133 0.96875 8.23758 1.94375 9.00008 3.375L10.0001 2.375V5.5H9.53133H7.96883H6.87508L7.80633 4.56875C7.41258 3.3875 6.31258 2.53125 5.00008 2.53125C3.76258 2.53125 2.70633 3.2875 2.25633 4.36875L0.812576 3.76875C1.50008 2.125 3.11258 0.96875 5.00008 0.96875ZM2.19375 6.43125C2.5875 7.6125 3.6875 8.46875 5 8.46875C6.2375 8.46875 7.29375 7.7125 7.74375 6.63125L9.1875 7.23125C8.5 8.875 6.8875 10.0312 5 10.0312C3.26875 10.0312 1.7625 9.05625 1 7.625L0 8.625V5.5H0.46875H2.03125H3.125L2.19375 6.43125Z",
                            defaultFillRule: "evenodd",
                            defaultClipRule: "evenodd",
                            onClick: options.onResetConnection
                        }
                    ]
                };
                return this.snackbar.presentItem(snackbarProps);
            }
        }
    ]);
    return WalletLinkRelayUI;
}();
module.exports.WalletLinkRelayUI = $19dcd7123c430076$var$WalletLinkRelayUI;

});
parcelRegister("ltRCg", function(module, exports) {
"use strict";
// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
var $fa35e57273a6d3b6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.injectCssReset = void 0;

var $fa35e57273a6d3b6$var$cssReset_css_1 = $fa35e57273a6d3b6$var$__importDefault((parcelRequire("gZcCR")));
function $fa35e57273a6d3b6$var$injectCssReset() {
    var styleEl = document.createElement("style");
    styleEl.type = "text/css";
    styleEl.appendChild(document.createTextNode($fa35e57273a6d3b6$var$cssReset_css_1.default));
    document.documentElement.appendChild(styleEl);
}
module.exports.injectCssReset = $fa35e57273a6d3b6$var$injectCssReset;

});
parcelRegister("gZcCR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function() {
    return '@namespace svg "http://www.w3.org/2000/svg";.-cbwsdk-css-reset,.-cbwsdk-css-reset *{animation:none;animation-delay:0;animation-direction:normal;animation-duration:0;animation-fill-mode:none;animation-iteration-count:1;animation-name:none;animation-play-state:running;animation-timing-function:ease;backface-visibility:visible;background:0;background-attachment:scroll;background-clip:border-box;background-color:rgba(0,0,0,0);background-image:none;background-origin:padding-box;background-position:0 0;background-position-x:0;background-position-y:0;background-repeat:repeat;background-size:auto auto;border:0;border-style:none;border-width:medium;border-color:inherit;border-bottom:0;border-bottom-color:inherit;border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom-style:none;border-bottom-width:medium;border-collapse:separate;border-image:none;border-left:0;border-left-color:inherit;border-left-style:none;border-left-width:medium;border-radius:0;border-right:0;border-right-color:inherit;border-right-style:none;border-right-width:medium;border-spacing:0;border-top:0;border-top-color:inherit;border-top-left-radius:0;border-top-right-radius:0;border-top-style:none;border-top-width:medium;box-shadow:none;box-sizing:border-box;caption-side:top;clear:none;clip:auto;color:inherit;columns:auto;column-count:auto;column-fill:balance;column-gap:normal;column-rule:medium none currentColor;column-rule-color:currentColor;column-rule-style:none;column-rule-width:none;column-span:1;column-width:auto;counter-increment:none;counter-reset:none;direction:ltr;empty-cells:show;float:none;font:normal;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,sans-serif;font-size:medium;font-style:normal;font-variant:normal;font-weight:normal;height:auto;hyphens:none;letter-spacing:normal;line-height:normal;list-style:none;list-style-image:none;list-style-position:outside;list-style-type:disc;margin:0;margin-bottom:0;margin-left:0;margin-right:0;margin-top:0;opacity:1;orphans:0;outline:0;outline-color:invert;outline-style:none;outline-width:medium;overflow:visible;overflow-x:visible;overflow-y:visible;padding:0;padding-bottom:0;padding-left:0;padding-right:0;padding-top:0;page-break-after:auto;page-break-before:auto;page-break-inside:auto;perspective:none;perspective-origin:50% 50%;pointer-events:auto;position:static;quotes:"\\201C" "\\201D" "\\2018" "\\2019";tab-size:8;table-layout:auto;text-align:inherit;text-align-last:auto;text-decoration:none;text-decoration-color:inherit;text-decoration-line:none;text-decoration-style:solid;text-indent:0;text-shadow:none;text-transform:none;transform:none;transform-style:flat;transition:none;transition-delay:0s;transition-duration:0s;transition-property:none;transition-timing-function:ease;unicode-bidi:normal;vertical-align:baseline;visibility:visible;white-space:normal;widows:0;word-spacing:normal;z-index:auto}.-cbwsdk-css-reset strong{font-weight:bold}.-cbwsdk-css-reset *{box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,sans-serif;line-height:1}.-cbwsdk-css-reset [class*=container]{margin:0;padding:0}.-cbwsdk-css-reset style{display:none}';
}();

});


parcelRegister("dm3GT", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $cv9Rk = parcelRequire("cv9Rk");
"use strict";
// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
var $9b90315d2d096eab$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SnackbarInstance = module.exports.SnackbarContainer = module.exports.Snackbar = void 0;

var $9b90315d2d096eab$var$clsx_1 = $9b90315d2d096eab$var$__importDefault((parcelRequire("jaS5E")));

var $l73Pe = parcelRequire("l73Pe");

var $ax3dm = parcelRequire("ax3dm");

var $5XDHL = parcelRequire("5XDHL");

var $9b90315d2d096eab$var$Snackbar_css_1 = $9b90315d2d096eab$var$__importDefault((parcelRequire("53ROB")));
var $9b90315d2d096eab$var$cblogo = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEuNDkyIDEwLjQxOWE4LjkzIDguOTMgMCAwMTguOTMtOC45M2gxMS4xNjNhOC45MyA4LjkzIDAgMDE4LjkzIDguOTN2MTEuMTYzYTguOTMgOC45MyAwIDAxLTguOTMgOC45M0gxMC40MjJhOC45MyA4LjkzIDAgMDEtOC45My04LjkzVjEwLjQxOXoiIGZpbGw9IiMxNjUyRjAiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwLjQxOSAwSDIxLjU4QzI3LjMzNSAwIDMyIDQuNjY1IDMyIDEwLjQxOVYyMS41OEMzMiAyNy4zMzUgMjcuMzM1IDMyIDIxLjU4MSAzMkgxMC40MkM0LjY2NSAzMiAwIDI3LjMzNSAwIDIxLjU4MVYxMC40MkMwIDQuNjY1IDQuNjY1IDAgMTAuNDE5IDB6bTAgMS40ODhhOC45MyA4LjkzIDAgMDAtOC45MyA4LjkzdjExLjE2M2E4LjkzIDguOTMgMCAwMDguOTMgOC45M0gyMS41OGE4LjkzIDguOTMgMCAwMDguOTMtOC45M1YxMC40MmE4LjkzIDguOTMgMCAwMC04LjkzLTguOTNIMTAuNDJ6IiBmaWxsPSIjZmZmIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS45OTggMjYuMDQ5Yy01LjU0OSAwLTEwLjA0Ny00LjQ5OC0xMC4wNDctMTAuMDQ3IDAtNS41NDggNC40OTgtMTAuMDQ2IDEwLjA0Ny0xMC4wNDYgNS41NDggMCAxMC4wNDYgNC40OTggMTAuMDQ2IDEwLjA0NiAwIDUuNTQ5LTQuNDk4IDEwLjA0Ny0xMC4wNDYgMTAuMDQ3eiIgZmlsbD0iI2ZmZiIvPjxwYXRoIGQ9Ik0xMi43NjIgMTQuMjU0YzAtLjgyMi42NjctMS40ODkgMS40ODktMS40ODloMy40OTdjLjgyMiAwIDEuNDg4LjY2NiAxLjQ4OCAxLjQ4OXYzLjQ5N2MwIC44MjItLjY2NiAxLjQ4OC0xLjQ4OCAxLjQ4OGgtMy40OTdhMS40ODggMS40ODggMCAwMS0xLjQ4OS0xLjQ4OHYtMy40OTh6IiBmaWxsPSIjMTY1MkYwIi8+PC9zdmc+";
var $9b90315d2d096eab$var$gearIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEyIDYuNzV2LTEuNWwtMS43Mi0uNTdjLS4wOC0uMjctLjE5LS41Mi0uMzItLjc3bC44MS0xLjYyLTEuMDYtMS4wNi0xLjYyLjgxYy0uMjQtLjEzLS41LS4yNC0uNzctLjMyTDYuNzUgMGgtMS41bC0uNTcgMS43MmMtLjI3LjA4LS41My4xOS0uNzcuMzJsLTEuNjItLjgxLTEuMDYgMS4wNi44MSAxLjYyYy0uMTMuMjQtLjI0LjUtLjMyLjc3TDAgNS4yNXYxLjVsMS43Mi41N2MuMDguMjcuMTkuNTMuMzIuNzdsLS44MSAxLjYyIDEuMDYgMS4wNiAxLjYyLS44MWMuMjQuMTMuNS4yMy43Ny4zMkw1LjI1IDEyaDEuNWwuNTctMS43MmMuMjctLjA4LjUyLS4xOS43Ny0uMzJsMS42Mi44MSAxLjA2LTEuMDYtLjgxLTEuNjJjLjEzLS4yNC4yMy0uNS4zMi0uNzdMMTIgNi43NXpNNiA4LjVhMi41IDIuNSAwIDAxMC01IDIuNSAyLjUgMCAwMTAgNXoiIGZpbGw9IiMwNTBGMTkiLz48L3N2Zz4=";
var $9b90315d2d096eab$var$Snackbar = /*#__PURE__*/ function() {
    function Snackbar() {
        (0, $4GJKx._)(this, Snackbar);
        this.items = new Map();
        this.nextItemKey = 0;
        this.root = null;
        this.darkMode = (0, $5XDHL.isDarkMode)();
    }
    (0, $1wc17._)(Snackbar, [
        {
            key: "attach",
            value: function attach(el) {
                this.root = document.createElement("div");
                this.root.className = "-cbwsdk-snackbar-root";
                el.appendChild(this.root);
                this.render();
            }
        },
        {
            key: "presentItem",
            value: function presentItem(itemProps) {
                var _this = this;
                var key = this.nextItemKey++;
                this.items.set(key, itemProps);
                this.render();
                return function() {
                    _this.items.delete(key);
                    _this.render();
                };
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.items.clear();
                this.render();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!this.root) return;
                (0, $l73Pe.render)((0, $l73Pe.h)("div", null, (0, $l73Pe.h)(module.exports.SnackbarContainer, {
                    darkMode: this.darkMode
                }, Array.from(this.items.entries()).map(function(param) {
                    var _param = (0, $cv9Rk._)(param, 2), key = _param[0], itemProps = _param[1];
                    return (0, $l73Pe.h)(module.exports.SnackbarInstance, Object.assign({}, itemProps, {
                        key: key
                    }));
                }))), this.root);
            }
        }
    ]);
    return Snackbar;
}();
module.exports.Snackbar = $9b90315d2d096eab$var$Snackbar;
var $9b90315d2d096eab$var$SnackbarContainer = function(props) {
    return (0, $l73Pe.h)("div", {
        class: (0, $9b90315d2d096eab$var$clsx_1.default)("-cbwsdk-snackbar-container")
    }, (0, $l73Pe.h)("style", null, $9b90315d2d096eab$var$Snackbar_css_1.default), (0, $l73Pe.h)("div", {
        class: "-cbwsdk-snackbar"
    }, props.children));
};
module.exports.SnackbarContainer = $9b90315d2d096eab$var$SnackbarContainer;
var $9b90315d2d096eab$var$SnackbarInstance = function(param) {
    var autoExpand = param.autoExpand, message = param.message, menuItems = param.menuItems;
    var _ref = (0, $cv9Rk._)((0, $ax3dm.useState)(true), 2), hidden = _ref[0], setHidden = _ref[1];
    var _ref1 = (0, $cv9Rk._)((0, $ax3dm.useState)(autoExpand !== null && autoExpand !== void 0 ? autoExpand : false), 2), expanded = _ref1[0], setExpanded = _ref1[1];
    (0, $ax3dm.useEffect)(function() {
        var timers = [
            window.setTimeout(function() {
                setHidden(false);
            }, 1),
            window.setTimeout(function() {
                setExpanded(true);
            }, 10000)
        ];
        return function() {
            timers.forEach(window.clearTimeout);
        };
    });
    var toggleExpanded = function() {
        setExpanded(!expanded);
    };
    return (0, $l73Pe.h)("div", {
        class: (0, $9b90315d2d096eab$var$clsx_1.default)("-cbwsdk-snackbar-instance", hidden && "-cbwsdk-snackbar-instance-hidden", expanded && "-cbwsdk-snackbar-instance-expanded")
    }, (0, $l73Pe.h)("div", {
        class: "-cbwsdk-snackbar-instance-header",
        onClick: toggleExpanded
    }, (0, $l73Pe.h)("img", {
        src: $9b90315d2d096eab$var$cblogo,
        class: "-cbwsdk-snackbar-instance-header-cblogo"
    }), " ", (0, $l73Pe.h)("div", {
        class: "-cbwsdk-snackbar-instance-header-message"
    }, message), (0, $l73Pe.h)("div", {
        class: "-gear-container"
    }, !expanded && (0, $l73Pe.h)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, $l73Pe.h)("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        fill: "#F5F7F8"
    })), (0, $l73Pe.h)("img", {
        src: $9b90315d2d096eab$var$gearIcon,
        class: "-gear-icon",
        title: "Expand"
    }))), menuItems && menuItems.length > 0 && (0, $l73Pe.h)("div", {
        class: "-cbwsdk-snackbar-instance-menu"
    }, menuItems.map(function(action, i) {
        return (0, $l73Pe.h)("div", {
            class: (0, $9b90315d2d096eab$var$clsx_1.default)("-cbwsdk-snackbar-instance-menu-item", action.isRed && "-cbwsdk-snackbar-instance-menu-item-is-red"),
            onClick: action.onClick,
            key: i
        }, (0, $l73Pe.h)("svg", {
            width: action.svgWidth,
            height: action.svgHeight,
            viewBox: "0 0 10 11",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $l73Pe.h)("path", {
            "fill-rule": action.defaultFillRule,
            "clip-rule": action.defaultClipRule,
            d: action.path,
            fill: "#AAAAAA"
        })), (0, $l73Pe.h)("span", {
            class: (0, $9b90315d2d096eab$var$clsx_1.default)("-cbwsdk-snackbar-instance-menu-item-info", action.isRed && "-cbwsdk-snackbar-instance-menu-item-info-is-red")
        }, action.info));
    })));
};
module.exports.SnackbarInstance = $9b90315d2d096eab$var$SnackbarInstance;

});
parcelRegister("53ROB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function() {
    return ".-cbwsdk-css-reset .-gear-container{margin-left:16px !important;margin-right:9px !important;display:flex;align-items:center;justify-content:center;width:24px;height:24px;transition:opacity .25s}.-cbwsdk-css-reset .-gear-container *{user-select:none}.-cbwsdk-css-reset .-gear-container svg{opacity:0;position:absolute}.-cbwsdk-css-reset .-gear-icon{height:12px;width:12px;z-index:10000}.-cbwsdk-css-reset .-cbwsdk-snackbar{align-items:flex-end;display:flex;flex-direction:column;position:fixed;right:0;top:0;z-index:2147483647}.-cbwsdk-css-reset .-cbwsdk-snackbar *{user-select:none}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance{display:flex;flex-direction:column;margin:8px 16px 0 16px;overflow:visible;text-align:left;transform:translateX(0);transition:opacity .25s,transform .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header:hover .-gear-container svg{opacity:1}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header{display:flex;align-items:center;background:#fff;overflow:hidden;border:1px solid #e7ebee;box-sizing:border-box;border-radius:8px;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header-cblogo{margin:8px 8px 8px 8px}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header *{cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header-message{color:#000;font-size:13px;line-height:1.5;user-select:none}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu{background:#fff;transition:opacity .25s ease-in-out,transform .25s linear,visibility 0s;visibility:hidden;border:1px solid #e7ebee;box-sizing:border-box;border-radius:8px;opacity:0;flex-direction:column;padding-left:8px;padding-right:8px}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:last-child{margin-bottom:8px !important}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover{background:#f5f7f8;border-radius:6px;transition:background .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover span{color:#050f19;transition:color .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover svg path{fill:#000;transition:fill .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item{visibility:inherit;height:35px;margin-top:8px;margin-bottom:0;display:flex;flex-direction:row;align-items:center;padding:8px;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item *{visibility:inherit;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover{background:rgba(223,95,103,.2);transition:background .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover *{cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover svg path{fill:#df5f67;transition:fill .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover span{color:#df5f67;transition:color .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-info{color:#aaa;font-size:13px;margin:0 8px 0 32px;position:absolute}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-hidden{opacity:0;text-align:left;transform:translateX(25%);transition:opacity .5s linear}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-expanded .-cbwsdk-snackbar-instance-menu{opacity:1;display:flex;transform:translateY(8px);visibility:visible}";
}();

});



parcelRegister("ir4DJ", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WLMobileRelayUI = void 0;

var $j96xY = parcelRequire("j96xY");

var $5XDHL = parcelRequire("5XDHL");

var $aulvc = parcelRequire("aulvc");
var $d6be58f67b7a70c7$var$WLMobileRelayUI = /*#__PURE__*/ function() {
    function WLMobileRelayUI() {
        (0, $4GJKx._)(this, WLMobileRelayUI);
        this.attached = false;
        this.redirectDialog = new $j96xY.RedirectDialog();
    }
    (0, $1wc17._)(WLMobileRelayUI, [
        {
            key: "attach",
            value: function attach() {
                if (this.attached) throw new Error("Coinbase Wallet SDK UI is already attached");
                this.redirectDialog.attach();
                this.attached = true;
            }
        },
        {
            key: "redirectToCoinbaseWallet",
            value: function redirectToCoinbaseWallet(walletLinkUrl) {
                var url = new URL($aulvc.CBW_MOBILE_DEEPLINK_URL);
                url.searchParams.append("redirect_url", (0, $5XDHL.getLocation)().href);
                if (walletLinkUrl) url.searchParams.append("wl_url", walletLinkUrl);
                var anchorTag = document.createElement("a");
                anchorTag.target = "cbw-opener";
                anchorTag.href = url.href;
                anchorTag.rel = "noreferrer noopener";
                anchorTag.click();
            }
        },
        {
            key: "openCoinbaseWalletDeeplink",
            value: function openCoinbaseWalletDeeplink(walletLinkUrl) {
                var _this = this;
                this.redirectDialog.present({
                    title: "Redirecting to Coinbase Wallet...",
                    buttonText: "Open",
                    onButtonClick: function() {
                        _this.redirectToCoinbaseWallet(walletLinkUrl);
                    }
                });
                setTimeout(function() {
                    _this.redirectToCoinbaseWallet(walletLinkUrl);
                }, 99);
            }
        },
        {
            key: "showConnecting",
            value: function showConnecting(_options) {
                var _this = this;
                // it uses the return callback to clear the dialog
                return function() {
                    _this.redirectDialog.clear();
                };
            }
        }
    ]);
    return WLMobileRelayUI;
}();
module.exports.WLMobileRelayUI = $d6be58f67b7a70c7$var$WLMobileRelayUI;

});
parcelRegister("j96xY", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
"use strict";
var $df03efaaee246892$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RedirectDialog = void 0;

var $df03efaaee246892$var$clsx_1 = $df03efaaee246892$var$__importDefault((parcelRequire("jaS5E")));

var $l73Pe = parcelRequire("l73Pe");

var $ltRCg = parcelRequire("ltRCg");

var $dm3GT = parcelRequire("dm3GT");

var $5XDHL = parcelRequire("5XDHL");

var $df03efaaee246892$var$RedirectDialog_css_1 = $df03efaaee246892$var$__importDefault((parcelRequire("h1mIt")));
var $df03efaaee246892$var$RedirectDialog = /*#__PURE__*/ function() {
    function RedirectDialog() {
        (0, $4GJKx._)(this, RedirectDialog);
        this.root = null;
        this.darkMode = (0, $5XDHL.isDarkMode)();
    }
    (0, $1wc17._)(RedirectDialog, [
        {
            key: "attach",
            value: function attach() {
                var el = document.documentElement;
                this.root = document.createElement("div");
                this.root.className = "-cbwsdk-css-reset";
                el.appendChild(this.root);
                (0, $ltRCg.injectCssReset)();
            }
        },
        {
            key: "present",
            value: function present(props) {
                this.render(props);
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.render(null);
            }
        },
        {
            key: "render",
            value: function render(props) {
                var _this = this;
                if (!this.root) return;
                (0, $l73Pe.render)(null, this.root);
                if (!props) return;
                (0, $l73Pe.render)((0, $l73Pe.h)($df03efaaee246892$var$RedirectDialogContent, Object.assign({}, props, {
                    onDismiss: function() {
                        _this.clear();
                    },
                    darkMode: this.darkMode
                })), this.root);
            }
        }
    ]);
    return RedirectDialog;
}();
module.exports.RedirectDialog = $df03efaaee246892$var$RedirectDialog;
var $df03efaaee246892$var$RedirectDialogContent = function(param) {
    var title = param.title, buttonText = param.buttonText, darkMode = param.darkMode, onButtonClick = param.onButtonClick, onDismiss = param.onDismiss;
    var theme = darkMode ? "dark" : "light";
    return (0, $l73Pe.h)($dm3GT.SnackbarContainer, {
        darkMode: darkMode
    }, (0, $l73Pe.h)("div", {
        class: "-cbwsdk-redirect-dialog"
    }, (0, $l73Pe.h)("style", null, $df03efaaee246892$var$RedirectDialog_css_1.default), (0, $l73Pe.h)("div", {
        class: "-cbwsdk-redirect-dialog-backdrop",
        onClick: onDismiss
    }), (0, $l73Pe.h)("div", {
        class: (0, $df03efaaee246892$var$clsx_1.default)("-cbwsdk-redirect-dialog-box", theme)
    }, (0, $l73Pe.h)("p", null, title), (0, $l73Pe.h)("button", {
        onClick: onButtonClick
    }, buttonText))));
};

});
parcelRegister("h1mIt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function() {
    return ".-cbwsdk-css-reset .-cbwsdk-redirect-dialog-backdrop{position:fixed;top:0;left:0;right:0;bottom:0;transition:opacity .25s;background-color:rgba(10,11,13,.5)}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-backdrop-hidden{opacity:0}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box{display:block;position:fixed;top:50%;left:50%;transform:translate(-50%, -50%);padding:20px;border-radius:8px;background-color:#fff;color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box p{display:block;font-weight:400;font-size:14px;line-height:20px;padding-bottom:12px;color:#5b636e}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box button{appearance:none;border:none;background:none;color:#0052ff;padding:0;text-decoration:none;display:block;font-weight:600;font-size:16px;line-height:24px}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box.dark{background-color:#0a0b0d;color:#fff}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box.dark button{color:#0052ff}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box.light{background-color:#fff;color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box.light button{color:#0052ff}";
}();

});


parcelRegister("aulvc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CBW_MOBILE_DEEPLINK_URL = module.exports.WALLETLINK_URL = module.exports.CB_KEYS_URL = void 0;
module.exports.CB_KEYS_URL = "https://keys.coinbase.com/connect";
module.exports.WALLETLINK_URL = "https://www.walletlink.org";
module.exports.CBW_MOBILE_DEEPLINK_URL = "https://go.cb-w.com/walletlink";

});




parcelRegister("4IUJI", function(module, exports) {

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkErrorForInvalidRequestArgs = module.exports.getCoinbaseInjectedProvider = module.exports.getCoinbaseInjectedSigner = module.exports.fetchRPCRequest = void 0;

var $exvkr = parcelRequire("exvkr");

var $gBAGR = parcelRequire("gBAGR");
function $3707482972f1aa6a$var$fetchRPCRequest(request, chain) {
    return $3707482972f1aa6a$var$_fetchRPCRequest.apply(this, arguments);
}
function $3707482972f1aa6a$var$_fetchRPCRequest() {
    $3707482972f1aa6a$var$_fetchRPCRequest = (0, $kSuI9._)(function(request, chain) {
        var requestBody, res, response;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!chain.rpcUrl) throw $gBAGR.standardErrors.rpc.internal("No RPC URL set for chain");
                    requestBody = Object.assign(Object.assign({}, request), {
                        jsonrpc: "2.0",
                        id: crypto.randomUUID()
                    });
                    return [
                        4,
                        window.fetch(chain.rpcUrl, {
                            method: "POST",
                            body: JSON.stringify(requestBody),
                            mode: "cors",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Cbw-Sdk-Version": $exvkr.LIB_VERSION
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        response.result
                    ];
            }
        });
    });
    return $3707482972f1aa6a$var$_fetchRPCRequest.apply(this, arguments);
}
module.exports.fetchRPCRequest = $3707482972f1aa6a$var$fetchRPCRequest;
function $3707482972f1aa6a$var$getCoinbaseInjectedSigner() {
    var window1 = globalThis;
    return window1.coinbaseWalletSigner;
}
module.exports.getCoinbaseInjectedSigner = $3707482972f1aa6a$var$getCoinbaseInjectedSigner;
function $3707482972f1aa6a$var$getCoinbaseInjectedLegacyProvider() {
    var window1 = globalThis;
    return window1.coinbaseWalletExtension;
}
function $3707482972f1aa6a$var$getInjectedEthereum() {
    var _a, _b;
    try {
        var window1 = globalThis;
        return (_a = window1.ethereum) !== null && _a !== void 0 ? _a : (_b = window1.top) === null || _b === void 0 ? void 0 : _b.ethereum;
    } catch (_c) {
        return undefined;
    }
}
function $3707482972f1aa6a$var$getCoinbaseInjectedProvider(param) {
    var metadata = param.metadata, preference = param.preference;
    var _a;
    if (preference.options !== "smartWalletOnly") {
        var signer = $3707482972f1aa6a$var$getCoinbaseInjectedSigner();
        if (signer) return undefined; // use signer instead
        var extension = $3707482972f1aa6a$var$getCoinbaseInjectedLegacyProvider();
        if (extension) {
            var appName = metadata.appName, appLogoUrl = metadata.appLogoUrl, appChainIds = metadata.appChainIds;
            (_a = extension.setAppInfo) === null || _a === void 0 || _a.call(extension, appName, appLogoUrl, appChainIds);
            return extension;
        }
    }
    var ethereum = $3707482972f1aa6a$var$getInjectedEthereum();
    if (ethereum === null || ethereum === void 0 ? void 0 : ethereum.isCoinbaseBrowser) return ethereum;
    return undefined;
}
module.exports.getCoinbaseInjectedProvider = $3707482972f1aa6a$var$getCoinbaseInjectedProvider;
/**
 * Validates the arguments for an invalid request and returns an error if any validation fails.
 * Valid request args are defined here: https://eips.ethereum.org/EIPS/eip-1193#request
 * @param args The request arguments to validate.
 * @returns An error object if the arguments are invalid, otherwise undefined.
 */ function $3707482972f1aa6a$var$checkErrorForInvalidRequestArgs(args) {
    if (!args || typeof args !== "object" || Array.isArray(args)) return $gBAGR.standardErrors.rpc.invalidParams({
        message: "Expected a single, non-array, object argument.",
        data: args
    });
    var method = args.method, params = args.params;
    if (typeof method !== "string" || method.length === 0) return $gBAGR.standardErrors.rpc.invalidParams({
        message: "'args.method' must be a non-empty string.",
        data: args
    });
    if (params !== undefined && !Array.isArray(params) && (typeof params !== "object" || params === null)) return $gBAGR.standardErrors.rpc.invalidParams({
        message: "'args.params' must be an object or array if provided.",
        data: args
    });
    return undefined;
}
module.exports.checkErrorForInvalidRequestArgs = $3707482972f1aa6a$var$checkErrorForInvalidRequestArgs;

});


parcelRegister("9Nfx7", function(module, exports) {

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $eha6O = parcelRequire("eha6O");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Communicator = void 0;

var $exvkr = parcelRequire("exvkr");

var $5EpBR = parcelRequire("5EpBR");

var $aulvc = parcelRequire("aulvc");

var $gBAGR = parcelRequire("gBAGR");
/**
 * Communicates with a popup window for Coinbase keys.coinbase.com (or another url)
 * to send and receive messages.
 *
 * This class is responsible for opening a popup window, posting messages to it,
 * and listening for responses.
 *
 * It also handles cleanup of event listeners and the popup window itself when necessary.
 */ var $7214bd3786026e10$var$Communicator = function Communicator() {
    var _this = this;
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $aulvc.CB_KEYS_URL;
    (0, $4GJKx._)(this, Communicator);
    this.popup = null;
    this.listeners = new Map();
    var _this1 = this;
    /**
         * Posts a message to the popup window
         */ this.postMessage = function() {
        var _ref = (0, $kSuI9._)(function(message) {
            var popup;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this1.waitForPopupLoaded()
                        ];
                    case 1:
                        popup = _state.sent();
                        popup.postMessage(message, _this1.url.origin);
                        return [
                            2
                        ];
                }
            });
        });
        return function(message) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this2 = this;
    /**
         * Posts a request to the popup window and waits for a response
         */ this.postRequestAndWaitForResponse = function() {
        var _ref = (0, $kSuI9._)(function(request) {
            var responsePromise;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        responsePromise = _this2.onMessage(function(param) {
                            var requestId = param.requestId;
                            return requestId === request.id;
                        });
                        _this2.postMessage(request);
                        return [
                            4,
                            responsePromise
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(request) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this3 = this;
    /**
         * Listens for messages from the popup window that match a given predicate.
         */ this.onMessage = function() {
        var _ref = (0, $kSuI9._)(function(predicate) {
            return (0, $eha6O.__generator)(this, function(_state) {
                return [
                    2,
                    new Promise(function(resolve, reject) {
                        var listener = function(event) {
                            if (event.origin !== _this3.url.origin) return; // origin validation
                            var message = event.data;
                            if (predicate(message)) {
                                resolve(message);
                                window.removeEventListener("message", listener);
                                _this3.listeners.delete(listener);
                            }
                        };
                        window.addEventListener("message", listener);
                        _this3.listeners.set(listener, {
                            reject: reject
                        });
                    })
                ];
            });
        });
        return function(predicate) {
            return _ref.apply(this, arguments);
        };
    }();
    /**
         * Closes the popup, rejects all requests and clears the listeners
         */ this.disconnect = function() {
        (0, $5EpBR.closePopup)(_this.popup);
        _this.popup = null;
        _this.listeners.forEach(function(param, listener) {
            var reject = param.reject;
            reject($gBAGR.standardErrors.provider.userRejectedRequest("Request rejected"));
            window.removeEventListener("message", listener);
        });
        _this.listeners.clear();
    };
    var _this4 = this;
    /**
         * Waits for the popup window to fully load and then sends a version message.
         */ this.waitForPopupLoaded = /*#__PURE__*/ (0, $kSuI9._)(function() {
        return (0, $eha6O.__generator)(this, function(_state) {
            if (_this4.popup && !_this4.popup.closed) {
                // In case the user un-focused the popup between requests, focus it again
                _this4.popup.focus();
                return [
                    2,
                    _this4.popup
                ];
            }
            _this4.popup = (0, $5EpBR.openPopup)(_this4.url);
            _this4.onMessage(function(param) {
                var event = param.event;
                return event === "PopupUnload";
            }).then(_this4.disconnect).catch(function() {});
            return [
                2,
                _this4.onMessage(function(param) {
                    var event = param.event;
                    return event === "PopupLoaded";
                }).then(function(message) {
                    _this4.postMessage({
                        requestId: message.id,
                        data: {
                            version: $exvkr.LIB_VERSION
                        }
                    });
                }).then(function() {
                    if (!_this4.popup) throw $gBAGR.standardErrors.rpc.internal();
                    return _this4.popup;
                })
            ];
        });
    });
    this.url = new URL(url);
};
module.exports.Communicator = $7214bd3786026e10$var$Communicator;

});
parcelRegister("5EpBR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.closePopup = module.exports.openPopup = void 0;

var $gBAGR = parcelRequire("gBAGR");
var $41d48dbd0086ef7e$var$POPUP_WIDTH = 420;
var $41d48dbd0086ef7e$var$POPUP_HEIGHT = 540;
// Window Management
function $41d48dbd0086ef7e$var$openPopup(url) {
    var left = (window.innerWidth - $41d48dbd0086ef7e$var$POPUP_WIDTH) / 2 + window.screenX;
    var top = (window.innerHeight - $41d48dbd0086ef7e$var$POPUP_HEIGHT) / 2 + window.screenY;
    var popup = window.open(url, "Smart Wallet", "width=".concat($41d48dbd0086ef7e$var$POPUP_WIDTH, ", height=").concat($41d48dbd0086ef7e$var$POPUP_HEIGHT, ", left=").concat(left, ", top=").concat(top));
    popup === null || popup === void 0 || popup.focus();
    if (!popup) throw $gBAGR.standardErrors.rpc.internal("Pop up window failed to open");
    return popup;
}
module.exports.openPopup = $41d48dbd0086ef7e$var$openPopup;
function $41d48dbd0086ef7e$var$closePopup(popup) {
    if (popup && !popup.closed) popup.close();
}
module.exports.closePopup = $41d48dbd0086ef7e$var$closePopup;

});


parcelRegister("fvyQt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.determineMethodCategory = void 0;
var $b4a4c7d93d65e09a$var$mapping = {
    handshake: [
        "eth_requestAccounts"
    ],
    sign: [
        "eth_ecRecover",
        "personal_sign",
        "personal_ecRecover",
        "eth_signTransaction",
        "eth_sendTransaction",
        "eth_signTypedData_v1",
        "eth_signTypedData_v3",
        "eth_signTypedData_v4",
        "eth_signTypedData",
        "wallet_addEthereumChain",
        "wallet_switchEthereumChain",
        "wallet_watchAsset",
        "wallet_getCapabilities",
        "wallet_sendCalls",
        "wallet_showCallsStatus"
    ],
    state: [
        // internal state
        "eth_chainId",
        "eth_accounts",
        "eth_coinbase",
        "net_version"
    ],
    deprecated: [
        "eth_sign",
        "eth_signTypedData_v2"
    ],
    unsupported: [
        "eth_subscribe",
        "eth_unsubscribe"
    ],
    fetch: []
};
function $b4a4c7d93d65e09a$var$determineMethodCategory(method) {
    for(var c in $b4a4c7d93d65e09a$var$mapping){
        var category = c;
        if ($b4a4c7d93d65e09a$var$mapping[category].includes(method)) return category;
    }
    return undefined;
}
module.exports.determineMethodCategory = $b4a4c7d93d65e09a$var$determineMethodCategory;

});




})();
//# sourceMappingURL=dist.95037bf1.js.map
